import { Component, ElementRef, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, ValidatorFn, Validators, FormControl } from '@angular/forms';
import { ICountry } from 'src/app/applicant/models';
import { ILookupCategory } from 'src/app/shared/models/lookup.model';
import { DocTemplateLogo, LookupCategory, MSAType, PaymentTerms, PaymentTerms_Default, PaymentTerms_Selected } from 'src/app/shared/enums/EnumsVMS';
import { SharedService } from 'src/app/shared/services';
import { VMSConstants } from 'src/app/shared/constants/vms-constants';
import { ActivatedRoute, Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { MessageService } from 'primeng/api';
import { RegisterService } from 'src/app/auth/services/register.service';
import { DialogService } from 'primeng/dynamicdialog';
import { DocViewerDialogComponent } from 'src/app/doc-viewer/doc-viewer-dialog/doc-viewer-dialog.component';
import { VendorOnboardingService } from '../../services/vendor-onboarding-service';
import { IVendorOnboardingDetails } from '../../models/vendor-onboarding-model';
import { ConfirmationService, ConfirmEventType, LazyLoadEvent, PrimeNGConfig } from 'primeng/api';
import SignaturePad from 'signature_pad';
import { DatePipe, ViewportScroller } from '@angular/common';
var htmlToPdfmake = require("html-to-pdfmake");
import * as pdfMake from "pdfmake/build/pdfmake";
import * as pdfFonts from 'pdfmake/build/vfs_fonts';
import { DomSanitizer } from '@angular/platform-browser';
import { Console } from 'console';
import { PDFDocument, rgb, StandardFonts } from 'pdf-lib';
import fontkit from '@pdf-lib/fontkit';
import { forkJoin } from 'rxjs';
(<any>pdfMake).vfs = pdfFonts?.pdfMake?.vfs;
(<any>pdfMake).fonts = {
  leckerli: {
    normal: `${window.location.origin}/assets/fonts/leckerli-one-v16-latin-regular.ttf`,
    bold: `${window.location.origin}/assets/fonts/leckerli-one-v16-latin-regular.ttf`,
    italics: `${window.location.origin}/assets/fonts/leckerli-one-v16-latin-regular.ttf`,
    bolditalics: `${window.location.origin}/assets/fonts/leckerli-one-v16-latin-regular.ttf`
  },
  cedarvillecursiveFont: {
    normal: `${window.location.origin}/assets/fonts/Cedarville-Cursive.ttf`,
    bold: `${window.location.origin}/assets/fonts/Cedarville-Cursive.ttf`,
    italics: `${window.location.origin}/assets/fonts/Cedarville-Cursive.ttf`,
    bolditalics: `${window.location.origin}/assets/fonts/Cedarville-Cursive.ttf`
  },
  Roboto: {
    normal: 'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-Regular.ttf',
    bold: 'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-Medium.ttf',
    italics: 'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-Italic.ttf',
    bolditalics: 'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-MediumItalic.ttf'
  }
}

@Component({
  selector: 'app-companyprofile-onboarddocument',
  templateUrl: './companyprofile-onboarddocument.component.html',
  styleUrls: ['./companyprofile-onboarddocument.component.css'],
  // encapsulation: ViewEncapsulation.None,
  providers: [DialogService, MessageService, ConfirmationService],
})
export class CompanyprofileOnboarddocumentComponent implements OnInit {
  tabIndex: number = 0;
  //-------start---------Company Profile Section -----Variables-----//
  companyProfileEditForm: FormGroup;
  disableVendorName: boolean = false;
  disableVendorEmail: boolean = false;
  isVendorPhoneUniqueNumbers: boolean = false;
  isVendorPhoneNumberValid: boolean = false;
  isFaxUniqueNumbers: boolean = false;
  isFaxNumberValid: boolean = false;
  editPaymentTerms: boolean = false;
  stateId: any = 0;
  states: any;
  public selectedStateId: Array<any> = [];
  public selectedCountryId: Array<any> = [];
  countries: ICountry[];
  public selectedPaymentTermsId: Array<any> = [];
  vendorPhoneExtDisabled: boolean = true;
  disabled: boolean = true;
  zipCode: any;
  entityTypes: any[] = [];
  categoryName;
  paymentTerms: any = [];
  paymentTermsId: any;
  entityTypeId: any;
  public selectedEntityTypeId: Array<any> = [];
  entityTypeEdit: string;
  isPaymentTermsEnable: boolean = false;
  net30WithFeeOnMSADoc;
  net45WithoutFeeOnMSADoc;
  net30WithFee: boolean = true;
  net45WithoutFee: boolean = true;
  isEntityTypeEnable: boolean = false;
  isEntityTypeDisable: boolean = false;
  isSqlComments: boolean = false;
  isSqlCommentsOnFirstName: boolean = false;
  isSqlCommentsOnMiddleName: boolean = false;
  isSqlCommentsOnLastName: boolean = false;
  taxIdNumber: string;
  taxIdNumberLength: number;
  vendorName: string;
  isVendorAvailability: boolean = false;
  isSaveAvailable: boolean = false;
  vendorNameAvail: any;
  taxIdAvail: any;
  adminPhoneExtDisabled: boolean = true;
  isAdminPhoneUniqueNumbers: boolean = false;
  isAdminPhoneNumberValid: boolean = false;
  adminEmail: any;
  adminEmailAvail: any;
  isStateEnable: boolean = false;
  vendorNameToSubmit: any;
  taxIdNumberToSubmit: any;
  vendorEmailIdToSubmit: any;
  vendorPhoneToSubmit: any;
  vendorExtToSubmit: any;
  faxNumberToSubmit: any;
  webAddressToSubmit: any;
  addressLine1ToSubmit: any;
  addressLine2ToSubmit: any;
  cityToSubmit: any;
  zipCodeToSubmit: any;
  zipCodeExtToSubmit: any;
  firstNameToSubmit: any;
  middleNameToSubmit: any;
  lastNameToSubmit: any;
  adminEmailToSubmit: any;
  adminPhoneToSubmit: any;
  adminExtToSubmit: any;
  hasCompanyProfileCompleted:boolean = false;
  emailEntityInvalid: boolean = false;
  allowedEmailList = ['gmail', 'yahoo', 'hotmail', 'hubspot', 'sendinblue', 'protonmail', 'outlook', 'zoho', 'aol', 'mail', 'gmx', 'icloud', 'yandex'];
  vendorEmailMatch: any;
  vendorEmailId:any;
  vendorAdminEmail:any;
  ssnNumberToSubmit:any;
  isMSAType1099:boolean=false;


  //---------end--------Company Profile Section -----Variables-----//

  ////start--------COI Section------Variables------------////////////
  companyCOIDetailsRequestForm: FormGroup;
  hasCOICompleted: boolean = false;
  isInsurancefileShowsuccessmsgOnRequest: boolean = false;
  InsurancefileuploadmessageOnRequest: string;
  InsuranceFileExtension: string;
  glEffSelectedDate: Date = new Date();
  alEffSelectedDate: Date = new Date();
  ulEffSelectedDate: Date = new Date();
  wcEffSelectedDate: Date = new Date();
  plEffSelectedDate: Date = new Date();
  coiFileDocUrlOnRequest: string = "";
  uploadedInsuranceFile: File;
  InsuranceUploadedPath: string;
  splittedInsuranceUploadedPathOnRequest: string[];
  InsuranceUploadedPathRequest: any;
  glEffDateToSubmit: Date;
  glExpDateToSubmit: Date;
  alEffDateToSubmit: Date;
  alExpDateToSubmit: Date;
  ulEffDateToSubmit: Date;
  ulExpDateToSubmit: Date;
  wcEffDateToSubmit: Date;
  wcExpDateToSubmit: Date;
  plEffDateToSubmit: Date;
  plExpDateToSubmit: Date;
  insuranceFileUrl: string;
  ////end--------COI Section------Variables------------////////////
  ////start--------I9 Section------Variables------------////////////
  i9FormFileExtension: string;
  isI9FileShowSuccessMsg: boolean = false;
  i9FileUploadMessage: string;
  uploadedI9File: File;
  hasI9Completed: boolean = false;
  i9FormValid: boolean = true;
  i9FormUploadedPath: any;
  splittedI9formUploadedPath: string[];
  i9FileDocUrl: string = "";
  showI9FormFilePreview: boolean = false;
  ////end--------I9 Section------Variables------------////////////
  ////start--------Everification Section------Variables------------////////////
  everificationFormFileExtension: string;
  isEverificationFileShowSuccessMsg: boolean = false;
  everificationFileUploadMessage: string;
  uploadedEverificationFile: File;
  hasEverificationCompleted: boolean = false;
  everificationFormValid: boolean = true;
  everificationFormUploadedPath: any;
  splittedEverificationformUploadedPath: string[];
  everificationFileDocUrl: string = "";
  showEverificationFormFilePreview: boolean = false;
  ////end--------Everification Section------Variables------------////////////
  ////start--------w9 Section------Variables------------////////////
  w9FormFileExtension: string;
  isW9FileShowSuccessMsg: boolean = false;
  w9FileUploadMessage: string;
  uploadedW9File: File;
  hasW9Completed: boolean = false;
  w9FormValid: boolean = true;
  w9FormUploadedPath: any;
  splittedW9formUploadedPath: string[];
  w9FileDocUrl: string = "";
  showW9FormFilePreview: boolean = false;
  ////end--------w9 Section------Variables------------////////////
  ////start--------dd Section------Variables------------////////////
  ddFormFileExtension: string;
  isDDFileShowSuccessMsg: boolean = false;
  ddFileUploadMessage: string;
  uploadedDDFile: File;
  hasDDCompleted: boolean = false;
  ddFormValid: boolean = true;
  ddFormUploadedPath: any;
  splittedDDformUploadedPath: string[];
  ddFileDocUrl: string = "";
  showDDFormFilePreview: boolean = false;
  ////end--------dd Section------Variables------------////////////
  ////start--------voidcheque Section------Variables------------////////////
  voidChequeFormFileExtension: string;
  isVoidChequeFileShowSuccessMsg: boolean = false;
  voidChequeFileUploadMessage: string;
  uploadedVoidChequeFile: File;
  hasVoidChequeCompleted: boolean = false;
  voidChequeFormValid: boolean = true;
  voidChequeFormUploadedPath: any;
  splittedVoidChequeformUploadedPath: string[];
  voidChequeFileDocUrl: string = "";
  showVoidChequeFormFilePreview: boolean = false;
  ////end--------voidcheque Section------Variables------------////////////
  //-------start---------MSA Section -----Variables-----//
  signFormMSA!: FormGroup;
  showMSAGenerateButton: boolean = true;
  imageUploadedPathMSASign: string;
  splittedImageUploadedPathMSASign: string[];
  fileToUploadMSASign: any;
  imageFileMSASign: string;
  imageUrlMSASign: any;
  defaultImageMSASign = "pi pi-user";
  uploadImageMSASign: any = "";
  uploadedFileMSASign: File;

  applicantNameOnMSA: any;
  dateOnMSAany: any;
  currentDateOnMSAany;
  showMSAFormFilePreviewEnable: boolean = false;
  showMSADocGenerateAccordion: boolean = false;
  msaDocumentUploaded: boolean = false;
  msatemplateId: any;
  msaTemplateOnBrowser: any;
  msaTemplate: any;
  msaIAgreeAboveTerms: boolean = false;
  uploadedMSAFile: File;
  msaFormUploadedPath: any;
  hasMSACompleted: boolean = false;
  paymentTermsConfirmationMessage: string;
  msaTemplateOnAccordion: any;
  isSignatureTab: boolean = false;
  isTextTab: boolean = true;
  isImageUploadTab: boolean = false;
  //---------end--------MSA Section -----Variables-----//


  //-------start---------PO Section -----Variables-----//
  @ViewChild('pdfViewer') public pdfViewer;
  title = 'signature-pad';
  @ViewChild("canvas", { static: true }) canvas!: ElementRef;
  @ViewChild("canvasPO", { static: true }) canvasPO!: ElementRef;
  @ViewChild("canvasNCA", { static: true }) canvasNCA!: ElementRef;
  sig!: SignaturePad;
  sigPO!: SignaturePad;
  sigNCA!: SignaturePad;
  public color: string = '#2889e9';
  penColor = 'rgba(0,0,0,1)';
  @ViewChild('printPdf') printPdf!: ElementRef;
  signFormPO!: FormGroup;
  yPosition: number = 15
  text: any;
  hrSign = 'data:image/png;base64,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';
  // logo = 'data:image/png;base64,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';
  logoOnLeft :string = DocTemplateLogo.DevCareLogo;
  logoOnRight: string = DocTemplateLogo.CMMIISOLogo;
  currentDate: Date = new Date();
  // showMSAAccordion = false;
  showPOGenerateButton: boolean = true;
  pdfFile;
  path: string = "../../../../../assets/img/first.png";
  alttext: string = "first image";
  //text2test;
  //@ViewChild('text2Container') text2Container: ElementRef;
  //@ViewChild('content', {static: false}) content: ElementRef;
  isSignatureTabPO: boolean = false;
  isTextTabPO: boolean = true;
  isImageUploadTabPO: boolean = false;
  imageUploadedPathPOSign: string;
  splittedImageUploadedPathPOSign: string[];
  fileToUploadPOSign: any;
  imageFilePOSign: string;
  imageUrlPOSign: any;
  defaultImagePOSign = "pi pi-user";
  uploadImagePOSign: any = "";
  imgBase64Path;
  uploadedFilePOSign: File;
  vendorInformation;
  dateOnPO;
  currentDateOnPO;
  showPOFormFilePreviewEnable: boolean = false;
  showPODocGenerateAccordion: boolean = false;
  nameOnDocLength;
  PODocumentUploaded: boolean = false;
  templateId;
  blobFile;
  POTemplateOnBrowser;
  POTemplateOnAccordion;
  POTemplate
  imageFile: string;
  //vendorId = 89;
  userProfileId = 1;
  POIAgreeAboveTerms: boolean = false;
  uploadedPOFile: File;
  vendornamePO: string;
  poFormUploadedPath: any;
  hasPOCompleted: boolean = false;
  //---------end--------PO Section -----Variables-----//

  //-------start---------NCA Section -----Variables-----//
  signFormNCA!: FormGroup;
  showNCAGenerateButton: boolean = true;
  imageUploadedPathNCASign: string;
  splittedImageUploadedPathNCASign: string[];
  fileToUploadNCASign: any;
  imageFileNCASign: string;
  imageUrlNCASign: any;
  defaultImageNCASign = "pi pi-user";
  uploadImageNCASign: any = "";
  uploadedFileNCASign: File;

  applicantNameOnNCA;
  dateOnNCA;
  currentDateOnNCA;
  showNCAFormFilePreviewEnable: boolean = false;
  showNCADocGenerateAccordion: boolean = false;
  NCADocumentUploaded: boolean = false;
  NCAtemplateId;
  NCATemplateOnBrowser;
  NCATemplateOnAccordion;
  NCATemplate
  NCAIAgreeAboveTerms: boolean = false;
  uploadedNCAFile: File;
  applicantName: any;
  ncaFormUploadedPath: any;
  hasNCACompleted: boolean = false;
  isSignatureTabNCA: boolean = false;
  isTextTabNCA: boolean = true;
  isImageUploadTabNCA: boolean = false;
  showNCAAccordion: boolean = false;
  //---------end--------NCA Section -----Variables-----//
  msaTypeIdOnEdit: number = 0;
  emailLinkRefId: string;
  documentTypeOnFileUpload: string;
  templatePaymentTermsId: string;
  msaTypeId: number;
  companyProfileAndOnboardingDocumentPageTitle: string;
  insuranceExhibitA: number;
  submittedByEmail: any;
  tempVendorId: any;
  loadingSaveButton: boolean = false;
  loadingUploadButton: boolean = false;
  saveModal:boolean = false;
  linkSharedEmailId: any;
  createdBy: any;
  commentsControl = new FormControl("", this.editorMaxLength(500));
  // emailValidity: any;
  alreadySubmittedModal: boolean = false;
  emailLinkExpiredModal: boolean = false;
  showGenerateButton: boolean = false;
  imageUrl: any;
  defaultImage = "pi pi-user";
  fileToUpload: any;
  uploadedFileMSA: File;
  vendorId: number;
  //-------start---------Existing Vendor Section -----Variables-----//
  isVendorAvailable:boolean;
  isMSASelected: boolean = false;
  isPOSelected: boolean = false;
  isNCASelected: boolean = false;
  isVoidChequeSelected: boolean = false;
  isW9Selected: boolean = false;
  isI9Selected: boolean = false;
  isDDSelected: boolean = false;
  isCOISelected: boolean = false;
  isEVerificationSelected: boolean = false;
  vendorDetailsForm: FormGroup;
  nameOnDocumentSubmit:string;
  selectedDocumentList: string[]=[];
  selectedDocumentCount: number;
  onMSAConfirmation:boolean =false;
  onPOConfirmation:boolean =false;
  onNCAConfirmation:boolean =false;
  nameOnDocument:string;
  //msaConfirmationCheckbox:boolean =true;
  //poConfirmationCheckbox:boolean =false;
  //ncaConfirmationCheckbox:boolean =false;
  companyProfileDDForm: FormGroup;
  companyProfileW9Form: FormGroup;
  companyProfileI9Form: FormGroup;
  accountCategories: any[] = [
    { name: 'Checking Account', value: 'Checking Account' },
    { name: 'Savings Account', value: 'Savings Account' }
  ];
  date:Date = new Date();
  onDDConfirmation:boolean = false;
  federalTaxClassifiCategories: any[] = [
    { name: 'Individual/sole proprietor or single-member LLC', value: 'single-member LLC' },
    { name: 'C Corporation', value: 'C Corporation' },
    { name: 'S Corporation', value: 'S Corporation' },
    { name: 'Partnership', value: 'Partnership' },
    { name: 'Trust/estate', value: 'Trust/estate' },
    { name: 'Limited liability company', value: 'LLC Tax Classification' },
    { name: 'Other', value: 'others' }
  ];
  llcCategories: any[] = [
    { name: 'C Corporation', value: 'C' },
    { name: 'S Corporation', value: 'S' },
    { name: 'P Partnership', value: 'P' }
  ];
  typeTINCategories: any[] = [
    { name: 'Social Security Number', value: 'SSN' },
    { name: 'Employer Identification Number', value: 'EIN', disabled: true }
  ];
  isLLC:boolean = false;
  isOthers:boolean = false;
  onW9Confirmation:boolean = false;
  isSSN:boolean = false;
  isEIN:boolean = false;
  citizenshipOrImmigrationStatusCategories: any[] = [
    { name: 'A citizen of the United States', value: 'citizen of US' },
    { name: 'A noncitizen national of the United States', value: 'noncitizen of US' },
    { name: 'A lawful permanent resident', value: 'lawful permanent resident' },
    { name: 'A noncitizen', value: 'noncitizen authorized to work' }
  ];
  identifiersCategories: any[] = [
    { name: 'USCIS A-Number', value: 'USCIS' },
    { name: 'Form I-94 Admission Number', value: 'I94' },
    { name: 'Foreign Passport Number & Country of Issuance', value:'Passport and Issuance'}
  ];
  isUSCIS: boolean = false;
  isidentifiers: boolean = false;
  onI9Confirmation: boolean = false;
  stateName: string = "";
  stateCode: string = "";
  fullAddress: string = "";
  isUSCISANumber: boolean = false;
  isI94AdminNumber: boolean = false;
  isfpn: boolean = false;
  selected: string = '';
  companyProfileTabOpened: boolean = false;
  companyDetailsTabOpened: boolean = false;
  msaTabOpened: boolean = false;
  poTabOpened: boolean = false;
  ncaTabOpened: boolean = false;
  ddTabOpened: boolean = false;
  coiTabOpened: boolean = false;
  w9TabOpened: boolean = false;
  i9TabOpened: boolean = false;
  eVerificationTabOpened: boolean = false;
  hasI9PrivewCompleted: boolean = false;
  hasDDPrivewCompleted: boolean = false;
  hasW9PrivewCompleted: boolean = false;


  ddOldCompanyName: string = '';
  ddOldAddress: string = ''
  ddOldBankName: string = '';
  ddOldAccountType: string = '';
  ddOldRoutingNumber: string = '';
  ddOldAccountNumber: string = '';
  ddOldSignature: string = '';
  ddOldConfirmationCheckbox: boolean = false;
  w9OldName: string = '';
  w9OldBusinessName: string = '';
  w9OldFederalTaxClassi: string = '';
  w9OldLlcTax: string = '';
  w9OldOthers: string = '';
  w9OldAddress: string = '';
  w9OldCityZipState: string = '';
  w9OldListAccNumber: string = '';
  w9OldReqNameAddress: string = '';
  w9OldExemptPayeeCode: string = '';
  w9OldExemptFATCA: string = '';
  w9OldTypeofTNS: string = '';
  w9OldSsn: string = '';
  w9OldEin: string = '';
  w9OldSignature: string = '';
  w9OldW9ConfirmationCheckbox: boolean = false;
  i9OldLastName: string = '';
  i9OldFirstName: string = '';
  i9OldMiddleName: string = '';
  i9OldOtherLastName: string = '';
  i9OldAddress: string = '';
  i9OldAptNumber: string = '';
  i9OldCityOrTown: string = '';
  i9OldState: string = '';
  i9OldZip: string = '';
  i9OldDob: string = '';
  i9OldSsn: string = '';
  i9OldEmailId: string = '';
  i9OldTelePhoneNo: string = '';
  i9OldCitizenshipOrImmigration: string = '';
  i9OldUscisOrANumber: string = '';
  i9OldNoncitizenNumber: string = '';
  i9OldExpDate: string = '';
  i9OldUscisANumber: string = '';
  i9OldI94AdminNumber: string = '';
  i9OldFpn: string = '';
  i9OldSignature: string = '';
  i9OldI9ConfirmationCheckbox: boolean = false;

  constructor(
    private formBuilder: FormBuilder,
    private route: ActivatedRoute,
    private router: Router,
    private messageService: MessageService,
    private sharedService: SharedService,
    private spinner: NgxSpinnerService,
    private registerService: RegisterService,
    private dialogService: DialogService,
    private vendoronboardingService: VendorOnboardingService,
    private sanitizer: DomSanitizer,
    public datepipe: DatePipe,
    private confirmationService: ConfirmationService,
    private viewportScroller: ViewportScroller

  ) { }

  ngOnInit(): void {
    this.spinner.show();
    const param = this.route.snapshot.paramMap.get('emailLinkRefId');
    this.vendorForm();
    this.companyCOIDetailsForm();
    // const param1 = this.route.snapshot.paramMap.get('linkSharedEmailId');
    if (param) {
      // this.emailLinkRefId = param;
      // this.linkSharedEmailId = param1;
      // this.getVendorOnboardDetails();
      const partEmailLinkRefId  = param.split('_');
      if(partEmailLinkRefId.length >= 2){
        this.emailLinkRefId = partEmailLinkRefId[0] + '_';
        this.linkSharedEmailId = partEmailLinkRefId[1];
        this.getVendorOnboardDetails();
        console.log('part 0', this.emailLinkRefId);
        console.log('part 1', this.linkSharedEmailId);
      }
     
    }
    this.vendoronboardingService.getEmailValidityCheck(this.emailLinkRefId).subscribe((data:any)=> {
      // this.emailValidity = data;
      console.log('email validity',data);
      if(data.isError == true && data.result == "Already Submitted by VendorOnboardProcess"){
        // this.router.navigate(['/login']);
        this.alreadySubmittedModal = true;
        this.spinner.hide();
      }
      else if(data.isError == true && data.result == "EMail link Expired by VendorOnboardProcess"){
        this.emailLinkExpiredModal = true;
        this.spinner.hide();
      }
      // else{
      // }
      });
      this.companyProfileForm();
      //this.vendorForm();
      this.getEntityType();
      //this.getStates();
      this.getCountries();
     
    this.vendorAdminEmail=undefined;
    // this.getVendorOnboardDetails();
    this.signFormPO = this.formBuilder.group({
      vendorName: new FormControl(''),
      name: new FormControl(''),
      title: new FormControl('', [Validators.required]),
      signText: [this.nameOnDocumentSubmit],
      poConfirmationCheckbox:[false]
    });
    this.signFormNCA = this.formBuilder.group({
      applicantName: new FormControl(''),
      name: new FormControl(''),
      // title: new FormControl('', [Validators.required]),
      signText: [this.nameOnDocumentSubmit],
      ncaConfirmationCheckbox:[false]
    });
    this.signFormMSA = this.formBuilder.group({
      vendorName: new FormControl(''),
      name: new FormControl(''),
      title: new FormControl('', [Validators.required]),
      signText: [this.nameOnDocumentSubmit],
      msaConfirmationCheckbox:[false]
    });
    this.sig = new SignaturePad(this.canvas.nativeElement, {
      penColor: this.penColor, minWidth: 1,
      maxWidth: 2
    });
    this.sigPO = new SignaturePad(this.canvasPO.nativeElement, {
      penColor: this.penColor, minWidth: 1,
      maxWidth: 2
    });
    this.sigNCA = new SignaturePad(this.canvasNCA.nativeElement, {
      penColor: this.penColor, minWidth: 1,
      maxWidth: 2
    });
  }

  getVendorOnboardDetails() {
    // this.emailLinkRefId = 'VNDMMmi16202307496K712J824ZVH4_';
    forkJoin({
    vendorDetails : this.vendoronboardingService.GetVendorOnboardProcess(this.emailLinkRefId),
    states: this.sharedService.getStates()
  }).subscribe((response: any) => {
      const value = response.vendorDetails;
      this.states = response.states;
      console.log('dd', value);
      if (value.templatePaymentTermsId == null) {
        value.templatePaymentTermsId = "";
      }
      this.vendorId = value.vendorId;
      this.isVendorAvailable=value.isVendorAvailable;
      this.isMSASelected = value.isMSASelected;
      this.isPOSelected = value.isPOSelected;
      this.isNCASelected = value.isNCASelected;
      this.isVoidChequeSelected =value.isVoidChequeSelected;
      this.isW9Selected = value.isW9Selected;
      this.isI9Selected = value.isI9Selected;
      this.isDDSelected = value.isDDSelected;
      this.isCOISelected = value.isCOISelected;
      this.isEVerificationSelected = value.isEVerificationSelected;
      if(this.isVendorAvailable)
      {
        this.hasMSACompleted= true;
        this.hasPOCompleted= true;
        this.hasNCACompleted= true;
        this.hasVoidChequeCompleted= true;
        this.hasDDCompleted= true;
        this.hasCOICompleted= true;
        this.hasI9Completed= true;
        this.hasW9Completed= true;
        this.hasEverificationCompleted= true;
        if(this.isMSASelected)
        {
          this.hasMSACompleted= false;
          this.selectedDocumentList.push('MSA Selected');
        }
        if(this.isPOSelected)
        {
          this.hasPOCompleted= false;
          this.selectedDocumentList.push('PO Selected');
        }
        if(this.isNCASelected)
        {
          if(this.showNCAAccordion == true){
            this.hasNCACompleted= false;
          this.selectedDocumentList.push('NCA Selected');
          }
          else if(this.showNCAAccordion == false){
            this.hasNCACompleted= true;
            this.selectedDocumentList.push('NCA Selected');
          }
          
        }
        if(this.isDDSelected)
        {
          this.hasDDCompleted= false;
          this.selectedDocumentList.push('DD Selected');
        }
        if(this.isCOISelected)
        {
          this.hasCOICompleted= false;
          this.selectedDocumentList.push('COI Selected');
          const glEffDate = this.companyCOIDetailsRequestForm.get('glEffDate');
          const glExpDate = this.companyCOIDetailsRequestForm.get('glExpDate');
          const alEffDate = this.companyCOIDetailsRequestForm.get('alEffDate');
          const alExpDate = this.companyCOIDetailsRequestForm.get('alExpDate');
          const ulEffDate = this.companyCOIDetailsRequestForm.get('ulEffDate');
          const ulExpDate = this.companyCOIDetailsRequestForm.get('ulExpDate');
          const wcEffDate = this.companyCOIDetailsRequestForm.get('wcEffDate');
          const wcExpDate = this.companyCOIDetailsRequestForm.get('wcExpDate');
          const plEffDate = this.companyCOIDetailsRequestForm.get('plEffDate');
          const plExpDate = this.companyCOIDetailsRequestForm.get('plExpDate');
          glEffDate.setValidators([Validators.required]);
          glExpDate.setValidators([Validators.required]);
          alEffDate.setValidators([Validators.required]);
          alExpDate.setValidators([Validators.required]);
          ulEffDate.setValidators([Validators.required]);
          ulExpDate.setValidators([Validators.required]);
          wcEffDate.setValidators([Validators.required]);
          wcExpDate.setValidators([Validators.required]);
          plEffDate.setValidators([Validators.required]);
          plExpDate.setValidators([Validators.required]);
          glEffDate.updateValueAndValidity();
          glExpDate.updateValueAndValidity();
          alEffDate.updateValueAndValidity();
          alExpDate.updateValueAndValidity();
          ulEffDate.updateValueAndValidity();
          ulExpDate.updateValueAndValidity();
          wcEffDate.updateValueAndValidity();
          wcExpDate.updateValueAndValidity();
          plEffDate.updateValueAndValidity();
          plExpDate.updateValueAndValidity();
        }
        if(this.isW9Selected)
        {
          this.hasW9Completed= false;
          this.selectedDocumentList.push('W9 Selected');
        }
        if(this.isI9Selected)
        {
          this.hasI9Completed= false;
          this.selectedDocumentList.push('I9 Selected');
        }
        if(this.isVoidChequeSelected)
        {
          this.hasVoidChequeCompleted= false;
          this.selectedDocumentList.push('Void Cheque Selected');
        }
        if(this.isEVerificationSelected )
        {
          this.hasEverificationCompleted= false;
          this.selectedDocumentList.push('EVerification Selected');
        }
        console.log(this.selectedDocumentList);
        this.selectedDocumentCount = this.selectedDocumentList.length;
        this.companyProfileAndOnboardingDocumentPageTitle = 'DVMS Documents - ' + value.vendorName;
      }
      if(!this.isVendorAvailable)
      {
        this.companyProfileAndOnboardingDocumentPageTitle = 'Company Profile and Onboarding Documents - ' + value.vendorName;
      }
      
      this.vendorAdminEmail=undefined;
      this.msaTypeIdOnEdit = value.msaTypeId;
      if(this.msaTypeIdOnEdit == 2 || this.msaTypeIdOnEdit == 4){
        this.showNCAAccordion = true;
        this.hasEverificationCompleted= true;
      }
      this.vendorName = value.vendorName;
      this.applicantName = value.applicantName;
     
      this.templatePaymentTermsId = value.templatePaymentTermsId;
      if(value.msaDocumentTemplate != undefined || value.msaDocumentTemplate != null)
      {
        this.msaTemplateOnBrowser = value.msaDocumentTemplate.generatedTemplate;
        // console.log('msa template',this.msaTemplateOnBrowser);
        var MSAOnPreview = this.msaTemplateOnBrowser.replace(/<p>/g, '<div>').replace(/<\/p>/g, '</div>');
        this.msaTemplateOnAccordion = this.sanitizer.bypassSecurityTrustHtml(MSAOnPreview);
      }
      if(value.poDocumentTemplate != undefined || value.poDocumentTemplate != null)
      {
        this.POTemplateOnAccordion = this.sanitizer.bypassSecurityTrustHtml(value.poDocumentTemplate.generatedTemplate);
        this.POTemplateOnBrowser = value.poDocumentTemplate.generatedTemplate
      }
      
      if(value.ncaDocumentTemplate != undefined || value.ncaDocumentTemplate != null){
        this.NCATemplateOnAccordion = this.sanitizer.bypassSecurityTrustHtml(value.ncaDocumentTemplate.generatedTemplate);
        this.NCATemplateOnBrowser =value.ncaDocumentTemplate.generatedTemplate;

      }
      this.insuranceExhibitA = value.insuranceExhibitId;
      this.tempVendorId = value.tempVendorId;
      this.emailLinkRefId = value.emailLinkRefId;
      this.createdBy = value.createdBy;
      // console.log('insurance exhibit a', this.insuranceExhibitA);
            // console.log('applicant name', this.applicantName);
      this.getPaymentTerms();
      const vendorEmailId = this.companyProfileEditForm.get('vendorEmailId');
      const vendorAdminEmail = this.companyProfileEditForm.get('vendorAdminEmail');
      if (this.msaTypeIdOnEdit == MSAType.Standard1099 || this.msaTypeIdOnEdit == MSAType.Special1099) {
        var arr=this.entityTypes.filter((item:any) => item.description == 'Individual');
        vendorEmailId.setValidators([Validators.required, Validators.pattern(VMSConstants.emailValidator)]);
        vendorAdminEmail.setValidators([Validators.required, Validators.pattern(VMSConstants.emailValidator)]);
        this.selectedEntityTypeId = arr[0];
        this.isEntityTypeEnable = true;
        this.entityTypeId = arr[0].lookupId;
        this.isEntityTypeDisable = true;
      }
      if(!this.isVendorAvailable)
      {
        this.companyProfileEditForm = this.formBuilder.group({
          vendorName: new FormControl(value.vendorName, [Validators.required]),
          vendorEmailId: new FormControl(value.vendorEmailId, [Validators.required, this.emailValidator("Others"), Validators.pattern(VMSConstants.emailValidator)]),
          vendorPhoneNumber: new FormControl(value.vendorPhoneNumber, [Validators.required]),
          vendorPhoneExtNumber: new FormControl(value.vendorPhoneExtNumber, [Validators.pattern(VMSConstants.phoneExtValidator)]),
          faxNumber: new FormControl(value.faxNumber),
          addressLine1: new FormControl(value.addressLine1, [Validators.required]),
          addressLine2: new FormControl(value.addressLine2),
          webAddress: new FormControl(value.webAddress, [Validators.pattern(VMSConstants.urlRegex)]),
          taxIdNumber: new FormControl(value.taxIdNumber),
          ssnNumber: new FormControl(value.ssnNumber),
          city: new FormControl(value.city, [Validators.required]),
          zipCode: new FormControl(value.zipCode, [Validators.required, Validators.pattern(VMSConstants.zipcodeValidator)]),
          zipCodeExt: new FormControl(value.zipCodeExt, [Validators.pattern(VMSConstants.zipcodeExtValidator)]),
          vendorAdminFirstName: new FormControl(value.firstName, [Validators.required]),
          vendorAdminMiddleName: new FormControl(value.middleName),
          vendorAdminLastName: new FormControl(value.lastName, [Validators.required]),
          vendorAdminEmail: new FormControl(value.vendorEmailId, [Validators.required, this.emailValidator("Others"), Validators.pattern(VMSConstants.emailValidator)]),
          vendorAdminPhone: new FormControl(value.vendorPhoneNumber, [Validators.required]),
          vendorAdminPhoneExt: new FormControl(value.vendorPhoneExtNumber, [Validators.pattern(VMSConstants.phoneExtValidator)]),
          nameOnDocument: new FormControl('', [Validators.required])
  
        });
      }
      if(this.isVendorAvailable)
      {
        console.log('is',value);
        this.vendorDetailsForm = this.formBuilder.group({
          vendorName: new FormControl(value.vendorName, [Validators.required]),
          taxIdNumber: new FormControl(value.taxIdNumber),
          ssnNumber: new FormControl(value.ssnNumber),
          addressLine1: new FormControl(value.addressLine1),
          nameOnDocument: new FormControl('', [Validators.required])
        });

      this.fullAddress = value.addressLine1 +', '+ value.city +', '+ value.stateName + ", " + value.zipCode;
      this.companyProfileDDForm.controls['companyName'].setValue(value.vendorName);
      this.companyProfileDDForm.controls['address'].setValue(this.fullAddress);
      
      const fullName = [value.vendorAdminFirstName, value.vendorAdminMiddleName, value.vendorAdminLastName]
      .filter(name => !!name && name.trim().length > 0) // remove null/undefined/empty strings
      .join(' ');
      this.companyProfileW9Form.controls['name'].setValue(fullName);
      this.companyProfileW9Form.controls['address'].setValue(value.addressLine1);
      this.companyProfileW9Form.controls['cityZipState'].setValue(value.city +', '+ value.stateName + ", " + value.zipCode); 
    
      this.stateName = value.stateName;
      this.companyProfileI9Form.controls['lastName'].setValue(value.vendorAdminLastName);
      this.companyProfileI9Form.controls['firstName'].setValue(value.vendorAdminFirstName);
      this.companyProfileI9Form.controls['middleName'].setValue(value.vendorAdminMiddleName);
      this.companyProfileI9Form.controls['address'].setValue(value.addressLine1);
      this.companyProfileI9Form.controls['cityOrTown'].setValue(value.city);
      this.companyProfileI9Form.controls['state'].setValue(value.stateName);
      this.companyProfileI9Form.controls['zip'].setValue(value.zipCode);
      //this.companyProfileI9Form.controls['ssn'].setValue(value.ssnNumber);
      this.companyProfileI9Form.controls['emailId'].setValue(value.vendorAdminEmail);
      this.companyProfileI9Form.controls['telePhoneNo'].setValue(value.vendorAdminPhone);
      }
     
const taxIdNumber = this.companyProfileEditForm.get('taxIdNumber');
const ssnNumber = this.companyProfileEditForm.get('ssnNumber');
  if(value.msaTypeId==MSAType.Standard1099 || value.msaTypeId==MSAType.Special1099){
    ssnNumber.setValidators([Validators.required,Validators.minLength(9)]);
    taxIdNumber.clearValidators();
    ssnNumber.disable();
    this.isMSAType1099=true;
  }
  else{
    taxIdNumber.setValidators([Validators.required,Validators.minLength(9)]);
    ssnNumber.clearValidators();
    taxIdNumber.disable();
    this.isMSAType1099=false;
  }
  taxIdNumber.updateValueAndValidity();
  ssnNumber.updateValueAndValidity();
  this.spinner.hide();
    });
  }
  ////company profile accordion methods//////
  companyProfileForm() {
    this.companyProfileEditForm = this.formBuilder.group({
      vendorName: ['', [Validators.required]],
      vendorEmailId: ['', [Validators.required, this.emailValidator("Others"), Validators.pattern(VMSConstants.emailValidator)]],
      vendorPhoneNumber: ['', [Validators.required]],
      vendorPhoneExtNumber: ['', [Validators.pattern(VMSConstants.phoneExtValidator)]],
      faxNumber: [''],
      addressLine1: ['', [Validators.required]],
      addressLine2: [''],
      webAddress: ['', [Validators.pattern(VMSConstants.urlRegex)]],
      taxIdNumber: [''],
      ssnNumber: [''],
      city: ['', [Validators.required]],
      zipCode: ['', [Validators.required, Validators.pattern(VMSConstants.zipcodeValidator)]],
      zipCodeExt: ['', [Validators.pattern(VMSConstants.zipcodeExtValidator)]],
      vendorAdminFirstName: ['', [Validators.required]],
      vendorAdminMiddleName: [''],
      vendorAdminLastName: ['', [Validators.required]],
      vendorAdminEmail: ['', [Validators.required, this.emailValidator("Others"), Validators.pattern(VMSConstants.emailValidator)]],
      vendorAdminPhone: ['', [Validators.required]],
      vendorAdminPhoneExt: ['', [Validators.pattern(VMSConstants.phoneExtValidator)]],
      nameOnDocument:['',[Validators.required]]
    });

     
    this.companyProfileDDForm = this.formBuilder.group({
      companyName: [this.vendorNameToSubmit, [Validators.required]],
      address: [this.fullAddress, [Validators.required]],
      bankName: [null, [Validators.required]],
      accountType: [null, [Validators.required]],
      routingNumber: [null,[Validators.required]],
      accountNumber: [null, [Validators.required]],
      signature: ['', [Validators.required]],
      date: [this.datepipe.transform(new Date(), "MM/dd/yyyy")],
      ddConfirmationCheckbox:[false]
    });

    this.companyProfileW9Form = this.formBuilder.group({
      name: [null, [Validators.required]],
      businessName: [null],
      federalTaxClassi: [null, [Validators.required]],
      llcTax: [null],
      others: [null],
      address: [null, [Validators.required,]],
      cityZipState: [null, [Validators.required]],
      listAccNumber: [null],
      reqNameAddress: [null],
      
      exemptPayeeCode: [null],
      exemptFATCA: [null],

      typeofTNS:[null, [Validators.required]],
      ssn: [null],
      ein: [null],

      signature: ['', [Validators.required]],
      date: [this.datepipe.transform(new Date(), "MM/dd/yyyy")],
      w9ConfirmationCheckbox:[false, [Validators.required]]
    });

    this.companyProfileI9Form = this.formBuilder.group({
      lastName: [null, [Validators.required]],
      firstName: [null, [Validators.required]],
      middleName: [null],
      otherLastName: [null],
      address: [null, [Validators.required]],
      aptNumber: [null],
      cityOrTown: [null, [Validators.required]],
      state: [null, [Validators.required]],
      zip: [null, [Validators.required,]],
      dob: [null, [Validators.required]],
      ssn: [null, [Validators.required]],
      emailId: [null, [Validators.required, Validators.pattern(VMSConstants.emailValidator)]],
      telePhoneNo: [null],

      citizenshipOrImmigration: [null, [Validators.required]],
      uscisOrANumber:[null],

      noncitizenNumber:[null],
      expDate:[null],
      uscisANumber:[null],
      i94AdminNumber:[null],
      fpn:[null],

      signature: ['', [Validators.required]],
      date: [this.datepipe.transform(new Date(), "MM/dd/yyyy")],

      i9ConfirmationCheckbox:[false, [Validators.required]],

      // docTitle1ListA:[null],
      // docTitle1ListB: [null],
      // docTitle1ListC: [null],
      // issuingAuthority1ListA : [null],
      // issuingAuthority1ListB : [null],
      // issuingAuthority1ListC : [null],
      // docNumber1ListA : [null],
      // docNumber1ListB : [null],
      // docNumber1ListC : [null],
      // s2ExpDate1ListA: [null],
      // s2ExpDate1ListB: [null],
      // s2ExpDate1ListC: [null],
      // docTitle2: [null],
      // issuingAuthority2 : [null],
      // docNumber2 : [null],
      // s2ExpDate2: [null],
      // docTitle3: [null],
      // issuingAuthority3 : [null],
      // docNumber3 : [null],
      // s2ExpDate3: [null],
      // additionalInfo: [null],
      // isAuthorizedByDHS:[false],
      // firstDayOfEmp: [null],
      // nameAnoTitleOfEmpOrAuth:[null],
      // signOfEmpOrAuth:[null],
      // empBusOrOrgName:[null],
      // empBusOrOrgAddress:[null],

      // supALastNameSec1:[null],
      // supAFirstNameSec1:[null],
      // supAMiddleNameSec1:[null],
      // supASignOfPrepareOrTrans1:[null],
      // supADate1:[null],
      // supALastName1:[null],
      // supAFirstName1:[null],
      // supAMiddleName1:[null],
      // supAAddress1:[null],
      // supACityOrTown1:[null],
      // supAState1:[null],
      // supAZip1:[null],
      // supASignOfPrepareOrTrans2:[null],
      // supADate2:[null],
      // supALastName2:[null],
      // supAFirstName2:[null],
      // supAMiddleName2:[null],
      // supAAddress2:[null],
      // supACityOrTown2:[null],
      // supAState2:[null],
      // supAZip2:[null],
      // supASignOfPrepareOrTrans3:[null],
      // supADate3:[null],
      // supALastName3:[null],
      // supAFirstName3:[null],
      // supAMiddleName3:[null],
      // supAAddress3:[null],
      // supACityOrTown3:[null],
      // supAState3:[null],
      // supAZip3:[null],
      // supASignOfPrepareOrTrans4:[null],
      // supADate4:[null],
      // supALastName4:[null],
      // supAFirstName4:[null],
      // supAMiddleName4:[null],
      // supAAddress4:[null],
      // supACityOrTown4:[null],
      // supAState4:[null],
      // supAZip4:[null],

      // supBLastNameSec1:[null],
      // supBFirstNameSec1:[null],
      // supBMiddleNameSec1:[null],
      // supBDate1:[null],
      // supBLastName1:[null],
      // supBFirstName1:[null],
      // supBMiddleName1:[null],
      // supBDocTitle1:[null],
      // supBDocNumber1:[null],
      // supBExpDate1:[null],
      // supBEmpNameOfEmpOrAuth1:[null],
      // supBsignOfEmpOrAuth1:[null],
      // supBAdditionalInfo1: [null],
      // isSupBAuthorizedByDHS1:[false],
      // supBDate2:[null],
      // supBLastName2:[null],
      // supBFirstName2:[null],
      // supBMiddleName2:[null],
      // supBDocTitle2:[null],
      // supBDocNumber2:[null],
      // supBExpDate2:[null],
      // supBEmpNameOfEmpOrAuth2:[null],
      // supBsignOfEmpOrAuth2:[null],
      // supBAdditionalInfo2: [null],
      // isSupBAuthorizedByDHS2:[false],
      // supBDate3:[null],
      // supBLastName3:[null],
      // supBFirstName3:[null],
      // supBMiddleName3:[null],
      // supBDocTitle3:[null],
      // supBDocNumber3:[null],
      // supBExpDate3:[null],
      // supBEmpNameOfEmpOrAuth3:[null],
      // supBsignOfEmpOrAuth3:[null],
      // supBAdditionalInfo3: [null],
      // isSupBAuthorizedByDHS3:[false],
    });
  }

  public errorHandling = (control: string, error: string) => {
    return this.companyProfileEditForm.controls[control].hasError(error);
  }

  get companyProfileFormEditControl() {
    return this.companyProfileEditForm.controls;
  }
  getEntityType() {
    this.categoryName = 'Entity Type';
    this.sharedService.getLookupCategory(this.categoryName).subscribe((data: any) => {
      this.entityTypes = data;
    });
  }
  getEntityTypeOnChange(event) {
    this.isEntityTypeEnable = true;
    this.entityTypeId = event.value.lookupId;
    const vendorEmailId = this.companyProfileEditForm.get('vendorEmailId');
    const vendorAdminEmail = this.companyProfileEditForm.get('vendorAdminEmail');
    if(event.value.description == 'Individual'){
      vendorEmailId.setValidators([Validators.required, Validators.pattern(VMSConstants.emailValidator)]);
      vendorAdminEmail.setValidators([Validators.required, Validators.pattern(VMSConstants.emailValidator)]);
    }
    else{
      vendorEmailId.setValidators([Validators.required, this.emailValidator(event.value.description),Validators.pattern(VMSConstants.emailValidator)]);
      vendorAdminEmail.setValidators([Validators.required, this.emailValidator(event.value.description), Validators.pattern(VMSConstants.emailValidator)]);
    }
  }
  getPaymentTerms() {
    this.sharedService.getLookupMasterByCategoryId(LookupCategory.PaymentTerms).subscribe((data: any) => {
      if (this.msaTypeIdOnEdit == MSAType.StandardC2C) {
        var templatePaymentTermsIdStC2C = (Number(PaymentTerms.Net_30_With_Two_Percent_Fees) + ',' + Number(PaymentTerms.Net_45_Without_Fees));
        const arrayPaymentTermsId = templatePaymentTermsIdStC2C.split(',');
        for (var i = 0; i < arrayPaymentTermsId.length; i++) {
          for (var j = 0; j < data.length; j++) {
            if (arrayPaymentTermsId[i] == data[j].lookupOrder) {
              this.paymentTerms.push(data[j]);
            }
          }
        }
      }
      if (this.msaTypeIdOnEdit == MSAType.Standard1099) {
        var templatePaymentTermsIdSt1099 = (Number(PaymentTerms.Net_20_With_Two_Percent_Fees) + ',' + Number(PaymentTerms.Net_30_With_One_Percent_Fees) + ',' + Number(PaymentTerms.Net_45_Without_Fees));
        const arrayPaymentTermsId = templatePaymentTermsIdSt1099.split(',');
        for (var i = 0; i < arrayPaymentTermsId.length; i++) {
          for (var j = 0; j < data.length; j++) {
            if (arrayPaymentTermsId[i] == data[j].lookupOrder) {
              this.paymentTerms.push(data[j]);
            }
          }
        }
      }
      if (this.msaTypeIdOnEdit == MSAType.Special1099 || MSAType.SpecialC2C) {
        const arrayPaymentTermsId = this.templatePaymentTermsId.split(',');
        for (var i = 0; i < arrayPaymentTermsId.length; i++) {
          for (var j = 0; j < data.length; j++) {
            if (arrayPaymentTermsId[i] == data[j].lookupOrder) {
              this.paymentTerms.push(data[j]);
            }
          }
        }
      }

    });
  }
  getPaymentTermsOnChange(event) {
    // console.log(this.templatePaymentTermsId);
    const temparray = this.templatePaymentTermsId.split(',');
    // console.log(temparray);
var temparraytoint = temparray.map(function (x) { 
  return parseInt(x, 10); 
});
console.log(temparraytoint);
   // const ptValueArray = Object.keys(PaymentTerms);
    const ptValueArray =Object.values(PaymentTerms).filter(val=>!isNaN(Number(val)));
    const valuetoretain: number[] = [];
    // console.log(ptValueArray);
  for(var i=0;i<ptValueArray.length;i++)
  {
    //console.log(ptValueArray[i]);
    for(var j=0;j<temparraytoint.length;j++)
    {
      //console.log(temparraytoint[j]);
       if(ptValueArray[i] == temparraytoint[j])
       {
        // console.log(ptValueArray[i]);
           valuetoretain.push(Number(ptValueArray[i]));
       }
    }
  }
  // console.log('final',valuetoretain);
    this.paymentTermsId = event.value.lookupOrder;
    if(this.msaTemplateOnBrowser.includes(" a) ")==true) {
      this.msaTemplateOnBrowser=this.msaTemplateOnBrowser.replace(" a) ","")
    }
    if(this.msaTemplateOnBrowser.includes(" b) ")==true) {
      this.msaTemplateOnBrowser=this.msaTemplateOnBrowser.replace(" b) ","")
    }
    if(this.msaTemplateOnBrowser.includes(" c) ")==true) {
      this.msaTemplateOnBrowser=this.msaTemplateOnBrowser.replace(" c) ","")
    }
    if(this.msaTemplateOnBrowser.includes(" d) ")==true) {
      this.msaTemplateOnBrowser=this.msaTemplateOnBrowser.replace(" d) ","")
    }
    if(this.msaTemplateOnBrowser.includes(" e) ")==true) {
      this.msaTemplateOnBrowser=this.msaTemplateOnBrowser.replace(" e) ","")
    }
    if(this.msaTemplateOnBrowser.includes(" f) ")==true) {
      this.msaTemplateOnBrowser=this.msaTemplateOnBrowser.replace(" f) ","")
    }
    if(this.msaTemplateOnBrowser.includes(" g) ")==true) {
      this.msaTemplateOnBrowser=this.msaTemplateOnBrowser.replace(" g) ","")
    }
    // console.log('1',this.msaTemplateOnBrowser);
    if (this.msaTemplateOnBrowser.includes(PaymentTerms_Selected.NotSelected+PaymentTerms_Selected.Net_20_With_Two_Percent_Fees_Selected) == true) {
      this.msaTemplateOnBrowser = this.msaTemplateOnBrowser.replace(PaymentTerms_Selected.NotSelected+PaymentTerms_Selected.Net_20_With_Two_Percent_Fees_Selected,PaymentTerms_Default.Net_20_With_Two_Percent_Fees_Default);
    }
    if (this.msaTemplateOnBrowser.includes(PaymentTerms_Selected.NotSelected+PaymentTerms_Selected.Net_20_Selected) == true) {
      this.msaTemplateOnBrowser = this.msaTemplateOnBrowser.replace(PaymentTerms_Selected.NotSelected+PaymentTerms_Selected.Net_20_Selected,PaymentTerms_Default.Net_20_Default);
    }
    if (this.msaTemplateOnBrowser.includes(PaymentTerms_Selected.NotSelected+PaymentTerms_Selected.Net_30_With_One_Percent_Fees_Selected) == true) {
      this.msaTemplateOnBrowser = this.msaTemplateOnBrowser.replace(PaymentTerms_Selected.NotSelected+PaymentTerms_Selected.Net_30_With_One_Percent_Fees_Selected,PaymentTerms_Default.Net_30_With_One_Percent_Fees_Default);
    }
    if (this.msaTemplateOnBrowser.includes(PaymentTerms_Selected.NotSelected+PaymentTerms_Selected.Net_30_With_Two_Percent_Fees_Selected) == true) {
      this.msaTemplateOnBrowser = this.msaTemplateOnBrowser.replace(PaymentTerms_Selected.NotSelected+PaymentTerms_Selected.Net_30_With_Two_Percent_Fees_Selected,PaymentTerms_Default.Net_30_With_Two_Percent_Fees_Default);
    }
    if (this.msaTemplateOnBrowser.includes(PaymentTerms_Selected.NotSelected+PaymentTerms_Selected.Net_35_Selected) == true) {
      this.msaTemplateOnBrowser = this.msaTemplateOnBrowser.replace(PaymentTerms_Selected.NotSelected+PaymentTerms_Selected.Net_35_Selected,PaymentTerms_Default.Net_35_Default);
    }
    if (this.msaTemplateOnBrowser.includes(PaymentTerms_Selected.NotSelected+PaymentTerms_Selected.Net_30_Without_Fees_Selected) == true) {
      this.msaTemplateOnBrowser = this.msaTemplateOnBrowser.replace(PaymentTerms_Selected.NotSelected+PaymentTerms_Selected.Net_30_Without_Fees_Selected,PaymentTerms_Default.Net_30_Without_Fees_Default);
    }
    if (this.msaTemplateOnBrowser.includes(PaymentTerms_Selected.NotSelected+PaymentTerms_Selected.Net_45_Without_Fees_Selected) == true) {
      this.msaTemplateOnBrowser = this.msaTemplateOnBrowser.replace(PaymentTerms_Selected.NotSelected+PaymentTerms_Selected.Net_45_Without_Fees_Selected,PaymentTerms_Default.Net_45_Without_Fees_Default);
    }
    if (this.msaTemplateOnBrowser.includes(PaymentTerms_Selected.Selected+PaymentTerms_Selected.Net_20_With_Two_Percent_Fees_Selected) == true) {
      this.msaTemplateOnBrowser = this.msaTemplateOnBrowser.replace(PaymentTerms_Selected.Selected+PaymentTerms_Selected.Net_20_With_Two_Percent_Fees_Selected,PaymentTerms_Default.Net_20_With_Two_Percent_Fees_Default);
    }
    if (this.msaTemplateOnBrowser.includes(PaymentTerms_Selected.Selected+PaymentTerms_Selected.Net_20_Selected) == true) {
      this.msaTemplateOnBrowser = this.msaTemplateOnBrowser.replace(PaymentTerms_Selected.Selected+PaymentTerms_Selected.Net_20_Selected,PaymentTerms_Default.Net_20_Default);
    }
    if (this.msaTemplateOnBrowser.includes(PaymentTerms_Selected.Selected+PaymentTerms_Selected.Net_30_With_One_Percent_Fees_Selected) == true) {
      this.msaTemplateOnBrowser = this.msaTemplateOnBrowser.replace(PaymentTerms_Selected.Selected+PaymentTerms_Selected.Net_30_With_One_Percent_Fees_Selected,PaymentTerms_Default.Net_30_With_One_Percent_Fees_Default);
    }
    if (this.msaTemplateOnBrowser.includes(PaymentTerms_Selected.Selected+PaymentTerms_Selected.Net_30_With_Two_Percent_Fees_Selected) == true) {
      this.msaTemplateOnBrowser = this.msaTemplateOnBrowser.replace(PaymentTerms_Selected.Selected+PaymentTerms_Selected.Net_30_With_Two_Percent_Fees_Selected,PaymentTerms_Default.Net_30_With_Two_Percent_Fees_Default);
    }
    if (this.msaTemplateOnBrowser.includes(PaymentTerms_Selected.Selected+PaymentTerms_Selected.Net_35_Selected) == true) {
      this.msaTemplateOnBrowser = this.msaTemplateOnBrowser.replace(PaymentTerms_Selected.Selected+PaymentTerms_Selected.Net_35_Selected,PaymentTerms_Default.Net_35_Default);
    }
    if (this.msaTemplateOnBrowser.includes(PaymentTerms_Selected.Selected+PaymentTerms_Selected.Net_30_Without_Fees_Selected) == true) {
      this.msaTemplateOnBrowser = this.msaTemplateOnBrowser.replace(PaymentTerms_Selected.Selected+PaymentTerms_Selected.Net_30_Without_Fees_Selected,PaymentTerms_Default.Net_30_Without_Fees_Default);
    }
    if (this.msaTemplateOnBrowser.includes(PaymentTerms_Selected.Selected+PaymentTerms_Selected.Net_45_Without_Fees_Selected) == true) {
      this.msaTemplateOnBrowser = this.msaTemplateOnBrowser.replace(PaymentTerms_Selected.Selected+PaymentTerms_Selected.Net_45_Without_Fees_Selected,PaymentTerms_Default.Net_45_Without_Fees_Default);
    }
    if (this.msaTypeIdOnEdit == MSAType.Standard1099) {
      
      if (event.value.lookupOrder == PaymentTerms.Net_20_With_Two_Percent_Fees) {
        if (this.msaTemplateOnBrowser.includes(PaymentTerms_Default.Net_20_With_Two_Percent_Fees_Default) == true) {
          this.msaTemplateOnBrowser = this.msaTemplateOnBrowser.replace(PaymentTerms_Default.Net_20_With_Two_Percent_Fees_Default, PaymentTerms_Selected.Selected +' a) '+ PaymentTerms_Selected.Net_20_With_Two_Percent_Fees_Selected);
          this.paymentTermsConfirmationMessage = PaymentTerms_Selected.Net_20_With_Two_Percent_Fees_Selected.replace('<strong>YES -</strong> within','Within');
        }
        if (this.msaTemplateOnBrowser.includes(PaymentTerms_Default.Net_30_With_One_Percent_Fees_Default) == true) {
          this.msaTemplateOnBrowser = this.msaTemplateOnBrowser.replace(PaymentTerms_Default.Net_30_With_One_Percent_Fees_Default, PaymentTerms_Selected.NotSelected +' b) '+ PaymentTerms_Selected.Net_30_With_One_Percent_Fees_Selected);
        }
        if (this.msaTemplateOnBrowser.includes(PaymentTerms_Default.Net_45_Without_Fees_Default) == true) {
          this.msaTemplateOnBrowser = this.msaTemplateOnBrowser.replace(PaymentTerms_Default.Net_45_Without_Fees_Default, PaymentTerms_Selected.NotSelected +' c) '+ PaymentTerms_Selected.Net_45_Without_Fees_Selected);
        }
      }
      else if (event.value.lookupOrder == PaymentTerms.Net_30_With_One_Percent_Fees) {
        if (this.msaTemplateOnBrowser.includes(PaymentTerms_Default.Net_20_With_Two_Percent_Fees_Default) == true) {
          this.msaTemplateOnBrowser = this.msaTemplateOnBrowser.replace(PaymentTerms_Default.Net_20_With_Two_Percent_Fees_Default, PaymentTerms_Selected.NotSelected +' a) '+  PaymentTerms_Selected.Net_20_With_Two_Percent_Fees_Selected);
        }
        if (this.msaTemplateOnBrowser.includes(PaymentTerms_Default.Net_30_With_One_Percent_Fees_Default) == true) {
          this.msaTemplateOnBrowser = this.msaTemplateOnBrowser.replace(PaymentTerms_Default.Net_30_With_One_Percent_Fees_Default, PaymentTerms_Selected.Selected +' b) '+ PaymentTerms_Selected.Net_30_With_One_Percent_Fees_Selected );
          this.paymentTermsConfirmationMessage = PaymentTerms_Selected.Net_30_With_One_Percent_Fees_Selected.replace('<strong>YES -</strong> within','Within');
        }
        if (this.msaTemplateOnBrowser.includes(PaymentTerms_Default.Net_45_Without_Fees_Default) == true) {
          this.msaTemplateOnBrowser = this.msaTemplateOnBrowser.replace(PaymentTerms_Default.Net_45_Without_Fees_Default, PaymentTerms_Selected.NotSelected +' c) '+ PaymentTerms_Selected.Net_45_Without_Fees_Selected);
        }
      }
      else if (event.value.lookupOrder == PaymentTerms.Net_45_Without_Fees) {
        if (this.msaTemplateOnBrowser.includes(PaymentTerms_Default.Net_20_With_Two_Percent_Fees_Default) == true) {
          this.msaTemplateOnBrowser = this.msaTemplateOnBrowser.replace(PaymentTerms_Default.Net_20_With_Two_Percent_Fees_Default, PaymentTerms_Selected.NotSelected +' a) '+ PaymentTerms_Selected.Net_20_With_Two_Percent_Fees_Selected);
        }
        if (this.msaTemplateOnBrowser.includes(PaymentTerms_Default.Net_30_With_One_Percent_Fees_Default) == true) {
          this.msaTemplateOnBrowser = this.msaTemplateOnBrowser.replace(PaymentTerms_Default.Net_30_With_One_Percent_Fees_Default, PaymentTerms_Selected.NotSelected +' b) '+ PaymentTerms_Selected.Net_30_With_One_Percent_Fees_Selected);
        }
        if (this.msaTemplateOnBrowser.includes(PaymentTerms_Default.Net_45_Without_Fees_Default) == true) {
          this.msaTemplateOnBrowser = this.msaTemplateOnBrowser.replace(PaymentTerms_Default.Net_45_Without_Fees_Default, PaymentTerms_Selected.Selected +' c) '+ PaymentTerms_Selected.Net_45_Without_Fees_Selected);
          this.paymentTermsConfirmationMessage = PaymentTerms_Selected.Net_45_Without_Fees_Selected.replace('<strong>YES -</strong> within','Within');
        }
      }
    }
    else if (this.msaTypeIdOnEdit == MSAType.StandardC2C) {
      if (event.value.lookupOrder == PaymentTerms.Net_30_With_Two_Percent_Fees) {
        if (this.msaTemplateOnBrowser.includes(PaymentTerms_Default.Net_30_With_Two_Percent_Fees_Default) == true) {
          this.msaTemplateOnBrowser = this.msaTemplateOnBrowser.replace(PaymentTerms_Default.Net_30_With_Two_Percent_Fees_Default, PaymentTerms_Selected.Selected +' a) '+ PaymentTerms_Selected.Net_30_With_Two_Percent_Fees_Selected);
          this.paymentTermsConfirmationMessage = PaymentTerms_Selected.Net_30_With_Two_Percent_Fees_Selected.replace('<strong>YES -</strong> within','Within');
        }
        if (this.msaTemplateOnBrowser.includes(PaymentTerms_Default.Net_45_Without_Fees_Default) == true) {
          this.msaTemplateOnBrowser = this.msaTemplateOnBrowser.replace(PaymentTerms_Default.Net_45_Without_Fees_Default, PaymentTerms_Selected.NotSelected + ' b) '+ PaymentTerms_Selected.Net_45_Without_Fees_Selected);

        }
      }
      else if (event.value.lookupOrder == PaymentTerms.Net_45_Without_Fees) {
        if (this.msaTemplateOnBrowser.includes(PaymentTerms_Default.Net_30_With_Two_Percent_Fees_Default) == true) {
          this.msaTemplateOnBrowser = this.msaTemplateOnBrowser.replace(PaymentTerms_Default.Net_30_With_Two_Percent_Fees_Default, PaymentTerms_Selected.NotSelected + ' a) ' + PaymentTerms_Selected.Net_30_With_Two_Percent_Fees_Selected);
        }
        if (this.msaTemplateOnBrowser.includes(PaymentTerms_Default.Net_45_Without_Fees_Default) == true) {
          this.msaTemplateOnBrowser = this.msaTemplateOnBrowser.replace(PaymentTerms_Default.Net_45_Without_Fees_Default, PaymentTerms_Selected.Selected + ' b) ' + PaymentTerms_Selected.Net_45_Without_Fees_Selected);
          this.paymentTermsConfirmationMessage = PaymentTerms_Selected.Net_45_Without_Fees_Selected.replace('<strong>YES -</strong> within','Within');
        }
      }
    }
    else if (this.msaTypeIdOnEdit == MSAType.SpecialC2C || MSAType.Special1099) {
      const ptValueArray = Object.values(PaymentTerms);
      // console.log('pt',ptValueArray);
      const bulletin = ["a) ", "b) ", "c) ", "d) ","e) ","f) ","g) "];
      for(var k=0;k<valuetoretain.length;k++)
      {
        if(valuetoretain[k] == PaymentTerms.Net_20)
        {
          if (event.value.lookupOrder == PaymentTerms.Net_20 && valuetoretain[k] == PaymentTerms.Net_20) {
            if (this.msaTemplateOnBrowser.includes(PaymentTerms_Default.Net_20_Default) == true) {
              var pt =PaymentTerms_Selected.Selected+' '+bulletin[k]+PaymentTerms_Selected.Net_20_Selected;
              this.msaTemplateOnBrowser = this.msaTemplateOnBrowser.replace(PaymentTerms_Default.Net_20_Default,pt);
              this.paymentTermsConfirmationMessage = PaymentTerms_Selected.Net_20_Selected.replace('<strong>YES -</strong> within','Within');

            }
          }
          else{
            // console.log('dfdfd');
            if (this.msaTemplateOnBrowser.includes(PaymentTerms_Default.Net_20_Default) == true) {
              var pt =PaymentTerms_Selected.NotSelected+' '+bulletin[k]+PaymentTerms_Selected.Net_20_Selected;
              this.msaTemplateOnBrowser = this.msaTemplateOnBrowser.replace(PaymentTerms_Default.Net_20_Default,pt);
            }
          }
        }
        else if(valuetoretain[k] == PaymentTerms.Net_20_With_Two_Percent_Fees)
        {
          if (event.value.lookupOrder == PaymentTerms.Net_20_With_Two_Percent_Fees && valuetoretain[k] == PaymentTerms.Net_20_With_Two_Percent_Fees) {  
            if (this.msaTemplateOnBrowser.includes(PaymentTerms_Default.Net_20_With_Two_Percent_Fees_Default) == true) {
              var pt =PaymentTerms_Selected.Selected+' '+bulletin[k]+PaymentTerms_Selected.Net_20_With_Two_Percent_Fees_Selected;
              this.msaTemplateOnBrowser = this.msaTemplateOnBrowser.replace(PaymentTerms_Default.Net_20_With_Two_Percent_Fees_Default,pt);
              this.paymentTermsConfirmationMessage = PaymentTerms_Selected.Net_20_With_Two_Percent_Fees_Selected.replace('<strong>YES -</strong> within','Within');
            }
          }
          else{
            if (this.msaTemplateOnBrowser.includes(PaymentTerms_Default.Net_20_With_Two_Percent_Fees_Default) == true) {
              var pt =PaymentTerms_Selected.NotSelected+' '+bulletin[k]+PaymentTerms_Selected.Net_20_With_Two_Percent_Fees_Selected;
              this.msaTemplateOnBrowser = this.msaTemplateOnBrowser.replace(PaymentTerms_Default.Net_20_With_Two_Percent_Fees_Default,pt);
            }
          }
        }
        else if(valuetoretain[k] == PaymentTerms.Net_30_With_One_Percent_Fees)
        {
          if (event.value.lookupOrder == PaymentTerms.Net_30_With_One_Percent_Fees && valuetoretain[k] == PaymentTerms.Net_30_With_One_Percent_Fees) {
            if (this.msaTemplateOnBrowser.includes(PaymentTerms_Default.Net_30_With_One_Percent_Fees_Default) == true) {
              var pt =PaymentTerms_Selected.Selected+' '+bulletin[k]+PaymentTerms_Selected.Net_30_With_One_Percent_Fees_Selected;
              this.msaTemplateOnBrowser = this.msaTemplateOnBrowser.replace(PaymentTerms_Default.Net_30_With_One_Percent_Fees_Default,pt);
              this.paymentTermsConfirmationMessage = PaymentTerms_Selected.Net_30_With_One_Percent_Fees_Selected.replace('<strong>YES -</strong> within','Within');

            }
          }
          else{
            if (this.msaTemplateOnBrowser.includes(PaymentTerms_Default.Net_30_With_One_Percent_Fees_Default) == true) {
              var pt =PaymentTerms_Selected.NotSelected+' '+bulletin[k]+PaymentTerms_Selected.Net_30_With_One_Percent_Fees_Selected;
              this.msaTemplateOnBrowser = this.msaTemplateOnBrowser.replace(PaymentTerms_Default.Net_30_With_One_Percent_Fees_Default,pt);
            }
          }
        }
        else if(valuetoretain[k] == PaymentTerms.Net_30_With_Two_Percent_Fees)
        {
          if (event.value.lookupOrder == PaymentTerms.Net_30_With_Two_Percent_Fees && valuetoretain[k] == PaymentTerms.Net_30_With_Two_Percent_Fees) {
            if (this.msaTemplateOnBrowser.includes(PaymentTerms_Default.Net_30_With_Two_Percent_Fees_Default) == true) {
              var pt =PaymentTerms_Selected.Selected+' '+bulletin[k]+PaymentTerms_Selected.Net_30_With_Two_Percent_Fees_Selected;
              this.msaTemplateOnBrowser = this.msaTemplateOnBrowser.replace(PaymentTerms_Default.Net_30_With_Two_Percent_Fees_Default,pt);
              this.paymentTermsConfirmationMessage = PaymentTerms_Selected.Net_30_With_Two_Percent_Fees_Selected.replace('<strong>YES -</strong> within','Within');
            }
          }
          else{
            if (this.msaTemplateOnBrowser.includes(PaymentTerms_Default.Net_30_With_Two_Percent_Fees_Default) == true) {
              var pt =PaymentTerms_Selected.NotSelected+' '+bulletin[k]+PaymentTerms_Selected.Net_30_With_Two_Percent_Fees_Selected;
              this.msaTemplateOnBrowser = this.msaTemplateOnBrowser.replace(PaymentTerms_Default.Net_30_With_Two_Percent_Fees_Default,pt);
            }
          }
        }
        else if(valuetoretain[k] == PaymentTerms.Net_30_Without_Fees)
        {
          if (event.value.lookupOrder == PaymentTerms.Net_30_Without_Fees && valuetoretain[k] == PaymentTerms.Net_30_Without_Fees) {
            if (this.msaTemplateOnBrowser.includes(PaymentTerms_Default.Net_30_Without_Fees_Default) == true) {
              var pt =PaymentTerms_Selected.Selected+' '+bulletin[k]+PaymentTerms_Selected.Net_30_Without_Fees_Selected;
              this.msaTemplateOnBrowser = this.msaTemplateOnBrowser.replace(PaymentTerms_Default.Net_30_Without_Fees_Default,pt);
              this.paymentTermsConfirmationMessage = PaymentTerms_Selected.Net_30_Without_Fees_Selected.replace('<strong>YES -</strong> within','Within');
            }
          }
          else{
            if (this.msaTemplateOnBrowser.includes(PaymentTerms_Default.Net_30_Without_Fees_Default) == true) {
              var pt =PaymentTerms_Selected.NotSelected+' '+bulletin[k]+PaymentTerms_Selected.Net_30_Without_Fees_Selected;
              this.msaTemplateOnBrowser = this.msaTemplateOnBrowser.replace(PaymentTerms_Default.Net_30_Without_Fees_Default,pt);
            }
          }
        }
        else if(valuetoretain[k] == PaymentTerms.Net_35)
        {
          if (event.value.lookupOrder == PaymentTerms.Net_35 && valuetoretain[k] == PaymentTerms.Net_35) {
            if (this.msaTemplateOnBrowser.includes(PaymentTerms_Default.Net_35_Default) == true) {
              var pt =PaymentTerms_Selected.Selected+' '+bulletin[k]+PaymentTerms_Selected.Net_35_Selected;
              this.msaTemplateOnBrowser = this.msaTemplateOnBrowser.replace(PaymentTerms_Default.Net_35_Default,pt);
              this.paymentTermsConfirmationMessage = PaymentTerms_Selected.Net_35_Selected.replace('<strong>YES -</strong> within','Within');
            }
          }
          else{
            if (this.msaTemplateOnBrowser.includes(PaymentTerms_Default.Net_35_Default) == true) {
              var pt =PaymentTerms_Selected.NotSelected+' '+bulletin[k]+PaymentTerms_Selected.Net_35_Selected;
              this.msaTemplateOnBrowser = this.msaTemplateOnBrowser.replace(PaymentTerms_Default.Net_35_Default,pt);
            }
          }
        }
        else if(valuetoretain[k] == PaymentTerms.Net_45_Without_Fees)
        {
          if (event.value.lookupOrder == PaymentTerms.Net_45_Without_Fees && valuetoretain[k] == PaymentTerms.Net_45_Without_Fees) {
            if (this.msaTemplateOnBrowser.includes(PaymentTerms_Default.Net_45_Without_Fees_Default) == true) {
              var pt =PaymentTerms_Selected.Selected+' '+bulletin[k]+PaymentTerms_Selected.Net_45_Without_Fees_Selected;
              this.msaTemplateOnBrowser = this.msaTemplateOnBrowser.replace(PaymentTerms_Default.Net_45_Without_Fees_Default,pt);
              this.paymentTermsConfirmationMessage = PaymentTerms_Selected.Net_45_Without_Fees_Selected.replace('<strong>YES -</strong> within','Within');
            }
          }
          else{
            if (this.msaTemplateOnBrowser.includes(PaymentTerms_Default.Net_45_Without_Fees_Default) == true) {
              var pt =PaymentTerms_Selected.NotSelected+' '+bulletin[k]+PaymentTerms_Selected.Net_45_Without_Fees_Selected;
              this.msaTemplateOnBrowser = this.msaTemplateOnBrowser.replace(PaymentTerms_Default.Net_45_Without_Fees_Default,pt);
            }
          }
        }
        
      }
     
    }

    this.isPaymentTermsEnable = true;
  }


  onlyNumbers($event) {
    let regex: RegExp = new RegExp(/^[0-9]{1,}$/g);
    let specialKeys: Array<string> = ['.', 'Backspace', 'Tab', 'End', 'Home', 'ArrowRight', 'ArrowLeft'];
    if (specialKeys.indexOf($event.key) !== -1) {
      return;
    } else {
      if (regex.test($event.key)) {
        return true;
      } else {
        return false;
      }
    }
  }

  faxUniqueNumbers(event) {
    let avoidString: Array<string> = ['(000) 000-0000', '(111) 111-1111', '(222) 222-2222', '(222) 222-2222', '(333) 333-3333', '(444) 444-4444', '(555) 555-5555', '(666) 666-6666', '(777) 777-7777', '(888) 888-8888', '(999) 999-9999'];
    let name = event.target.value;
    if (name.length >= 1 && name.length < 14) {
      this.isFaxNumberValid = true;
    }
    else {
      this.isFaxNumberValid = false;
    }
    if (avoidString.includes(name)) {
      this.isFaxUniqueNumbers = true;
    }
    else {
      this.isFaxUniqueNumbers = false;
    }
  }

  vendorPhoneUniqueNumbers(event) {
    let avoidString: Array<string> = ['(000) 000-0000', '(111) 111-1111', '(222) 222-2222', '(222) 222-2222', '(333) 333-3333', '(444) 444-4444', '(555) 555-5555', '(666) 666-6666', '(777) 777-7777', '(888) 888-8888', '(999) 999-9999'];
    let name = event.target.value;
    if (name.length >= 1 && name.length < 14) {
      this.isVendorPhoneNumberValid = true;
    }
    else {
      this.isVendorPhoneNumberValid = false;
    }
    if (avoidString.includes(name)) {
      this.isVendorPhoneUniqueNumbers = true;
    }
    else {
      this.isVendorPhoneUniqueNumbers = false;
    }

    if (avoidString.includes(name) || name.length < 14) {
      this.vendorPhoneExtDisabled = true;
    }
    else {
      this.vendorPhoneExtDisabled = false;
    }
  }

  enableZipCodeExt() {
    this.zipCode = this.companyProfileEditForm.controls['zipCode'].value;
    this.disabled = false;
    if (this.zipCode == '') {
      this.disabled = true;
      this.companyProfileEditForm.controls['zipCodeExt'].setValue = undefined;
    }
  }
  getStates() {
    this.sharedService.getStates().subscribe((data: any) => {
      this.states = data;
    });
  }

  getStateOnChange(event) {
    this.isStateEnable = true;
    this.stateId = event.value.stateId;
    this.stateName = event.value.stateName;
    this.stateCode = event.value.stateCode;
  }

  getCountries() {
    this.sharedService.getCountries().subscribe((data: any) => {
      console.log(data);
      this.countries = data;
    });
  }
  preventSqlComments(event) {
    let avoidString: Array<string> = ['DELETE', 'ADD', 'UPDATE', 'TABLE', 'INSERT'];
    let name = event.target.value.toUpperCase();
    if (avoidString.includes(name)) {
      this.isSqlComments = true;
    }
    else {
      this.isSqlComments = false;
    }
  }
  preventSqlCommentsOnFirstName(event) {
    let avoidString: Array<string> = ['DELETE', 'ADD', 'UPDATE', 'TABLE', 'INSERT'];
    let name = event.target.value.toUpperCase();
    if (avoidString.includes(name)) {
      this.isSqlCommentsOnFirstName = true;
    }
    else {
      this.isSqlCommentsOnFirstName = false;
    }
  }

  preventSqlCommentsOnMiddleName(event) {
    let avoidString: Array<string> = ['DELETE', 'ADD', 'UPDATE', 'TABLE', 'INSERT'];
    let name = event.target.value.toUpperCase();
    if (avoidString.includes(name)) {
      this.isSqlCommentsOnMiddleName = true;
    }
    else {
      this.isSqlCommentsOnMiddleName = false;
    }
  }

  preventSqlCommentsOnLastName(event) {
    let avoidString: Array<string> = ['DELETE', 'ADD', 'UPDATE', 'TABLE', 'INSERT'];
    let name = event.target.value.toUpperCase();
    if (avoidString.includes(name)) {
      this.isSqlCommentsOnLastName = true;
    }
    else {
      this.isSqlCommentsOnLastName = false;
    }
  }
  onVendorAvailabilityCheck() {

    this.taxIdNumber = this.companyProfileEditForm.controls['taxIdNumber'].value;
    this.vendorName = this.companyProfileEditForm.controls['vendorName'].value;
    this.taxIdNumberLength = this.companyProfileEditForm.controls['taxIdNumber'].value.length;
    if (this.vendorName != '') {
      this.registerService.onVendorNameCheck(this.vendorName).subscribe((data: any) => {
        this.vendorNameAvail = data;
      });
    }
    if (this.taxIdNumberLength == 9 && this.taxIdNumber != '' && this.vendorName != '') {
      this.registerService.onVendorAvailabilityCheck(this.vendorName, this.taxIdNumber, 0).subscribe((data: any) => {
        if (data == true) {
          this.isVendorAvailability = false;
          this.messageService.add({ key: 'bc', severity: 'error', summary: 'Error', detail: 'Already company exists in this State with this TaxId' });
        }
        else {
          this.isVendorAvailability = true;
          this.isSaveAvailable = true;
        }

      });
    }

    else if (this.taxIdNumberLength < 9) {
      this.isSaveAvailable = false;
    }
  }
  onAdminEmailAvailabilityCheck() {
    this.vendorAdminEmail = this.companyProfileEditForm.controls['vendorAdminEmail'].value;
    if (this.vendorAdminEmail != '') {
      this.vendorAdminEmail = this.vendorAdminEmail.trim();
      this.registerService.onVendorEmailCheck(this.vendorAdminEmail).subscribe((data: any) => {
        this.adminEmailAvail = data;
      });
    }
  }
  onCheckTaxIdNumber() {
    var taxIdNumber = this.companyProfileEditForm.controls['taxIdNumber'].value;
    var taxIdNumberLength = this.companyProfileEditForm.controls['taxIdNumber'].value.length;
    if (taxIdNumberLength == 9) {
      this.registerService.onTaxIdNumberCheck(taxIdNumber).subscribe((data: any) => {
        this.taxIdAvail = data;
      });
    }
  }
  adminPhoneUniqueNumbers(event) {
    let avoidString: Array<string> = ['(000) 000-0000', '(111) 111-1111', '(222) 222-2222', '(222) 222-2222', '(333) 333-3333', '(444) 444-4444', '(555) 555-5555', '(666) 666-6666', '(777) 777-7777', '(888) 888-8888', '(999) 999-9999'];
    let name = event.target.value;
    if (name.length >= 1 && name.length < 14) {
      this.isAdminPhoneNumberValid = true;
    }
    else {
      this.isAdminPhoneNumberValid = false;
    }
    if (avoidString.includes(name)) {
      this.isAdminPhoneUniqueNumbers = true;
    }
    else {
      this.isAdminPhoneUniqueNumbers = false;
    }

    if (avoidString.includes(name) || name.length < 14) {
      this.adminPhoneExtDisabled = true;
    }
    else {
      this.adminPhoneExtDisabled = false;
    }
  }
  companyProfileNext() {
    if(!this.isVendorAvailable)
    {
      this.tabIndex = this.tabIndex + 1;
      var MSAOnPreview = this.msaTemplateOnBrowser.replace(/<p>/g, '<div>').replace(/<\/p>/g, '</div>');
      this.msaTemplateOnAccordion = this.sanitizer.bypassSecurityTrustHtml(MSAOnPreview);
      this.nameOnDocument= this.companyProfileEditForm.controls['nameOnDocument'].value;
      this.signFormMSA.controls['name'].setValue(this.nameOnDocumentSubmit);
    }
    if(this.isVendorAvailable)
    {
      if(this.isVendorAvailable && this.isMSASelected)
        {
          this.tabIndex =1;
          var MSAOnPreview = this.msaTemplateOnBrowser.replace(/<p>/g, '<div>').replace(/<\/p>/g, '</div>');
          this.msaTemplateOnAccordion = this.sanitizer.bypassSecurityTrustHtml(MSAOnPreview);
          this.nameOnDocument= this.vendorDetailsForm.controls['nameOnDocument'].value;
          //this.signFormMSA.setValue({name:this.nameOnDocumentSubmit});
          this.signFormMSA.controls['name'].setValue(this.nameOnDocumentSubmit);
        }
        else if(this.isVendorAvailable && this.isPOSelected)
        {
          this.nameOnDocument= this.vendorDetailsForm.controls['nameOnDocument'].value;
          //this.signFormPO.setValue({name:this.nameOnDocumentSubmit});
          this.signFormPO.controls['name'].setValue(this.nameOnDocumentSubmit);
          this.tabIndex = this.tabIndex + 1;
          this.clearPOSign();
        }
        else if(this.isVendorAvailable && this.isNCASelected)
        {
          if(this.showNCAAccordion == true){
            this.nameOnDocument= this.vendorDetailsForm.controls['nameOnDocument'].value;
            //this.signFormNCA.setValue({name:this.nameOnDocumentSubmit});
            this.signFormNCA.controls['name'].setValue(this.nameOnDocumentSubmit);
            this.tabIndex =this.tabIndex + 1;
          this.messageService.add({severity: 'success', summary: 'Confirmed', detail: 'Details have been added successfully'});
          this.clearNCASign();
          }
          else if(this.showNCAAccordion == false){
          this.tabIndex =this.tabIndex + 2;
          this.messageService.add({severity: 'success', summary: 'Confirmed', detail: 'Details have been added successfully'});
          //this.clearNCASign();
          }
        }
        else
        {
          this.tabIndex = this.tabIndex + 1;
        }
    }
   
    
    // this.tabIndex = 6;

  }
  companyProfileSave({ value }: { value: any }) {
    this.spinner.show();
    setTimeout(() => {
      this.spinner.hide();
    }, 2000);
    //value.stateId = this.stateId;
    //value.entityTypeId = this.entityTypeId;
    if(!this.isVendorAvailable)
    {
      value = this.companyProfileEditForm.getRawValue();
      this.vendorNameToSubmit = (value.vendorName === null) ? value.vendorName : value.vendorName.trim();
      this.taxIdNumberToSubmit = value.taxIdNumber;
      this.vendorEmailIdToSubmit = (value.vendorEmailId === null) ? value.vendorEmailId : value.vendorEmailId.trim();
      this.vendorPhoneToSubmit = value.vendorPhoneNumber;
      this.vendorExtToSubmit = value.vendorPhoneExtNumber;
      this.faxNumberToSubmit = value.faxNumber;
      this.webAddressToSubmit = value.webAddress;
      this.addressLine1ToSubmit = (value.addressLine1 === null) ? value.addressLine1 : value.addressLine1.trim();
      this.addressLine2ToSubmit = (value.addressLine2 === null || value.addressLine2 == undefined) ? value.addressLine2 : value.addressLine2.trim();
      this.cityToSubmit = (value.city === null) ? value.city : value.city.trim();
      this.zipCodeToSubmit = value.zipCode;
      this.zipCodeExtToSubmit = value.zipCodeExt;
      this.firstNameToSubmit = (value.vendorAdminFirstName === null) ? value.vendorAdminFirstName : value.vendorAdminFirstName.trim();
      this.middleNameToSubmit = (value.vendorAdminMiddleName === null || value.vendorAdminMiddleName == undefined) ? value.vendorAdminMiddleName : value.vendorAdminMiddleName.trim();
      this.lastNameToSubmit = (value.vendorAdminLastName === null) ? value.vendorAdminLastName : value.vendorAdminLastName.trim();
      this.adminEmailToSubmit = (value.vendorAdminEmail === null) ? value.vendorAdminEmail : value.vendorAdminEmail.trim();
      this.adminPhoneToSubmit = value.vendorAdminPhone;
      this.adminExtToSubmit = value.vendorAdminPhoneExt;
      this.ssnNumberToSubmit=value.ssnNumber;
      this.nameOnDocumentSubmit= value.nameOnDocument;
      this.fullAddress = this.addressLine1ToSubmit +', '+ this.cityToSubmit +', '+ this.stateName + ", " + this.zipCodeToSubmit;
      this.companyProfileDDForm.controls['companyName'].setValue(this.vendorNameToSubmit);
      this.companyProfileDDForm.controls['address'].setValue(this.fullAddress);
      this.companyProfileDDForm.controls['signature'].setValue(this.nameOnDocumentSubmit);

      const fullName = [this.firstNameToSubmit, this.middleNameToSubmit, this.lastNameToSubmit]
      .filter(name => !!name && name.trim().length > 0) // remove null/undefined/empty strings
      .join(' ');
      this.companyProfileW9Form.controls['name'].setValue(fullName);
      this.companyProfileW9Form.controls['address'].setValue(this.addressLine1ToSubmit);
      this.companyProfileW9Form.controls['cityZipState'].setValue(this.cityToSubmit +', '+ this.stateName + ", " + this.zipCodeToSubmit); 
      this.companyProfileW9Form.controls['signature'].setValue(this.nameOnDocumentSubmit);

      this.companyProfileI9Form.controls['lastName'].setValue(this.lastNameToSubmit);
      this.companyProfileI9Form.controls['firstName'].setValue(this.firstNameToSubmit);
      this.companyProfileI9Form.controls['middleName'].setValue(this.middleNameToSubmit);
      this.companyProfileI9Form.controls['address'].setValue(this.addressLine1ToSubmit);
      this.companyProfileI9Form.controls['cityOrTown'].setValue(this.cityToSubmit);
      this.companyProfileI9Form.controls['state'].setValue(this.stateCode);
      this.companyProfileI9Form.controls['zip'].setValue(this.zipCodeToSubmit);
      //this.companyProfileI9Form.controls['ssn'].setValue(this.ssnNumberToSubmit);
      this.companyProfileI9Form.controls['emailId'].setValue(this.adminEmailToSubmit);
      this.companyProfileI9Form.controls['telePhoneNo'].setValue(this.adminPhoneToSubmit);
      this.companyProfileI9Form.controls['signature'].setValue(this.nameOnDocumentSubmit);
    }
    else if(this.isVendorAvailable)
    {
      value = this.vendorDetailsForm.getRawValue();
      this.vendorNameToSubmit = (value.vendorName === null) ? value.vendorName : value.vendorName.trim();
      this.taxIdNumberToSubmit = value.taxIdNumber;
      this.ssnNumberToSubmit=value.ssnNumber;
      this.nameOnDocumentSubmit= value.nameOnDocument;
      this.addressLine1ToSubmit = (value.addressLine1 === null) ? value.addressLine1 : value.addressLine1.trim();
      this.taxIdNumberToSubmit = value.taxIdNumber;
      this.ssnNumberToSubmit=value.ssnNumber;

      const matches = this.states.filter((e:any)=>e.stateName == this.stateName);
      this.stateCode = matches.length ? matches[0].stateCode : null;
      this.companyProfileDDForm.controls['signature'].setValue(this.nameOnDocumentSubmit);
      this.companyProfileW9Form.controls['signature'].setValue(this.nameOnDocumentSubmit);
      this.companyProfileI9Form.controls['signature'].setValue(this.nameOnDocumentSubmit);
      this.companyProfileI9Form.controls['state'].setValue(this.stateCode);
    }
    
    //if (this.paymentTermsId != undefined) {
    // value.paymentTermsId = this.paymentTermsId;
    this.hasCompanyProfileCompleted = true;
    // console.log('has profile step completed', this.hasCompanyProfileCompleted);
    this.messageService.add({severity: 'success', summary: 'Confirmed', detail: 'Details have been added successfully'})
    // }
    this.scrollToTop(0);
  }

  // emailValidator(entity): ValidatorFn {
  //   return (control: AbstractControl): { [key: string]: any } => {
  //     if (/^[-!#$%&'*+\/0-9=?A-Z^_a-z{|}~](\.?[-!#$%&'*+\/0-9=?A-Z^_a-z`{|}~])*@[a-zA-Z0-9](-*\.?[a-zA-Z0-9])*\.[a-zA-Z](-?[a-zA-Z0-9])+$/.test(control.value)) {
  //       var domainName = control.value.split('@')[1].split('.')[0];

  //       if (entity == 'Individual') {
  //         if (this.allowedEmailList.includes(domainName) == false) {
  //           return { 'emailEntityInvalid': true };
  //         }
  //       }

  //       if (entity != 'Others') {
  //         if (this.allowedEmailList.includes(domainName) == true) {
  //           this.confirmationService.confirm({
  //             key:'businessEmail',
  //            //message: '<center>Please verify the email entered on the company profile is</center><center>'+' '+this.emailId.bold()+'.</center><center> You cannot change this email address after the save.</center><center>Select <strong>YES</strong> to continue or <strong>NO </strong>to go back and edit the email address',
  //            message: '<center> You have entered free service email address, please provide a business/work email address if available. </center>',
  //            accept: () => {
  //              this.emailEntityInvalid = true;
  //              return { 'emailEntityInvalid': true };
  //            },
  //            reject:() =>{
  //              this.emailEntityInvalid = false;
  //            }});


  //         }
  //         else {
  //           this.emailEntityInvalid = false;
  //         }
  //       }
  //     } 
  //     // else {
  //     //   if (control.value.length > 0) {
  //     //     //this.emailInvalid = true;
  //     //     console.log('ertr',this.emailInvalid);
  //     //     return { 'emailInvalid': true };
  //     //   }
  //     //   else {
  //     //     console.log('sjkd',this.emailInvalid);
  //     //     this.emailInvalid = false;
  //     //   }
  //     // }
  //   }

  // }
  emailValidator(entity): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } => {
      
    if(control.value != this.vendorAdminEmail)
    {
      if (/^[-!#$%&'*+\/0-9=?A-Z^_a-z{|}~](\.?[-!#$%&'*+\/0-9=?A-Z^_a-z`{|}~])*@[a-zA-Z0-9](-*\.?[a-zA-Z0-9])*\.[a-zA-Z](-?[a-zA-Z0-9])+$/.test(control.value)) {
        var domainName = control.value.split('@')[1].split('.')[0];

        if (entity == 'Individual') {
          if (this.allowedEmailList.includes(domainName) == false) {
            return { 'emailEntityInvalid': true };
          }
        }

        else {
          if (this.allowedEmailList.includes(domainName) == true) {
            this.confirmationService.confirm({
              key:'businessEmail',
             //message: '<center>Please verify the email entered on the company profile is</center><center>'+' '+this.emailId.bold()+'.</center><center> You cannot change this email address after the save.</center><center>Select <strong>YES</strong> to continue or <strong>NO </strong>to go back and edit the email address',
             message: '<center> You have entered free service email address, please provide a business/work email address if available. </center>',
             accept: () => {
               this.emailEntityInvalid = true;
               return { 'emailEntityInvalid': true };
             },
             reject:() =>{
               this.emailEntityInvalid = false;
             }});


          }
          else {
            this.emailEntityInvalid = false;
          }
        }
      }
    }
     
    }

  }
  ///end/////////company profile accordion methods/////////////////
  ////////start////////////msa section methods////////
  clear() {
    this.sig.clear();
  }
  
  undo() {
    var data = this.sig.toData();
    if (data) {
      data.pop(); // remove the last dot or line
      this.sig.fromData(data);
    }
  }
  handleChange(e){
    // if(e.index == 0){
    //   this.isSignatureTab = true;
    //   this.isTextTab = false;
    //   this.isImageUploadTab = false;
    // }
    if(e.index == 0){
      this.isTextTab = true;
      this.isSignatureTab = false;
      this.isImageUploadTab = false;
    }
    if(e.index == 1){
      this.isTextTab = false;
      this.isSignatureTab = false;
      this.isImageUploadTab = true;
    }
  }
  onImageSelect(event, file: FileList) {
    this.imageFile = event.target.value;
    this.imageFile = this.imageFile.split('\\').pop().split('/').pop();
    if (this.imageFile.split('.').pop() == 'png' || this.imageFile.split('.').pop() == 'jpg' || this.imageFile.split('.').pop() == 'jpeg') {
      this.fileToUpload = file.item(0);
      //For Image Preview
      let reader = new FileReader();
      reader.onload = (event: any) => {
        this.imageUrl = event.target.result;
      }
      //console.log(this.fileToUpload);
      reader.readAsDataURL(this.fileToUpload);
      this.uploadImageFile();
      this.defaultImage = "";
    }
    else {
      this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Please select valid file format (png,jpg,jpeg)' });
    }
  }
  
  @ViewChild('imageUpload') imagefileInput;
  uploadImageFile(): void {
    let fi = this.imagefileInput.nativeElement;
    if (fi.files && fi.files[0]) {
      this.uploadedFileMSA = fi.files[0];
      if(this.uploadedFileMSA .size> 1e+6)
      {
          //alert('1');
      }
      else{
        //alert('2');
      }
      var reader = new FileReader();
      reader.onload = (event:any) => 
      {
          this.imgBase64Path = event.target.result;
          console.log(this.imgBase64Path);
      }
      reader.readAsDataURL(fi.files[0]);
    }
  }
  
  downloadMSAPDF() {
    this.loadingSaveButton = true;
    if (this.isSignatureTab == true) {
      if (this.sig.isEmpty() == true) {
        this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Please sign the document' });
        //this.showGenerateButton = true;
        this.loadingSaveButton = false;
      }
      else if (this.sig.isEmpty() == false) {
        this.confirmationService.confirm({
          header:'MSA Confirmation - Please confirm your payment term',
          message: '<strong>'+ this.paymentTermsConfirmationMessage + '</strong>' + '<br><br><center>Please click <b>Yes</b> to confirm the payment term or click <b>No</b> to go back to the Company Profile to change the payment term</center>',
          icon:'pi pi-exclamation-triangle required-field',
          accept: () => {
            let form = this.signFormMSA.value;
            let sign = this.sig.toDataURL();
           var html=undefined;
            if(this.msaTemplateOnBrowser.includes("<p style='text-align: center'><span><b>MASTER CONTRACTOR AGREEMENT</b><span></p>"))
            {
              this.msaTemplateOnBrowser= this.msaTemplateOnBrowser.replace("<span><b>MASTER CONTRACTOR AGREEMENT</b><span>","")
              console.log(this.msaTemplateOnBrowser);
              this.msaTemplateOnBrowser = this.msaTemplateOnBrowser.replace(/<p>/g,'<div>').replace(/<\/p>/g,'</div>');
              html = htmlToPdfmake(this.msaTemplateOnBrowser, { removeExtraBlanks: true });
            }
            else if(this.msaTemplateOnBrowser.includes("<p class=\"ql-align-center\"><strong>MASTER CONTRACTOR AGREEMENT</strong></p>"))
            {
              this.msaTemplateOnBrowser= this.msaTemplateOnBrowser.replace("<strong>MASTER CONTRACTOR AGREEMENT</strong>","")
              console.log(this.msaTemplateOnBrowser);
              this.msaTemplateOnBrowser = this.msaTemplateOnBrowser.replace(/<p>/g,'<div>').replace(/<\/p>/g,'</div>');
              html = htmlToPdfmake(this.msaTemplateOnBrowser, { removeExtraBlanks: true });
            }
            else{
              this.msaTemplateOnBrowser = this.msaTemplateOnBrowser.replace(/<p>/g,'<div>').replace(/<\/p>/g,'</div>');
               html = htmlToPdfmake(this.msaTemplateOnBrowser, { removeExtraBlanks: true });
            }
            var ct: any = [];
            ct.push(' ');
            ct.push(' ');
            ct.push({
              columns: [
                {
                  width: '50%',
                  text: 'DevCare Solutions, Ltd.',
                  bold: true,
                  fontSize: 9,
                  margin: 0
                },
                {
                  width: '50%',
                  text: form.vendorName,
                  bold: true,
                  fontSize: 9,
                  margin: 0
                },
              ],
              columnGap: 180
            })
            ct.push(' ');
            ct.push({
              columns: [
      
                {
                  width: '50%',
                  text: 'Janakiram Ramakrishnan',
                  bold: true,
                  fontSize: 11
                },
                {
                  width: '50%',
                  text: form.name,
                  bold: true,
                  fontSize: 11,
                },
      
              ],
              columnGap: 180
            })
      
            ct.push(
              { canvas: [{ type: 'line', x1: 332, y1: 0, x2: 490, y2: 0, lineWidth: 0.1 }] },
              { canvas: [{ type: 'line', x1: 0, y1: 0, x2: 150, y2: 0, lineWidth: 0.1 }] }
            )
            ct.push({
              columns: [
      
                {
                  width: '50%',
                  text: 'Name (Print)',
                  fontSize: 8,
                  margin: [0, 2, 0, 0]
                },
                {
                  width: '50%',
                  text: 'Name (Print)',
                  fontSize: 8,
                  margin: [0, 2, 0, 0]
                },
      
              ],
              columnGap: 180
            })
            ct.push(' ');
            // ct.push(' ');
            ct.push({
              columns: [
      
                {
                  width: '50%',
                  text: 'HR Manager',
                  bold: true,
                  fontSize: 11
                },
                {
                  width: '50%',
                  text: form.title,
                  // text: this.datepipe.transform(new Date(), "MM/dd/yyyy"),
                  bold: true,
                  fontSize: 11
                },
      
              ],
              columnGap: 180
            })
      
            ct.push(
              // { canvas: [{ type: 'line', x1: 348, y1: 0, x2: 515, y2: 0, lineWidth: 0.1 }] },
              { canvas: [{ type: 'line', x1: 332, y1: 0, x2: 490, y2: 0, lineWidth: 0.1 }] },
              { canvas: [{ type: 'line', x1: 0, y1: 0, x2: 150, y2: 0, lineWidth: 0.1 }] }
            )
      
            ct.push({
              columns: [
      
                {
                  width: '50%',
                  text: 'Title',
                  fontSize: 8,
                  margin: [0, 2, 0, 0]
                },
                {
                  width: '50%',
                  text: 'Title',
                  fontSize: 8,
                  margin: [0, 2, 0, 0]
                },
      
              ],
              columnGap: 180
            })
            ct.push(' ');
            // ct.push(' ');
      
      
            ct.push({
              table: {
                widths: [150, 180, 150],
                body: [
                  [
                    {
                      image: 'hrsignImage',
                      width: '120'
                    },
                    {
      
                    },
                    {
                      image: 'userSignImage',
                      width: '120'
                    },
                  ],
                  [
                    {
                      text:  this.datepipe.transform(new Date(), "MM/dd/yyyy"),
                    },
                    {
      
                    },
                    {
                      text:  this.datepipe.transform(new Date(), "MM/dd/yyyy"),
                    },
                  ],
                ]
              },
              layout: 'noBorders'
            })
      
      
      
            ct.push(
              { canvas: [{ type: 'line', x1: 332, y1: 0, x2: 490, y2: 0, lineWidth: 0.1 }] },
              { canvas: [{ type: 'line', x1: 0, y1: 0, x2: 150, y2: 0, lineWidth: 0.1 }] }
            )
      
            ct.push({
              columns: [
      
                {
                  width: '50%',
                  text: 'Signature & Date',
                  fontSize: 8,
                  margin: [0, 2, 0, 0]
                },
                {
                  width: '50%',
                  text: 'Signature & Date',
                  fontSize: 8,
                  margin: [0, 2, 0, 0]
                },
      
              ],
              columnGap: 180
            })
            ct.push({
      
            });
            //let value = html.concat(html, ct)
            let value = html;
            for (let i = 0; i < ct.length; i++) {
              value.push(ct[i])
            }
      
            var docDefinition: any = {
              // pageMargins: [40, 80, 40, 60],
              pageMargins: [54, 60, 54, 55],
              header: function(currentPage, pageCount, pageSize) {
                  //if (currentPage <= 1) {
                  //    return [];
                  //}
              
                  // return {
                  //     table: {
                  //         widths: [170, 240,'*'],
                  //         body: [
                  //             [
                  //                 { image: 'logoImage',width: '100',},
                  //                 { text: 'MASTER CONTRACTOR AGREEMENT', bold:true,fontSize: 9, margin: [10, 30, 40, 10] },
                  //                 { text:''}
                  //             ],
                  //         ]
                  //     },
                  //     layout: 'noBorders',
                  //     margin: [40, 15, 10, 10]
                  // };
                  return {
                    table: {
                        widths: [120, 220, 180],
                        body: [
                            [
                              { image: 'logoDevCare',width: '100', alignment:'left', margin: [12, 0, 5, 0]},
                              { text: 'MASTER CONTRACTOR AGREEMENT', bold:true,fontSize: 9, margin: [52, 27, -100, 0] },
                              { image: 'logoCMMIISO',width: '155', alignment:'right', margin: [-6, 0, 5, 0]},
                              // { text:''},
                            ],
                        ],
                    },
                    layout: 'noBorders',
                    margin: [40, 18, 10, 10]
                };
              },
              footer: function (currentPage: any, pageCount: any) {
                return {
                  table: {
                    widths: '*',
                    body: [
                      [
                        { text: 'DevCare Solutions, Ltd.', alignment: 'left', style: 'normalText', margin: [52, 20,50, 0], aligment: 'right', italics: true },
                        { text: 'Page ' + currentPage.toString() + ' of ' + pageCount, alignment: 'right', style: 'normalText', margin: [0, 20, 53, 0], aligment: 'left', italics: true }
                      ]
                    ]
                  },
                  layout: 'noBorders'
                };
              },
              permissions: {
                printing: 'highResolution',
                modifying: false,
                copying: false
              },
              content: value,
              defaultStyle: {
                fontSize: 9,
                alignment: 'justify'
              },
              images: {
                hrsignImage: this.hrSign,
                userSignImage: sign,
                logoDevCare: this.logoOnLeft,
                logoCMMIISO: this.logoOnRight,
              }
            };
            const pdfDocGenerator = pdfMake.createPdf(docDefinition);
            pdfDocGenerator.getBlob((blob) => {
              this.blobFile = blob;
              // const url = URL.createObjectURL(blob);
              // window.open(url, '_blank');
              const file = new File([this.blobFile], "DEVCAREMSA.pdf", { type: 'application/pdf' });
              this.uploadedMSAFile = file;
              this.documentTypeOnFileUpload = "MSA";
              this.vendoronboardingService.InsertTempVendorDocuments(this.documentTypeOnFileUpload, this.uploadedMSAFile, this.emailLinkRefId).subscribe((data: any) => {
                //this.companyService.uploadMSAFile(file).subscribe((res) => {
                  // console.log('msa pdf', data);
                this.messageService.add({ severity: 'success', summary: 'Confirmed', detail: 'MSA successfully uploaded' });
                this.msaFormUploadedPath = data.result;
                this.hasMSACompleted = true;
                this.loadingSaveButton = false;
                this.msaSectionNext();
              },error => {
                console.log(error);
              }
              );
        
            });
      
      
          }, reject: () => {
            this.signFormMSA.patchValue({ msaConfirmationCheckbox: false });
            //this.msaConfirmationCheckbox= false;
            //this.onMSAConfirmation= false;
            this.loadingSaveButton = false;
            this.hasMSACompleted = false;
          }
        })
      }  
      
    }
    else if (this.isTextTab == true){
      if (this.signFormMSA.controls['signText'].value == '') {
        this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Please add text' });
        this.loadingSaveButton = false;
      }
      else{
        this.confirmationService.confirm({
          header:'MSA Confirmation - Please confirm your payment term',
          message: '<strong>'+ this.paymentTermsConfirmationMessage + '</strong>' + '<br><br><center>Please click <b>Yes</b> to confirm the payment term or click <b>No</b> to go back to the Company Profile to change the payment term</center>',
          icon:'pi pi-exclamation-triangle required-field',
          accept: () => {
            let form = this.signFormMSA.value;
          //  let sign = this.sig.toDataURL();
           var html=undefined;
            if(this.msaTemplateOnBrowser.includes("<p style='text-align: center'><span><b>MASTER CONTRACTOR AGREEMENT</b><span></p>"))
            {
              this.msaTemplateOnBrowser= this.msaTemplateOnBrowser.replace("<span><b>MASTER CONTRACTOR AGREEMENT</b><span>","")
              console.log(this.msaTemplateOnBrowser);
              this.msaTemplateOnBrowser = this.msaTemplateOnBrowser.replace(/<p>/g,'<div>').replace(/<\/p>/g,'</div>');
              html = htmlToPdfmake(this.msaTemplateOnBrowser, { removeExtraBlanks: true });
            }
            else if(this.msaTemplateOnBrowser.includes("<p class=\"ql-align-center\"><strong>MASTER CONTRACTOR AGREEMENT</strong></p>"))
            {
              this.msaTemplateOnBrowser= this.msaTemplateOnBrowser.replace("<strong>MASTER CONTRACTOR AGREEMENT</strong>","")
              console.log(this.msaTemplateOnBrowser);
              this.msaTemplateOnBrowser = this.msaTemplateOnBrowser.replace(/<p>/g,'<div>').replace(/<\/p>/g,'</div>');
              html = htmlToPdfmake(this.msaTemplateOnBrowser, { removeExtraBlanks: true });
            }
            else{
              this.msaTemplateOnBrowser = this.msaTemplateOnBrowser.replace(/<p>/g,'<div>').replace(/<\/p>/g,'</div>');
               html = htmlToPdfmake(this.msaTemplateOnBrowser, { removeExtraBlanks: true });
            }
            var ct: any = [];
            ct.push(' ');
            ct.push(' ');
            ct.push({
              columns: [
                {
                  width: '50%',
                  text: 'DevCare Solutions, Ltd.',
                  bold: true,
                  fontSize: 9,
                  margin: 0
                },
                {
                  width: '50%',
                  text: form.vendorName,
                  bold: true,
                  fontSize: 9,
                  margin: 0
                },
              ],
              columnGap: 180
            })
            ct.push(' ');
            ct.push({
              columns: [
      
                {
                  width: '50%',
                  text: 'Janakiram Ramakrishnan',
                  bold: true,
                  fontSize: 11
                },
                {
                  width: '50%',
                  text: this.nameOnDocumentSubmit,
                  bold: true,
                  fontSize: 11,
                },
      
              ],
              columnGap: 180
            })
      
            ct.push(
              // { canvas: [{ type: 'line', x1: 348, y1: 0, x2: 515, y2: 0, lineWidth: 0.1 }] },
              { canvas: [{ type: 'line', x1: 332, y1: 0, x2: 490, y2: 0, lineWidth: 0.1 }] },
              { canvas: [{ type: 'line', x1: 0, y1: 0, x2: 150, y2: 0, lineWidth: 0.1 }] }
            )
            ct.push({
              columns: [
      
                {
                  width: '50%',
                  text: 'Name (Print)',
                  fontSize: 8,
                  margin: [0, 2, 0, 0]
                },
                {
                  width: '50%',
                  text: 'Name (Print)',
                  fontSize: 8,
                  margin: [0, 2, 0, 0]
                },
      
              ],
              columnGap: 180
            })
            ct.push(' ');
            // ct.push(' ');
            ct.push({
              columns: [
      
                {
                  width: '50%',
                  text: 'HR Manager',
                  bold: true,
                  fontSize: 11
                },
                {
                  width: '50%',
                  text: form.title,
                  // text: this.datepipe.transform(new Date(), "MM/dd/yyyy"),
                  bold: true,
                  fontSize: 11
                },
      
              ],
              columnGap: 180
            })
      
            ct.push(
              // { canvas: [{ type: 'line', x1: 348, y1: 0, x2: 515, y2: 0, lineWidth: 0.1 }] },
              { canvas: [{ type: 'line', x1: 332, y1: 0, x2: 490, y2: 0, lineWidth: 0.1 }] },
              { canvas: [{ type: 'line', x1: 0, y1: 0, x2: 150, y2: 0, lineWidth: 0.1 }] }
            )
      
            ct.push({
              columns: [
      
                {
                  width: '50%',
                  text: 'Title',
                  fontSize: 8,
                  margin: [0, 2, 0, 0]
                },
                {
                  width: '50%',
                  text: 'Title',
                  fontSize: 8,
                  margin: [0, 2, 0, 0]
                },
      
              ],
              columnGap: 180
            })
            ct.push(' ');
            // ct.push(' ');
      
      
            ct.push({
              table: {
                widths: [150, 180, 150],
                body: [
                  [
                    {
                      image: 'hrsignImage',
                      width: '120'
                    },
                    {
      
                    },
                    {
                      text: this.nameOnDocumentSubmit,
                      font: 'cedarvillecursiveFont',
                      fontSize: 15,
                    },
                  ],
                  [
                    {
                      text:  this.datepipe.transform(new Date(), "MM/dd/yyyy"),
                    },
                    {
      
                    },
                    {
                      text:  this.datepipe.transform(new Date(), "MM/dd/yyyy"),
                    },
                  ],
                ]
              },
              layout: 'noBorders'
            })
      
      
      
            ct.push(
              // { canvas: [{ type: 'line', x1: 348, y1: 0, x2: 515, y2: 0, lineWidth: 0.1 }] },
              { canvas: [{ type: 'line', x1: 332, y1: 0, x2: 490, y2: 0, lineWidth: 0.1 }] },
              { canvas: [{ type: 'line', x1: 0, y1: 0, x2: 150, y2: 0, lineWidth: 0.1 }] }
            )
      
            ct.push({
              columns: [
      
                {
                  width: '50%',
                  text: 'Signature & Date',
                  fontSize: 8,
                  margin: [0, 2, 0, 0]
                },
                {
                  width: '50%',
                  text: 'Signature & Date',
                  fontSize: 8,
                  margin: [0, 2, 0, 0]
                },
      
              ],
              columnGap: 180
            })
            ct.push({
      
            });
            //let value = html.concat(html, ct)
            let value = html;
            for (let i = 0; i < ct.length; i++) {
              value.push(ct[i])
            }
      
            var docDefinition: any = {
              // pageMargins: [40, 80, 40, 60],
              pageMargins: [54, 60, 54, 55],
              header: function(currentPage, pageCount, pageSize) {
                  //if (currentPage <= 1) {
                  //    return [];
                  //}
              
                  // return {
                  //     table: {
                  //         widths: [170, 240,'*'],
                  //         body: [
                  //             [
                  //                 { image: 'logoImage',width: '100',},
                  //                 { text: 'MASTER CONTRACTOR AGREEMENT', bold:true,fontSize: 9, margin: [10, 30, 40, 10] },
                  //                 { text:''}
                  //             ],
                  //         ]
                  //     },
                  //     layout: 'noBorders',
                  //     margin: [40, 15, 10, 10]
                  // };
                  return {
                    table: {
                        widths: [120, 220, 180],
                        body: [
                            [
                              { image: 'logoDevCare',width: '100', alignment:'left', margin: [12, 0, 5, 0]},
                              { text: 'MASTER CONTRACTOR AGREEMENT', bold:true,fontSize: 9, margin: [52, 27, -100, 0] },
                              { image: 'logoCMMIISO',width: '155', alignment:'right', margin: [-6, 0, 5, 0]},
                              // { text:''},
                            ],
                        ],
                    },
                    layout: 'noBorders',
                    margin: [40, 18, 10, 10]
                };
              },
              footer: function (currentPage: any, pageCount: any) {
                return {
                  table: {
                    widths: '*',
                    body: [
                      [
                        { text: 'DevCare Solutions, Ltd.', alignment: 'left', style: 'normalText', margin: [52, 20,50, 0], aligment: 'right', italics: true },
                        { text: 'Page ' + currentPage.toString() + ' of ' + pageCount, alignment: 'right', style: 'normalText', margin: [0, 20, 53, 0], aligment: 'left', italics: true }
                      ]
                    ]
                  },
                  layout: 'noBorders'
                };
              },
              permissions: {
                printing: 'highResolution',
                modifying: false,
                copying: false
              },
              content: value,
              defaultStyle: {
                fontSize: 9,
                alignment: 'justify'
              },
              images: {
                hrsignImage: this.hrSign,
               // userSignImage: sign,
                logoDevCare: this.logoOnLeft,
                logoCMMIISO: this.logoOnRight,
              }
            };
            const pdfDocGenerator = pdfMake.createPdf(docDefinition);
            pdfDocGenerator.getBlob((blob) => {
              this.blobFile = blob;
              //  const url = URL.createObjectURL(blob);
              //  window.open(url, '_blank');
              const file = new File([this.blobFile], "DEVCAREMSA.pdf", { type: 'application/pdf' });
              this.uploadedMSAFile = file;
              this.documentTypeOnFileUpload = "MSA";
              this.vendoronboardingService.InsertTempVendorDocuments(this.documentTypeOnFileUpload, this.uploadedMSAFile, this.emailLinkRefId).subscribe((data: any) => {
                //this.companyService.uploadMSAFile(file).subscribe((res) => {
                  // console.log('msa pdf', data);
                this.messageService.add({ severity: 'success', summary: 'Confirmed', detail: 'MSA successfully uploaded' });
                this.msaFormUploadedPath = data.result;
                this.hasMSACompleted = true;
                this.loadingSaveButton = false;
                this.msaSectionNext();
              },error => {
               console.log(error);
             }
             );
        
            });
      
      
          }, reject: () => {
            console.log('dddddd');
            this.signFormMSA.patchValue({ msaConfirmationCheckbox: false });
            this.onMSAConfirmation= false;
            this.loadingSaveButton = false;
            this.hasMSACompleted = false;
          }
        })
      }
    }
    else if(this.isImageUploadTab == true)
    {
      if (this.imgBase64Path == undefined) {
        this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Please upload image' });
        this.loadingSaveButton = false;
      }
      else if (this.imgBase64Path !== undefined) {
        this.confirmationService.confirm({
          header:'MSA Confirmation - Please confirm your payment term',
          message: '<strong>'+ this.paymentTermsConfirmationMessage + '</strong>' + '<br><br><center>Please click <b>Yes</b> to confirm the payment term or click <b>No</b> to go back to the Company Profile to change the payment term</center>',
          icon:'pi pi-exclamation-triangle required-field',
          accept: () => {
            let form = this.signFormMSA.value;
            //let sign = this.sig.toDataURL();
           var html=undefined;
            if(this.msaTemplateOnBrowser.includes("<p style='text-align: center'><span><b>MASTER CONTRACTOR AGREEMENT</b><span></p>"))
            {
              this.msaTemplateOnBrowser= this.msaTemplateOnBrowser.replace("<span><b>MASTER CONTRACTOR AGREEMENT</b><span>","")
              console.log(this.msaTemplateOnBrowser);
              this.msaTemplateOnBrowser = this.msaTemplateOnBrowser.replace(/<p>/g,'<div>').replace(/<\/p>/g,'</div>');
              html = htmlToPdfmake(this.msaTemplateOnBrowser, { removeExtraBlanks: true });
            }
            else if(this.msaTemplateOnBrowser.includes("<p class=\"ql-align-center\"><strong>MASTER CONTRACTOR AGREEMENT</strong></p>"))
            {
              this.msaTemplateOnBrowser= this.msaTemplateOnBrowser.replace("<strong>MASTER CONTRACTOR AGREEMENT</strong>","")
              console.log(this.msaTemplateOnBrowser);
              this.msaTemplateOnBrowser = this.msaTemplateOnBrowser.replace(/<p>/g,'<div>').replace(/<\/p>/g,'</div>');
              html = htmlToPdfmake(this.msaTemplateOnBrowser, { removeExtraBlanks: true });
            }
            else{
              this.msaTemplateOnBrowser = this.msaTemplateOnBrowser.replace(/<p>/g,'<div>').replace(/<\/p>/g,'</div>');
               html = htmlToPdfmake(this.msaTemplateOnBrowser, { removeExtraBlanks: true });
            }
            var ct: any = [];
            ct.push(' ');
            ct.push(' ');
            ct.push({
              columns: [
                {
                  width: '50%',
                  text: 'DevCare Solutions, Ltd.',
                  bold: true,
                  fontSize: 9,
                  margin: 0
                },
                {
                  width: '50%',
                  text: form.vendorName,
                  bold: true,
                  fontSize: 9,
                  margin: 0
                },
              ],
              columnGap: 180
            })
            ct.push(' ');
            ct.push({
              columns: [
      
                {
                  width: '50%',
                  text: 'Janakiram Ramakrishnan',
                  bold: true,
                  fontSize: 11
                },
                {
                  width: '50%',
                  text: form.name,
                  bold: true,
                  fontSize: 11,
                },
      
              ],
              columnGap: 180
            })
      
            ct.push(
              // { canvas: [{ type: 'line', x1: 348, y1: 0, x2: 515, y2: 0, lineWidth: 0.1 }] },
              { canvas: [{ type: 'line', x1: 332, y1: 0, x2: 490, y2: 0, lineWidth: 0.1 }] },
              { canvas: [{ type: 'line', x1: 0, y1: 0, x2: 150, y2: 0, lineWidth: 0.1 }] }
            )
            ct.push({
              columns: [
      
                {
                  width: '50%',
                  text: 'Name (Print)',
                  fontSize: 8,
                  margin: [0, 2, 0, 0]
                },
                {
                  width: '50%',
                  text: 'Name (Print)',
                  fontSize: 8,
                  margin: [0, 2, 0, 0]
                },
      
              ],
              columnGap: 180
            })
            ct.push(' ');
            // ct.push(' ');
            ct.push({
              columns: [
      
                {
                  width: '50%',
                  text: 'HR Manager',
                  bold: true,
                  fontSize: 11
                },
                {
                  width: '50%',
                  text: form.title,
                  // text: this.datepipe.transform(new Date(), "MM/dd/yyyy"),
                  bold: true,
                  fontSize: 11
                },
      
              ],
              columnGap: 180
            })
      
            ct.push(
              // { canvas: [{ type: 'line', x1: 348, y1: 0, x2: 515, y2: 0, lineWidth: 0.1 }] },
              { canvas: [{ type: 'line', x1: 332, y1: 0, x2: 490, y2: 0, lineWidth: 0.1 }] },
              { canvas: [{ type: 'line', x1: 0, y1: 0, x2: 150, y2: 0, lineWidth: 0.1 }] }
            )
      
            ct.push({
              columns: [
      
                {
                  width: '50%',
                  text: 'Title',
                  fontSize: 8,
                  margin: [0, 2, 0, 0]
                },
                {
                  width: '50%',
                  text: 'Title',
                  fontSize: 8,
                  margin: [0, 2, 0, 0]
                },
      
              ],
              columnGap: 180
            })
            ct.push(' ');
            // ct.push(' ');
      
      
            ct.push({
              table: {
                widths: [150, 180, 150],
                body: [
                  [
                    {
                      image: 'hrsignImage',
                      width: '120'
                    },
                    {
      
                    },
                    {
                      image: 'userSignImage',
                      width: '120'
                    },
                  ],
                  [
                    {
                      text:  this.datepipe.transform(new Date(), "MM/dd/yyyy"),
                    },
                    {
      
                    },
                    {
                      text:  this.datepipe.transform(new Date(), "MM/dd/yyyy"),
                    },
                  ],
                ]
              },
              layout: 'noBorders'
            })
      
      
      
            ct.push(
              // { canvas: [{ type: 'line', x1: 348, y1: 0, x2: 515, y2: 0, lineWidth: 0.1 }] },
              { canvas: [{ type: 'line', x1: 332, y1: 0, x2: 490, y2: 0, lineWidth: 0.1 }] },
              { canvas: [{ type: 'line', x1: 0, y1: 0, x2: 150, y2: 0, lineWidth: 0.1 }] }
            )
      
            ct.push({
              columns: [
      
                {
                  width: '50%',
                  text: 'Signature & Date',
                  fontSize: 8,
                  margin: [0, 2, 0, 0]
                },
                {
                  width: '50%',
                  text: 'Signature & Date',
                  fontSize: 8,
                  margin: [0, 2, 0, 0]
                },
      
              ],
              columnGap: 180
            })
            ct.push({
      
            });
            //let value = html.concat(html, ct)
            let value = html;
            for (let i = 0; i < ct.length; i++) {
              value.push(ct[i])
            }
      
            var docDefinition: any = {
              // pageMargins: [40, 80, 40, 60],
              pageMargins: [54, 60, 54, 55],
              header: function(currentPage, pageCount, pageSize) {
                  //if (currentPage <= 1) {
                  //    return [];
                  //}
              
                  // return {
                  //     table: {
                  //         widths: [170, 240,'*'],
                  //         body: [
                  //             [
                  //                 { image: 'logoImage',width: '100',},
                  //                 { text: 'MASTER CONTRACTOR AGREEMENT', bold:true,fontSize: 9, margin: [10, 30, 40, 10] },
                  //                 { text:''}
                  //             ],
                  //         ]
                  //     },
                  //     layout: 'noBorders',
                  //     margin: [40, 15, 10, 10]
                  // };
                  return {
                    table: {
                        widths: [120, 220, 180],
                        body: [
                            [
                              { image: 'logoDevCare',width: '100', alignment:'left', margin: [12, 0, 5, 0]},
                              { text: 'MASTER CONTRACTOR AGREEMENT', bold:true,fontSize: 9, margin: [52, 27, -100, 0] },
                              { image: 'logoCMMIISO',width: '155', alignment:'right', margin: [-6, 0, 5, 0]},
                              // { text:''},
                            ],
                        ],
                    },
                    layout: 'noBorders',
                    margin: [40, 18, 10, 10]
                };
              },
              footer: function (currentPage: any, pageCount: any) {
                return {
                  table: {
                    widths: '*',
                    body: [
                      [
                        { text: 'DevCare Solutions, Ltd.', alignment: 'left', style: 'normalText', margin: [52, 20,50, 0], aligment: 'right', italics: true },
                        { text: 'Page ' + currentPage.toString() + ' of ' + pageCount, alignment: 'right', style: 'normalText', margin: [0, 20, 53, 0], aligment: 'left', italics: true }
                      ]
                    ]
                  },
                  layout: 'noBorders'
                };
              },
              permissions: {
                printing: 'highResolution',
                modifying: false,
                copying: false
              },
              content: value,
              defaultStyle: {
                fontSize: 9,
                alignment: 'justify'
              },
              images: {
                hrsignImage: this.hrSign,
                userSignImage: this.imgBase64Path,
                logoDevCare: this.logoOnLeft,
                logoCMMIISO: this.logoOnRight,
              }
            };
            const pdfDocGenerator = pdfMake.createPdf(docDefinition);
            pdfDocGenerator.getBlob((blob) => {
              this.blobFile = blob;
              //  const url = URL.createObjectURL(blob);
              //  window.open(url, '_blank');
               const file = new File([this.blobFile], "DEVCAREMSA.pdf", { type: 'application/pdf' });
               this.uploadedMSAFile = file;
               this.documentTypeOnFileUpload = "MSA";
               this.vendoronboardingService.InsertTempVendorDocuments(this.documentTypeOnFileUpload, this.uploadedMSAFile, this.emailLinkRefId).subscribe((data: any) => {
                 //this.companyService.uploadMSAFile(file).subscribe((res) => {
              //     // console.log('msa pdf', data);
                 this.messageService.add({ severity: 'success', summary: 'Confirmed', detail: 'MSA successfully uploaded' });
                 this.msaFormUploadedPath = data.result;
                 this.hasMSACompleted = true;
                this.loadingSaveButton = false;
                 this.msaSectionNext();
              },error => {
                console.log(error);
              }
              );
        
            });
          }, reject: () => {
            this.signFormMSA.patchValue({ msaConfirmationCheckbox: false });
            this.onMSAConfirmation= false;
            this.loadingSaveButton = false;
            this.hasMSACompleted = false;
          }
        })
      }
    }
   
    
  }
  onChangeMSAIAgreeAboveTerms(value) {
    this.msaIAgreeAboveTerms = value.checked;
  }
  msaSectionNext() {
    if(!this.isVendorAvailable)
    {
      this.tabIndex = this.tabIndex + 1;
      this.messageService.add({severity: 'success', summary: 'Confirmed', detail: 'Details have been added successfully'});
      this.signFormPO.controls['name'].setValue(this.nameOnDocumentSubmit);
      this.scrollToTop(0);
      this.clearPOSign();
    }
    if(this.isVendorAvailable)
    {
      if(this.isVendorAvailable && this.isPOSelected)
        {
          this.tabIndex = this.tabIndex + 1;
          this.signFormPO.controls['name'].setValue(this.nameOnDocumentSubmit);
          this.messageService.add({severity: 'success', summary: 'Confirmed', detail: 'Details have been added successfully'});
          this.scrollToTop(0);
          this.clearPOSign();
        }
        else if(this.isVendorAvailable && this.isNCASelected)
        {
          this.signFormNCA.controls['name'].setValue(this.nameOnDocumentSubmit);
          if(this.showNCAAccordion == true){
            this.tabIndex =this.tabIndex + 1;
          this.messageService.add({severity: 'success', summary: 'Confirmed', detail: 'Details have been added successfully'});
          this.scrollToTop(0);
          this.clearNCASign();
          }
          else if(this.showNCAAccordion == false){
          this.tabIndex =this.tabIndex + 2;
          this.messageService.add({severity: 'success', summary: 'Confirmed', detail: 'Details have been added successfully'});
          //this.clearNCASign();
          }
        }
          else 
          {
            this.tabIndex = this.tabIndex + 1;
          }
    }
    this.scrollToTop(0);
  }
  msaSectionPrevious() {
   this.tabIndex = this.tabIndex - 1;
   this.scrollToTop(0);
  }
  ///end/////////msa accordion methods/////////////////
  ////////////PO accordion methods - start/////////////////

  downloadPOPDF() {
    this.loadingSaveButton = true;
    if (this.isSignatureTabPO == true) {
      if (this.sigPO.isEmpty() == true) {
        this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Please sign the document' });
        this.loadingSaveButton = false;
      }
      else if (this.sigPO.isEmpty() == false) {
    this.confirmationService.confirm({
      header: 'PO Confirmation',
      message: 'You cannot change the information after submission please verify before submitting the Purchase Order.<br><br><center>Would you like to proceed with submission?</center>',
      icon: 'pi pi-exclamation-triangle required-field',
      accept: () => {

let form = this.signFormPO.value;
let sign = this.sigPO.toDataURL();
var html = undefined;
if(this.POTemplateOnBrowser.includes("<p style='text-align: center'><span><b>PURCHASE ORDER</b><span></p>"))
{
  this.POTemplateOnBrowser= this.POTemplateOnBrowser.replace("<span><b>PURCHASE ORDER</b><span>","")
  console.log(this.POTemplateOnBrowser);
  html = htmlToPdfmake(this.POTemplateOnBrowser, { removeExtraBlanks: true });
}
else if(this.POTemplateOnBrowser.includes("<p class=\"ql-align-center\"><strong>PURCHASE ORDER</strong></p>"))
{
  this.POTemplateOnBrowser= this.POTemplateOnBrowser.replace("<strong>PURCHASE ORDER</strong>","")
  console.log(this.POTemplateOnBrowser);
  html = htmlToPdfmake(this.POTemplateOnBrowser, { removeExtraBlanks: true });
}
else{
   html = htmlToPdfmake(this.POTemplateOnBrowser, { removeExtraBlanks: true });
}
var ct: any = [];
ct.push(' ');
ct.push(' ');
ct.push({
  columns: [
    {
      width: '50%',
      text: 'DevCare Solutions, Ltd.',
      bold: true,
      fontSize: 9,
      margin: 0
    },
    {
      width: '50%',
      text: form.vendorName,
      bold: true,
      fontSize: 9,
      margin: 0
    },
  ],
  columnGap: 180
})
ct.push(' ');
ct.push({
  columns: [

    {
      width: '50%',
      text: 'Janakiram Ramakrishnan',
      bold: true,
      fontSize: 11
    },
    {
      width: '50%',
      text: form.name,
      bold: true,
      fontSize: 11,
    },

  ],
  columnGap: 180
})

ct.push(
  { canvas: [{ type: 'line', x1: 332, y1: 0, x2: 490, y2: 0, lineWidth: 0.1 }] },
  { canvas: [{ type: 'line', x1: 0, y1: 0, x2: 150, y2: 0, lineWidth: 0.1 }] }
)

ct.push({
  columns: [

    {
      width: '50%',
      text: 'Name (Print)',
      fontSize: 8,
      margin: [0, 2, 0, 0]
    },
    {
      width: '50%',
      text: 'Name (Print)',
      fontSize: 8,
      margin: [0, 2, 0, 0]
    },

  ],
  columnGap: 180
})
ct.push(' ');
// ct.push(' ');
ct.push({
  columns: [

    {
      width: '50%',
      text: 'HR Manager',
      bold: true,
      fontSize: 11
    },
    {
      width: '50%',
      text: form.title,
      // text: this.datepipe.transform(new Date(), "MM/dd/yyyy"),
      bold: true,
      fontSize: 11
    },

  ],
  columnGap: 180
})

ct.push(
  { canvas: [{ type: 'line', x1: 332, y1: 0, x2: 490, y2: 0, lineWidth: 0.1 }] },
  { canvas: [{ type: 'line', x1: 0, y1: 0, x2: 150, y2: 0, lineWidth: 0.1 }] }
)

ct.push({
  columns: [

    {
      width: '50%',
      text: 'Title',
      fontSize: 8,
      margin: [0, 2, 0, 0]
    },
    {
      width: '50%',
      text: 'Title',
      fontSize: 8,
      margin: [0, 2, 0, 0]
    },

  ],
  columnGap: 180
})

ct.push(' ');
// ct.push(' ');
ct.push({
  table: {
    widths: [150, 180, 150],
    body: [
      [
        {
          image: 'hrsignImage',
          width: '120'
        },
        {

        },
        // {
        //   text: this.signFormMSA.controls['name'].value,
        //   font: 'cedarvillecursiveFont',
        //   fontSize: 15,
        // },
        {
          image: 'userSignImage',
          width: '120'
        },
      ],
      [
        {
          text: this.datepipe.transform(new Date(), "MM/dd/yyyy"),
        },
        {

        },
        {
          text: this.datepipe.transform(new Date(), "MM/dd/yyyy"),
        },
      ],
    ]
  },
  layout: 'noBorders'
})


ct.push(
  { canvas: [{ type: 'line', x1: 332, y1: 0, x2: 490, y2: 0, lineWidth: 0.1 }] },
  { canvas: [{ type: 'line', x1: 0, y1: 0, x2: 150, y2: 0, lineWidth: 0.1 }] }
)

ct.push({
  columns: [

    {
      width: '50%',
      text: 'Signature & Date',
      fontSize: 8,
      margin: [0, 2, 0, 0]
    },
    {
      width: '50%',
      text: 'Signature & Date',
      fontSize: 8,
      margin: [0, 2, 0, 0]
    },

  ],
  columnGap: 180
})
ct.push({

});
//let value = html.concat(html, ct)
let value = html;
for (let i = 0; i < ct.length; i++) {
  value.push(ct[i])
}
var docDefinition: any = {
  header: function(currentPage, pageCount, pageSize) {
    //if (currentPage <= 1) {
    //    return [];
    //}
  
    // return {
    //     table: {
    //         widths: [170, 240,'*'],
    //         body: [
    //             [
    //                 { image: 'logoImage',width: '100',},
    //                 { text: 'PURCHASE ORDER', bold:true,fontSize: 9, margin: [40, 43, 0, 0] },
    //                 { text:''}
    //             ],
    //         ]
    //     },
    //     layout: 'noBorders',
    //     margin: [40, 18, 10, 10]
    // };
    return {
      table: {
          widths: [120, 220, 180],
          body: [
              [
                { image: 'logoDevCare',width: '100', alignment:'left', margin: [12, 0, 5, 0]},
                { text: 'PURCHASE ORDER', bold:true,fontSize: 9, margin: [90, 27, -100, 0] },
                { image: 'logoCMMIISO',width: '155', alignment:'right', margin: [-6, 0, 5, 0]},
                // { text:''},
              ],
          ],
      },
      layout: 'noBorders',
      margin: [40, 18, 10, 10]
  };
  },
  // pageMargins: [40, 82, 40, 60],
  pageMargins: [54, 60, 54, 54],
  footer: function (currentPage: any, pageCount: any) {
    return {
      table: {
        widths: '*',
        body: [
          [
            { text: 'DevCare Solutions, Ltd.', alignment: 'left', style: 'normalText', margin: [52, 20, 50, 0], aligment: 'right', italics: true },
            { text: 'Page ' + currentPage.toString() + ' of ' + pageCount, alignment: 'right', style: 'normalText', margin: [0, 20, 53, 0], aligment: 'left', italics: true }
          ]
        ]
      },
      layout: 'noBorders'
    };
  },
  permissions: {
    printing: 'highResolution',
    modifying: false,
    copying: false
  },
  content: value,
  defaultStyle: {
    fontSize: 9,
    alignment: 'justify'
  },
  images: {
    hrsignImage: this.hrSign,
    userSignImage: sign,
    logoDevCare: this.logoOnLeft,
    logoCMMIISO: this.logoOnRight,
  }
};

 const pdfDocGenerator = pdfMake.createPdf(docDefinition);
 pdfDocGenerator.getBlob((blob) => {
   this.blobFile = blob;
  //  const url = URL.createObjectURL(blob);
  //  window.open(url, '_blank');
   const file = new File([this.blobFile], "DEVCAREPO.pdf", { type: 'application/pdf' });
   console.log('blob file', this.blobFile);
   this.uploadedPOFile = file;
   this.documentTypeOnFileUpload = "PO";
   this.vendoronboardingService.InsertTempVendorDocuments(this.documentTypeOnFileUpload, this.uploadedPOFile, this.emailLinkRefId).subscribe((data: any) => {
  //  console.log('po generated',data);
     this.messageService.add({ severity: 'success', summary: 'Confirmed', detail: 'PO successfully uploaded' });
    this.poFormUploadedPath = data.result;
     this.hasPOCompleted = true;
     this.loadingSaveButton = false;
     this.poSectionNext();      

   },error => {
      console.log(error);
    });
   //this.PODocumentUploaded = true;
 });
},
      reject: () => {
        this.signFormPO.patchValue({ poConfirmationCheckbox: false });
        //this.onPOConfirmation= false;
        this.loadingSaveButton = false;
        this.hasPOCompleted = false;
      }
    })
  }
}
else if(this.isTextTabPO == true){
  if (this.signFormPO.controls['signText'].value == '') {
    this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Please add text' });
    this.loadingSaveButton = false;
  }
  else{
    this.confirmationService.confirm({
      header: 'PO Confirmation',
      message: 'You cannot change the information after submission please verify before submitting the Purchase Order.<br><br><center>Would you like to proceed with submission?</center>',
      icon: 'pi pi-exclamation-triangle required-field',
      accept: () => {

let form = this.signFormPO.value;
//let sign = this.sigPO.toDataURL();
var html = undefined;
if(this.POTemplateOnBrowser.includes("<p style='text-align: center'><span><b>PURCHASE ORDER</b><span></p>"))
{
  this.POTemplateOnBrowser= this.POTemplateOnBrowser.replace("<span><b>PURCHASE ORDER</b><span>","")
  console.log(this.POTemplateOnBrowser);
  html = htmlToPdfmake(this.POTemplateOnBrowser, { removeExtraBlanks: true });
}
else if(this.POTemplateOnBrowser.includes("<p class=\"ql-align-center\"><strong>PURCHASE ORDER</strong></p>"))
{
  this.POTemplateOnBrowser= this.POTemplateOnBrowser.replace("<strong>PURCHASE ORDER</strong>","")
  console.log(this.POTemplateOnBrowser);
  html = htmlToPdfmake(this.POTemplateOnBrowser, { removeExtraBlanks: true });
}
else{
   html = htmlToPdfmake(this.POTemplateOnBrowser, { removeExtraBlanks: true });
}
var ct: any = [];
ct.push(' ');
ct.push(' ');
ct.push({
  columns: [
    {
      width: '50%',
      text: 'DevCare Solutions, Ltd.',
      bold: true,
      fontSize: 9,
      margin: 0
    },
    {
      width: '50%',
      text: form.vendorName,
      bold: true,
      fontSize: 9,
      margin: 0
    },
  ],
  columnGap: 180
})
ct.push(' ');
ct.push({
  columns: [

    {
      width: '50%',
      text: 'Janakiram Ramakrishnan',
      bold: true,
      fontSize: 11
    },
    {
      width: '50%',
      text: this.nameOnDocumentSubmit,
      bold: true,
      fontSize: 11,
    },

  ],
  columnGap: 180
})

ct.push(
  // { canvas: [{ type: 'line', x1: 348, y1: 0, x2: 515, y2: 0, lineWidth: 0.1 }] },
  { canvas: [{ type: 'line', x1: 332, y1: 0, x2: 490, y2: 0, lineWidth: 0.1 }] },
  { canvas: [{ type: 'line', x1: 0, y1: 0, x2: 150, y2: 0, lineWidth: 0.1 }] }
)

ct.push({
  columns: [

    {
      width: '50%',
      text: 'Name (Print)',
      fontSize: 8,
      margin: [0, 2, 0, 0]
    },
    {
      width: '50%',
      text: 'Name (Print)',
      fontSize: 8,
      margin: [0, 2, 0, 0]
    },

  ],
  columnGap: 180
})
ct.push(' ');
// ct.push(' ');
ct.push({
  columns: [

    {
      width: '50%',
      text: 'HR Manager',
      bold: true,
      fontSize: 11
    },
    {
      width: '50%',
      text: form.title,
      // text: this.datepipe.transform(new Date(), "MM/dd/yyyy"),
      bold: true,
      fontSize: 11
    },

  ],
  columnGap: 180
})

ct.push(
  // { canvas: [{ type: 'line', x1: 348, y1: 0, x2: 515, y2: 0, lineWidth: 0.1 }] },
  { canvas: [{ type: 'line', x1: 332, y1: 0, x2: 490, y2: 0, lineWidth: 0.1 }] },
  { canvas: [{ type: 'line', x1: 0, y1: 0, x2: 150, y2: 0, lineWidth: 0.1 }] }
)

ct.push({
  columns: [

    {
      width: '50%',
      text: 'Title',
      fontSize: 8,
      margin: [0, 2, 0, 0]
    },
    {
      width: '50%',
      text: 'Title',
      fontSize: 8,
      margin: [0, 2, 0, 0]
    },

  ],
  columnGap: 180
})

ct.push(' ');
// ct.push(' ');
ct.push({
  table: {
    widths: [150, 180, 150],
    body: [
      [
        {
          image: 'hrsignImage',
          width: '120'
        },
        {

        },
        {
          text: this.nameOnDocumentSubmit,
          font: 'cedarvillecursiveFont',
          fontSize: 15,
        },
      ],
      [
        {
          text: this.datepipe.transform(new Date(), "MM/dd/yyyy"),
        },
        {

        },
        {
          text: this.datepipe.transform(new Date(), "MM/dd/yyyy"),
        },
      ],
    ]
  },
  layout: 'noBorders'
})


ct.push(
  // { canvas: [{ type: 'line', x1: 348, y1: 0, x2: 515, y2: 0, lineWidth: 0.1 }] },
  { canvas: [{ type: 'line', x1: 332, y1: 0, x2: 490, y2: 0, lineWidth: 0.1 }] },
  { canvas: [{ type: 'line', x1: 0, y1: 0, x2: 150, y2: 0, lineWidth: 0.1 }] }
)

ct.push({
  columns: [

    {
      width: '50%',
      text: 'Signature & Date',
      fontSize: 8,
      margin: [0, 2, 0, 0]
    },
    {
      width: '50%',
      text: 'Signature & Date',
      fontSize: 8,
      margin: [0, 2, 0, 0]
    },

  ],
  columnGap: 180
})
ct.push({

});
//let value = html.concat(html, ct)
let value = html;
for (let i = 0; i < ct.length; i++) {
  value.push(ct[i])
}
var docDefinition: any = {
  header: function(currentPage, pageCount, pageSize) {
    //if (currentPage <= 1) {
    //    return [];
    //}
  
    // return {
    //     table: {
    //         widths: [170, 240,'*'],
    //         body: [
    //             [
    //                 { image: 'logoImage',width: '100',},
    //                 { text: 'PURCHASE ORDER', bold:true,fontSize: 9, margin: [40, 43, 0, 0] },
    //                 { text:''}
    //             ],
    //         ]
    //     },
    //     layout: 'noBorders',
    //     margin: [40, 18, 10, 10]
    // };
    return {
      table: {
          widths: [120, 220, 180],
          body: [
              [
                { image: 'logoDevCare',width: '100', alignment:'left', margin: [12, 0, 5, 0]},
                { text: 'PURCHASE ORDER', bold:true,fontSize: 9, margin: [90, 27, -100, 0] },
                { image: 'logoCMMIISO',width: '155', alignment:'right', margin: [-6, 0, 5, 0]},
                // { text:''},
              ],
          ],
      },
      layout: 'noBorders',
      margin: [40, 18, 10, 10]
  };
  },
  // pageMargins: [40, 82, 40, 60],
  pageMargins: [54, 60, 54, 54],
  footer: function (currentPage: any, pageCount: any) {
    return {
      table: {
        widths: '*',
        body: [
          [
            { text: 'DevCare Solutions, Ltd.', alignment: 'left', style: 'normalText', margin: [52, 20, 50, 0], aligment: 'right', italics: true },
            { text: 'Page ' + currentPage.toString() + ' of ' + pageCount, alignment: 'right', style: 'normalText', margin: [0, 20, 53, 0], aligment: 'left', italics: true }
          ]
        ]
      },
      layout: 'noBorders'
    };
  },
  permissions: {
    printing: 'highResolution',
    modifying: false,
    copying: false
  },
  content: value,
  defaultStyle: {
    fontSize: 9,
    alignment: 'justify'
  },
  images: {
    hrsignImage: this.hrSign,
    //userSignImage: sign,
    logoDevCare: this.logoOnLeft,
    logoCMMIISO: this.logoOnRight,
    }
};

 const pdfDocGenerator = pdfMake.createPdf(docDefinition);
 pdfDocGenerator.getBlob((blob) => {
   this.blobFile = blob;
  //  const url = URL.createObjectURL(blob);
  //  window.open(url, '_blank');
   const file = new File([this.blobFile], "DEVCAREPO.pdf", { type: 'application/pdf' });
   console.log('blob file', this.blobFile);
   this.uploadedPOFile = file;
   this.documentTypeOnFileUpload = "PO";
   this.vendoronboardingService.InsertTempVendorDocuments(this.documentTypeOnFileUpload, this.uploadedPOFile, this.emailLinkRefId).subscribe((data: any) => {
  //  console.log('po generated',data);
     this.messageService.add({ severity: 'success', summary: 'Confirmed', detail: 'PO successfully uploaded' });
    this.poFormUploadedPath = data.result;
     this.hasPOCompleted = true;
     this.loadingSaveButton = false;
     this.poSectionNext();      

   },error => {
      console.log(error);
    });
   //this.PODocumentUploaded = true;
 });
},
      reject: () => {
        this.onPOConfirmation= false;
        this.signFormPO.patchValue({ poConfirmationCheckbox: false });
        this.loadingSaveButton = false;
        this.hasPOCompleted = false;
      }
    })
  }
}
else if(this.isImageUploadTabPO == true)
    {
      if (this.imgBase64Path == undefined) {
        this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Please upload image' });
        this.loadingSaveButton = false;
      }
      else if (this.imgBase64Path !== undefined) {
        this.confirmationService.confirm({
          header: 'PO Confirmation',
          message: 'You cannot change the information after submission please verify before submitting the Purchase Order.<br><br><center>Would you like to proceed with submission?</center>',
          icon: 'pi pi-exclamation-triangle required-field',
          accept: () => {
    
    let form = this.signFormPO.value;
    //let sign = this.sigPO.toDataURL();
    var html = undefined;
if(this.POTemplateOnBrowser.includes("<p style='text-align: center'><span><b>PURCHASE ORDER</b><span></p>"))
{
  this.POTemplateOnBrowser= this.POTemplateOnBrowser.replace("<span><b>PURCHASE ORDER</b><span>","")
  console.log(this.POTemplateOnBrowser);
  html = htmlToPdfmake(this.POTemplateOnBrowser, { removeExtraBlanks: true });
}
else if(this.POTemplateOnBrowser.includes("<p class=\"ql-align-center\"><strong>PURCHASE ORDER</strong></p>"))
{
  this.POTemplateOnBrowser= this.POTemplateOnBrowser.replace("<strong>PURCHASE ORDER</strong>","")
  console.log(this.POTemplateOnBrowser);
  html = htmlToPdfmake(this.POTemplateOnBrowser, { removeExtraBlanks: true });
}
else{
   html = htmlToPdfmake(this.POTemplateOnBrowser, { removeExtraBlanks: true });
}
    var ct: any = [];
    ct.push(' ');
    ct.push(' ');
    ct.push({
      columns: [
        {
          width: '50%',
          text: 'DevCare Solutions, Ltd.',
          bold: true,
          fontSize: 9,
          margin: 0
        },
        {
          width: '50%',
          text: form.vendorName,
          bold: true,
          fontSize: 9,
          margin: 0
        },
      ],
      columnGap: 180
    })
    ct.push(' ');
    ct.push({
      columns: [
    
        {
          width: '50%',
          text: 'Janakiram Ramakrishnan',
          bold: true,
          fontSize: 11
        },
        {
          width: '50%',
          text: form.name,
          bold: true,
          fontSize: 11,
        },
    
      ],
      columnGap: 180
    })
    
    ct.push(
      // { canvas: [{ type: 'line', x1: 348, y1: 0, x2: 515, y2: 0, lineWidth: 0.1 }] },
      { canvas: [{ type: 'line', x1: 332, y1: 0, x2: 490, y2: 0, lineWidth: 0.1 }] },
      { canvas: [{ type: 'line', x1: 0, y1: 0, x2: 150, y2: 0, lineWidth: 0.1 }] }
    )
    
    ct.push({
      columns: [
    
        {
          width: '50%',
          text: 'Name (Print)',
          fontSize: 8,
          margin: [0, 2, 0, 0]
        },
        {
          width: '50%',
          text: 'Name (Print)',
          fontSize: 8,
          margin: [0, 2, 0, 0]
        },
    
      ],
      columnGap: 180
    })
    ct.push(' ');
    // ct.push(' ');
    ct.push({
      columns: [
    
        {
          width: '50%',
          text: 'HR Manager',
          bold: true,
          fontSize: 11
        },
        {
          width: '50%',
          text: form.title,
          // text: this.datepipe.transform(new Date(), "MM/dd/yyyy"),
          bold: true,
          fontSize: 11
        },
    
      ],
      columnGap: 180
    })
    
    ct.push(
      // { canvas: [{ type: 'line', x1: 348, y1: 0, x2: 515, y2: 0, lineWidth: 0.1 }] },
      { canvas: [{ type: 'line', x1: 332, y1: 0, x2: 490, y2: 0, lineWidth: 0.1 }] },
      { canvas: [{ type: 'line', x1: 0, y1: 0, x2: 150, y2: 0, lineWidth: 0.1 }] }
    )
    
    ct.push({
      columns: [
    
        {
          width: '50%',
          text: 'Title',
          fontSize: 8,
          margin: [0, 2, 0, 0]
        },
        {
          width: '50%',
          text: 'Title',
          fontSize: 8,
          margin: [0, 2, 0, 0]
        },
    
      ],
      columnGap: 180
    })
    
    ct.push(' ');
    // ct.push(' ');
    ct.push({
      table: {
        widths: [150, 180, 150],
        body: [
          [
            {
              image: 'hrsignImage',
              width: '120'
            },
            {
    
            },
            // {
            //   text: this.signFormMSA.controls['name'].value,
            //   font: 'cedarvillecursiveFont',
            //   fontSize: 15,
            // },
            {
              image: 'userSignImage',
              width: '120'
            },
          ],
          [
            {
              text: this.datepipe.transform(new Date(), "MM/dd/yyyy"),
            },
            {
    
            },
            {
              text: this.datepipe.transform(new Date(), "MM/dd/yyyy"),
            },
          ],
        ]
      },
      layout: 'noBorders'
    })
    
    
    ct.push(
      // { canvas: [{ type: 'line', x1: 348, y1: 0, x2: 515, y2: 0, lineWidth: 0.1 }] },
      { canvas: [{ type: 'line', x1: 332, y1: 0, x2: 490, y2: 0, lineWidth: 0.1 }] },
      { canvas: [{ type: 'line', x1: 0, y1: 0, x2: 150, y2: 0, lineWidth: 0.1 }] }
    )
    
    ct.push({
      columns: [
    
        {
          width: '50%',
          text: 'Signature & Date',
          fontSize: 8,
          margin: [0, 2, 0, 0]
        },
        {
          width: '50%',
          text: 'Signature & Date',
          fontSize: 8,
          margin: [0, 2, 0, 0]
        },
    
      ],
      columnGap: 180
    })
    ct.push({
    
    });
    //let value = html.concat(html, ct)
    let value = html;
    for (let i = 0; i < ct.length; i++) {
      value.push(ct[i])
    }
    var docDefinition: any = {
      header: function(currentPage, pageCount, pageSize) {
        //if (currentPage <= 1) {
        //    return [];
        //}
      
        // return {
        //     table: {
        //         widths: [170, 240,'*'],
        //         body: [
        //             [
        //                 { image: 'logoImage',width: '100',},
        //                 { text: 'PURCHASE ORDER', bold:true,fontSize: 9, margin: [40, 43, 0, 0] },
        //                 { text:''}
        //             ],
        //         ]
        //     },
        //     layout: 'noBorders',
        //     margin: [40, 18, 10, 10]
        // };
        return {
          table: {
              widths: [120, 220, 180],
              body: [
                  [
                    { image: 'logoDevCare',width: '100', alignment:'left', margin: [12, 0, 5, 0]},
                    { text: 'PURCHASE ORDER', bold:true,fontSize: 9, margin: [90, 27, -100, 0] },
                    { image: 'logoCMMIISO',width: '155', alignment:'right', margin: [-6, 0, 5, 0]},
                    // { text:''},
                  ],
              ],
          },
          layout: 'noBorders',
          margin: [40, 18, 10, 10]
      };
      },
      // pageMargins: [40, 82, 40, 60],
      pageMargins: [54, 60, 54, 54],
      footer: function (currentPage: any, pageCount: any) {
        return {
          table: {
            widths: '*',
            body: [
              [
                { text: 'DevCare Solutions, Ltd.', alignment: 'left', style: 'normalText', margin: [52, 20, 50, 0], aligment: 'right', italics: true },
                { text: 'Page ' + currentPage.toString() + ' of ' + pageCount, alignment: 'right', style: 'normalText', margin: [0, 20, 53, 0], aligment: 'left', italics: true }
              ]
            ]
          },
          layout: 'noBorders'
        };
      },
      permissions: {
        printing: 'highResolution',
        modifying: false,
        copying: false
      },
      content: value,
      defaultStyle: {
        fontSize: 9,
        alignment: 'justify'
      },
      images: {
        hrsignImage: this.hrSign,
        userSignImage: this.imgBase64Path,
        logoDevCare: this.logoOnLeft,
        logoCMMIISO: this.logoOnRight,
      }
    };
    
     const pdfDocGenerator = pdfMake.createPdf(docDefinition);
     pdfDocGenerator.getBlob((blob) => {
       this.blobFile = blob;
      //  const url = URL.createObjectURL(blob);
      //  window.open(url, '_blank');
       const file = new File([this.blobFile], "DEVCAREPO.pdf", { type: 'application/pdf' });
       console.log('blob file', this.blobFile);
       this.uploadedPOFile = file;
       this.documentTypeOnFileUpload = "PO";
       this.vendoronboardingService.InsertTempVendorDocuments(this.documentTypeOnFileUpload, this.uploadedPOFile, this.emailLinkRefId).subscribe((data: any) => {
      //  console.log('po generated',data);
         this.messageService.add({ severity: 'success', summary: 'Confirmed', detail: 'PO successfully uploaded' });
        this.poFormUploadedPath = data.result;
         this.hasPOCompleted = true;
         this.loadingSaveButton = false;
         this.poSectionNext();      
    
       },error => {
          console.log(error);
        });
       //this.PODocumentUploaded = true;
     });
    },
          reject: () => {
            this.onPOConfirmation= false;
            this.signFormPO.patchValue({ poConfirmationCheckbox: false });
            this.loadingSaveButton = false;
            this.hasPOCompleted = false;
          }
        })
      }
    }
}

handleChangePO(e){
  // if(e.index == 0){
  //   this.isSignatureTabPO = true;
  //   this.isTextTabPO = false;
  //   this.isImageUploadTabPO = false;
  // }
  if(e.index == 0){
    this.isTextTabPO = true;
    this.isSignatureTabPO = false;
    this.isImageUploadTabPO = false;
  }
  if(e.index == 1){
    this.isTextTabPO = false;
    this.isSignatureTabPO = false;
    this.isImageUploadTabPO = true;
  }
}
onImageSelectPOSign(event, file: FileList) {
  this.imageFilePOSign = event.target.value;
  this.imageFilePOSign = this.imageFilePOSign.split('\\').pop().split('/').pop();
  if (this.imageFilePOSign.split('.').pop() == 'png' || this.imageFilePOSign.split('.').pop() == 'jpg' || this.imageFilePOSign.split('.').pop() == 'jpeg') {
    this.fileToUploadPOSign = file.item(0);
    //For Image Preview
    let reader = new FileReader();
    reader.onload = (event: any) => {
      this.imageUrlPOSign = event.target.result;
    }
    //console.log(this.fileToUpload);
    reader.readAsDataURL(this.fileToUploadPOSign);
    this.uploadImageFilePOSign();
    this.defaultImagePOSign = "";
  }
  else {
    this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Please select valid file format (png,jpg,jpeg)' });
  }
}

@ViewChild('imageUploadPOSign') imagefileInputPOSign;
uploadImageFilePOSign(): void {
  let fi = this.imagefileInputPOSign.nativeElement;
  if (fi.files && fi.files[0]) {
    this.uploadedFilePOSign = fi.files[0];
    if(this.uploadedFilePOSign .size> 1e+6)
    {
        //alert('1');
    }
    else{
      //alert('2');
    }
    var reader = new FileReader();
    reader.onload = (event:any) => 
    {
        this.imgBase64Path = event.target.result;
        // console.log(this.imgBase64Path);
    }
    reader.readAsDataURL(fi.files[0]);
  }
}

  isBoldOpenPO = (arrayLength: any, valueBefore = false) => {
    const isEven = arrayLength % 2 === 0;
    const result = valueBefore !== isEven;

    return result;
  }
  
  onChangePOIAgreeAboveTerms(value) {
    this.POIAgreeAboveTerms = value.checked;
    // console.log('this.IAgreeAboveTerms - ' + this.POIAgreeAboveTerms);
  }
  poSectionNext() {
    // if(this.msaTypeIdOnEdit == 2 || this.msaTypeIdOnEdit == 4){
    //   this.tabIndex = 3;
    // }
    // else if(this.msaTypeIdOnEdit == 1 || this.msaTypeIdOnEdit == 3){
    //   this.tabIndex = 3;
    // }
    if(!this.isVendorAvailable)
    {
      if(this.showNCAAccordion == true){
        this.tabIndex = 3;
      }
      else if(this.showNCAAccordion == false){
        this.tabIndex = 4;
      }
      this.messageService.add({severity: 'success', summary: 'Confirmed', detail: 'Details have been added successfully'});
      this.signFormNCA.controls['name'].setValue(this.nameOnDocumentSubmit);
      this.scrollToTop(200);
      this.clearNCASign();
    }
    if(this.isVendorAvailable)
    {
      if(this.isVendorAvailable && this.isNCASelected)
        {
          this.signFormNCA.controls['name'].setValue(this.nameOnDocumentSubmit);
          if(this.showNCAAccordion == true){
            this.tabIndex =this.tabIndex + 1;
          this.messageService.add({severity: 'success', summary: 'Confirmed', detail: 'Details have been added successfully'});
          this.scrollToTop(200);
          this.clearNCASign();
          }
          else if(this.showNCAAccordion == false){
          this.tabIndex =this.tabIndex + 2;
          this.messageService.add({severity: 'success', summary: 'Confirmed', detail: 'Details have been added successfully'});
          //this.clearNCASign();
          }
          
        }
          else 
          {
            this.tabIndex =this.tabIndex + 1;
          }
    }
    this.scrollToTop(200);
  }
  poSectionPrevious() {
    //this.tabIndex = 1;
    if(!this.isVendorAvailable)
      {
        this.tabIndex = 1;
      }
      if(this.isVendorAvailable)
      {
        this.tabIndex = this.tabIndex-1;
      }
      this.scrollToTop(0);
  }
  clearPOSign() {
    this.sigPO.clear();
  }
  
  undoPOSign() {
    var data = this.sigPO.toData();
    if (data) {
      data.pop(); // remove the last dot or line
      this.sigPO.fromData(data);
    }
  }
  ////////////PO accordion methods - End/////////////////
  ////////////NCA accordion methods - Start/////////////////

  downloadNCAPDF() {
    this.loadingSaveButton = true;
    if (this.isSignatureTabNCA == true) {
      if (this.sigNCA.isEmpty() == true) {
        this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Please sign the document' });
        this.loadingSaveButton = false;
      }
      else if (this.sigNCA.isEmpty() == false) {
    this.confirmationService.confirm({
      header: 'NCA Confirmation',
      message: 'You cannot change the information after submission please verify before submitting the NCA.<br><br><center>Would you like to proceed with submission?</center>',
      icon: 'pi pi-exclamation-triangle required-field',
      accept: () => {

let form = this.signFormNCA.value;
let sign = this.sigNCA.toDataURL();
var html = undefined;
if(this.NCATemplateOnBrowser.includes("<p style='text-align: center'><span><b>CONFIDENTIALITY AND NON-COMPETE AGREEMENT</b><span></p>"))
{
  this.NCATemplateOnBrowser= this.NCATemplateOnBrowser.replace("<span><b>CONFIDENTIALITY AND NON-COMPETE AGREEMENT</b><span>","")
  console.log(this.NCATemplateOnBrowser);
  html = htmlToPdfmake(this.NCATemplateOnBrowser, { removeExtraBlanks: true });
}
else if(this.NCATemplateOnBrowser.includes("<p class=\"ql-align-center\"><strong>CONFIDENTIALITY AND NON-COMPETE AGREEMENT</strong></p>"))
{
  this.NCATemplateOnBrowser= this.NCATemplateOnBrowser.replace("<strong>CONFIDENTIALITY AND NON-COMPETE AGREEMENT</strong>","")
  console.log(this.NCATemplateOnBrowser);
  html = htmlToPdfmake(this.NCATemplateOnBrowser, { removeExtraBlanks: true });
}
else{
   html = htmlToPdfmake(this.NCATemplateOnBrowser, { removeExtraBlanks: true });
}
var ct: any = [];
ct.push(' ');
ct.push(' ');
ct.push({
  columns: [
    {
      width: '50%',
      text: 'DevCare Solutions, Ltd.',
      bold: true,
      fontSize: 9,
      margin: 0
    },
    {
      width: '50%',
      text: form.applicantName,
      bold: true,
      fontSize: 9,
      margin: 0
    },
  ],
  columnGap: 180
})
ct.push(' ');
ct.push({
  columns: [

    {
      width: '50%',
      text: 'Janakiram Ramakrishnan',
      bold: true,
      fontSize: 11
    },
    {
      width: '50%',
      text: form.name,
      bold: true,
      fontSize: 11,
    },

  ],
  columnGap: 180
})

ct.push(
  // { canvas: [{ type: 'line', x1: 348, y1: 0, x2: 515, y2: 0, lineWidth: 0.1 }] },
  { canvas: [{ type: 'line', x1: 332, y1: 0, x2: 490, y2: 0, lineWidth: 0.1 }] },
  { canvas: [{ type: 'line', x1: 0, y1: 0, x2: 150, y2: 0, lineWidth: 0.1 }] }
)

ct.push({
  columns: [

    {
      width: '50%',
      text: 'Name (Print)',
      fontSize: 8,
      margin: [0, 2, 0, 0]
    },
    {
      width: '50%',
      text: "Candidate's Full Name",
      fontSize: 8,
      margin: [0, 2, 0, 0]
    },

  ],
  columnGap: 180
})
ct.push(' ');
// ct.push(' ');
// ct.push({
//   columns: [

//     {
//       width: '50%',
//       text: 'HR Manager',
//       bold: true,
//       fontSize: 11
//     },
//     {
//       width: '50%',
//       text: form.title,
//       // text: this.datepipe.transform(new Date(), "MM/dd/yyyy"),
//       bold: true,
//       fontSize: 11
//     },

//   ],
//   columnGap: 180
// })

// ct.push(
//   { canvas: [{ type: 'line', x1: 348, y1: 0, x2: 515, y2: 0, lineWidth: 0.1 }] },
//   { canvas: [{ type: 'line', x1: 0, y1: 0, x2: 150, y2: 0, lineWidth: 0.1 }] }
// )

// ct.push({
//   columns: [

//     {
//       width: '50%',
//       text: 'Title',
//       fontSize: 8,
//       margin: [0, 2, 0, 0]
//     },
//     {
//       width: '50%',
//       text: 'Title',
//       fontSize: 8,
//       margin: [0, 2, 0, 0]
//     },

//   ],
//   columnGap: 180
// })

// ct.push(' ');
// ct.push(' ');
ct.push({
  table: {
    widths: [150, 180, 150],
    body: [
      [
        {
          image: 'hrsignImage',
          width: '120'
        },
        {

        },
        // {
        //   text: this.signFormMSA.controls['name'].value,
        //   font: 'cedarvillecursiveFont',
        //   fontSize: 15,
        // },
        {
          image: 'userSignImage',
          width: '120'
        },
      ],
      [
        {
          text: this.datepipe.transform(new Date(), "MM/dd/yyyy"),
        },
        {

        },
        {
          text: this.datepipe.transform(new Date(), "MM/dd/yyyy"),
        },
      ],
    ]
  },
  layout: 'noBorders'
})


ct.push(
  // { canvas: [{ type: 'line', x1: 348, y1: 0, x2: 515, y2: 0, lineWidth: 0.1 }] },
  { canvas: [{ type: 'line', x1: 332, y1: 0, x2: 490, y2: 0, lineWidth: 0.1 }] },
  { canvas: [{ type: 'line', x1: 0, y1: 0, x2: 150, y2: 0, lineWidth: 0.1 }] }
)

ct.push({
  columns: [

    {
      width: '50%',
      text: 'Signature & Date',
      fontSize: 8,
      margin: [0, 2, 0, 0]
    },
    {
      width: '50%',
      text: 'Signature & Date',
      fontSize: 8,
      margin: [0, 2, 0, 0]
    },

  ],
  columnGap: 180
})
ct.push({

});
//let value = html.concat(html, ct)
let value = html;
for (let i = 0; i < ct.length; i++) {
  value.push(ct[i])
}
var docDefinition: any = {
  header:  function(currentPage, pageCount, pageSize) {
    //if (currentPage <= 1) {
    //    return [];
    //}
  
    // return {
    //     table: {
    //         widths: [170, 240,'*'],
    //         body: [
    //             [
    //                 { image: 'logoImage',width: '100',},
    //                 { text: 'CONFIDENTIALITY AND NON-COMPETE AGREEMENT', bold:true,fontSize: 9, margin: [-28, 43, 0, 0] },
    //                 { text:''}
    //             ],
    //         ]
    //     },
    //     layout: 'noBorders',
    //     margin: [40, 18, 10, 10]
    // };
    return {
      table: {
          widths: [120, 220, 180],
          body: [
              [
                { image: 'logoDevCare',width: '100', alignment:'left', margin: [12, 0, 5, 0]},
                { text: 'CONFIDENTIALITY AND NON-COMPETE AGREEMENT', bold:true,fontSize: 9, margin: [18, 31, -100, 0] },
                { image: 'logoCMMIISO',width: '155', alignment:'right', margin: [-6, 0, 5, 0]},
              ],
          ],
      },
      layout: 'noBorders',
      margin: [40, 18, 10, 10]
  };
  },
  // pageMargins: [40, 82, 40, 60],
  pageMargins: [54, 64, 54, 58],
  footer: function (currentPage: any, pageCount: any) {
    return {
      table: {
        widths: '*',
        body: [
          [
            { text: 'DevCare Solutions, Ltd.', alignment: 'left', style: 'normalText', margin: [52, 20, 50, 0], aligment: 'right', italics: true },
            { text: 'Page ' + currentPage.toString() + ' of ' + pageCount, alignment: 'right', style: 'normalText', margin: [0, 20, 53, 0], aligment: 'left', italics: true }
          ]
        ]
      },
      layout: 'noBorders'
    };
  },
  permissions: {
    printing: 'highResolution',
    modifying: false,
    copying: false
  },
  content: value,
  defaultStyle: {
    fontSize: 9,
    alignment: 'justify'
  },
  images: {
    hrsignImage: this.hrSign,
    userSignImage: sign,
    logoDevCare: this.logoOnLeft,
    logoCMMIISO: this.logoOnRight,
  }
};

 const pdfDocGenerator = pdfMake.createPdf(docDefinition);
 pdfDocGenerator.getBlob((blob) => {
   this.blobFile = blob;
  //  const url = URL.createObjectURL(blob);
  //  window.open(url, '_blank');
   const file = new File([this.blobFile], "DEVCARENCA.pdf", { type: 'application/pdf' });
   console.log('blob file', this.blobFile);
   this.uploadedNCAFile = file;
   this.documentTypeOnFileUpload = "NCA";
   this.vendoronboardingService.InsertTempVendorDocuments(this.documentTypeOnFileUpload, this.uploadedNCAFile, this.emailLinkRefId).subscribe((data: any) => {
    //  console.log('nca generated',data);
     this.messageService.add({ severity: 'success', summary: 'Confirmed', detail: 'NCA successfully uploaded' });
     this.ncaFormUploadedPath = data.result;
     this.hasNCACompleted = true;
     this.loadingSaveButton = false;
     this.ncaSectionNext();
   },error => {
    console.log(error);
   }
   );
   //this.NCADocumentUploaded = true;
 });
      }, reject: () => {
        this.signFormNCA.patchValue({ ncaConfirmationCheckbox: false });
        this.onNCAConfirmation= false;
        this.loadingSaveButton = false;
        this.hasNCACompleted = false;
      }
    })
  

  }
}
else if(this.isTextTabNCA == true){
  if (this.signFormNCA.controls['signText'].value == '') {
    this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Please add text' });
    this.loadingSaveButton = false;
  }
  else{
    this.confirmationService.confirm({
      header: 'NCA Confirmation',
      message: 'You cannot change the information after submission please verify before submitting the NCA.<br><br><center>Would you like to proceed with submission?</center>',
      icon: 'pi pi-exclamation-triangle required-field',
      accept: () => {

let form = this.signFormNCA.value;
//let sign = this.sigNCA.toDataURL();
var html = undefined;
if(this.NCATemplateOnBrowser.includes("<p style='text-align: center'><span><b>CONFIDENTIALITY AND NON-COMPETE AGREEMENT</b><span></p>"))
{
  this.NCATemplateOnBrowser= this.NCATemplateOnBrowser.replace("<span><b>CONFIDENTIALITY AND NON-COMPETE AGREEMENT</b><span>","")
  console.log(this.NCATemplateOnBrowser);
  html = htmlToPdfmake(this.NCATemplateOnBrowser, { removeExtraBlanks: true });
}
else if(this.NCATemplateOnBrowser.includes("<p class=\"ql-align-center\"><strong>CONFIDENTIALITY AND NON-COMPETE AGREEMENT</strong></p>"))
{
  this.NCATemplateOnBrowser= this.NCATemplateOnBrowser.replace("<strong>CONFIDENTIALITY AND NON-COMPETE AGREEMENT</strong>","")
  console.log(this.NCATemplateOnBrowser);
  html = htmlToPdfmake(this.NCATemplateOnBrowser, { removeExtraBlanks: true });
}
else{
   html = htmlToPdfmake(this.NCATemplateOnBrowser, { removeExtraBlanks: true });
}
var ct: any = [];
ct.push(' ');
ct.push(' ');
ct.push({
  columns: [
    {
      width: '50%',
      text: 'DevCare Solutions, Ltd.',
      bold: true,
      fontSize: 9,
      margin: 0
    },
    {
      width: '50%',
      text: form.applicantName,
      bold: true,
      fontSize: 9,
      margin: 0
    },
  ],
  columnGap: 180
})
ct.push(' ');
ct.push({
  columns: [

    {
      width: '50%',
      text: 'Janakiram Ramakrishnan',
      bold: true,
      fontSize: 11
    },
    {
      width: '50%',
      text: this.nameOnDocumentSubmit,
      bold: true,
      fontSize: 11,
    },

  ],
  columnGap: 180
})

ct.push(
  // { canvas: [{ type: 'line', x1: 348, y1: 0, x2: 515, y2: 0, lineWidth: 0.1 }] },
  { canvas: [{ type: 'line', x1: 332, y1: 0, x2: 490, y2: 0, lineWidth: 0.1 }] },
  { canvas: [{ type: 'line', x1: 0, y1: 0, x2: 150, y2: 0, lineWidth: 0.1 }] }
)

ct.push({
  columns: [

    {
      width: '50%',
      text: 'Name (Print)',
      fontSize: 8,
      margin: [0, 2, 0, 0]
    },
    {
      width: '50%',
      text: "Candidate's Full Name",
      fontSize: 8,
      margin: [0, 2, 0, 0]
    },

  ],
  columnGap: 180
})
ct.push(' ');
// ct.push(' ');
// ct.push({
//   columns: [

//     {
//       width: '50%',
//       text: 'HR Manager',
//       bold: true,
//       fontSize: 11
//     },
//     {
//       width: '50%',
//       text: form.title,
//       // text: this.datepipe.transform(new Date(), "MM/dd/yyyy"),
//       bold: true,
//       fontSize: 11
//     },

//   ],
//   columnGap: 180
// })

// ct.push(
//   { canvas: [{ type: 'line', x1: 348, y1: 0, x2: 515, y2: 0, lineWidth: 0.1 }] },
//   { canvas: [{ type: 'line', x1: 0, y1: 0, x2: 150, y2: 0, lineWidth: 0.1 }] }
// )

// ct.push({
//   columns: [

//     {
//       width: '50%',
//       text: 'Title',
//       fontSize: 8,
//       margin: [0, 2, 0, 0]
//     },
//     {
//       width: '50%',
//       text: 'Title',
//       fontSize: 8,
//       margin: [0, 2, 0, 0]
//     },

//   ],
//   columnGap: 180
// })

// ct.push(' ');
// ct.push(' ');
ct.push({
  table: {
    widths: [150, 180, 150],
    body: [
      [
        {
          image: 'hrsignImage',
          width: '120'
        },
        {

        },
        {
          text: this.nameOnDocumentSubmit,
          font: 'cedarvillecursiveFont',
          fontSize: 15,
        },
      ],
      [
        {
          text: this.datepipe.transform(new Date(), "MM/dd/yyyy"),
        },
        {

        },
        {
          text: this.datepipe.transform(new Date(), "MM/dd/yyyy"),
        },
      ],
    ]
  },
  layout: 'noBorders'
})


ct.push(
  // { canvas: [{ type: 'line', x1: 348, y1: 0, x2: 515, y2: 0, lineWidth: 0.1 }] },
  { canvas: [{ type: 'line', x1: 332, y1: 0, x2: 490, y2: 0, lineWidth: 0.1 }] },
  { canvas: [{ type: 'line', x1: 0, y1: 0, x2: 150, y2: 0, lineWidth: 0.1 }] }
)

ct.push({
  columns: [

    {
      width: '50%',
      text: 'Signature & Date',
      fontSize: 8,
      margin: [0, 2, 0, 0]
    },
    {
      width: '50%',
      text: 'Signature & Date',
      fontSize: 8,
      margin: [0, 2, 0, 0]
    },

  ],
  columnGap: 180
})
ct.push({

});
//let value = html.concat(html, ct)
let value = html;
for (let i = 0; i < ct.length; i++) {
  value.push(ct[i])
}
var docDefinition: any = {
  header:  function(currentPage, pageCount, pageSize) {
    //if (currentPage <= 1) {
    //    return [];
    //}
  
    // return {
    //     table: {
    //         widths: [170, 240,'*'],
    //         body: [
    //             [
    //                 { image: 'logoImage',width: '100',},
    //                 { text: 'CONFIDENTIALITY AND NON-COMPETE AGREEMENT', bold:true,fontSize: 9, margin: [-28, 43, 0, 0] },
    //                 { text:''}
    //             ],
    //         ]
    //     },
    //     layout: 'noBorders',
    //     margin: [40, 18, 10, 10]
    // };
    return {
      table: {
          widths: [120, 220, 180],
          body: [
              [
                { image: 'logoDevCare',width: '100', alignment:'left', margin: [12, 0, 5, 0]},
                { text: 'CONFIDENTIALITY AND NON-COMPETE AGREEMENT', bold:true,fontSize: 9, margin: [18, 31, -100, 0] },
                { image: 'logoCMMIISO',width: '155', alignment:'right', margin: [-6, 0, 5, 0]},
              ],
          ],
      },
      layout: 'noBorders',
      margin: [40, 18, 10, 10]
  };
  },
  // pageMargins: [40, 82, 40, 60],
  pageMargins: [54, 64, 54, 58],
  footer: function (currentPage: any, pageCount: any) {
    return {
      table: {
        widths: '*',
        body: [
          [
            { text: 'DevCare Solutions, Ltd.', alignment: 'left', style: 'normalText', margin: [52, 20, 50, 0], aligment: 'right', italics: true },
            { text: 'Page ' + currentPage.toString() + ' of ' + pageCount, alignment: 'right', style: 'normalText', margin: [0, 20, 53, 0], aligment: 'left', italics: true }
          ]
        ]
      },
      layout: 'noBorders'
    };
  },
  permissions: {
    printing: 'highResolution',
    modifying: false,
    copying: false
  },
  content: value,
  defaultStyle: {
    fontSize: 9,
    alignment: 'justify'
  },
  images: {
    hrsignImage: this.hrSign,
   // userSignImage: sign,
    logoDevCare: this.logoOnLeft,
    logoCMMIISO: this.logoOnRight,
  }
};

 const pdfDocGenerator = pdfMake.createPdf(docDefinition);
 pdfDocGenerator.getBlob((blob) => {
   this.blobFile = blob;
    //  const url = URL.createObjectURL(blob);
    //  window.open(url, '_blank');
   const file = new File([this.blobFile], "DEVCARENCA.pdf", { type: 'application/pdf' });
   console.log('blob file', this.blobFile);
   this.uploadedNCAFile = file;
   this.documentTypeOnFileUpload = "NCA";
   this.vendoronboardingService.InsertTempVendorDocuments(this.documentTypeOnFileUpload, this.uploadedNCAFile, this.emailLinkRefId).subscribe((data: any) => {
    //  console.log('nca generated',data);
     this.messageService.add({ severity: 'success', summary: 'Confirmed', detail: 'NCA successfully uploaded' });
     this.ncaFormUploadedPath = data.result;
     this.hasNCACompleted = true;
     this.loadingSaveButton = false;
     this.ncaSectionNext();
   },error => {
    console.log(error);
   }
   );
   //this.NCADocumentUploaded = true;
 });
      }, reject: () => {
        this.signFormNCA.patchValue({ ncaConfirmationCheckbox: false });
        this.onNCAConfirmation= false;
        this.loadingSaveButton = false;
        this.hasNCACompleted = false;
      }
    })
  }
}

else if(this.isImageUploadTabNCA == true){
  if (this.imgBase64Path == undefined) {
    this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Please upload image' });
    this.loadingSaveButton = false;
  }
  else if (this.imgBase64Path !== undefined) {
    this.confirmationService.confirm({
      header: 'NCA Confirmation',
      message: 'You cannot change the information after submission please verify before submitting the NCA.<br><br><center>Would you like to proceed with submission?</center>',
      icon: 'pi pi-exclamation-triangle required-field',
      accept: () => {

let form = this.signFormNCA.value;
//let sign = this.sigNCA.toDataURL();
var html = undefined;
if(this.NCATemplateOnBrowser.includes("<p style='text-align: center'><span><b>CONFIDENTIALITY AND NON-COMPETE AGREEMENT</b><span></p>"))
{
  this.NCATemplateOnBrowser= this.NCATemplateOnBrowser.replace("<span><b>CONFIDENTIALITY AND NON-COMPETE AGREEMENT</b><span>","")
  console.log(this.NCATemplateOnBrowser);
  html = htmlToPdfmake(this.NCATemplateOnBrowser, { removeExtraBlanks: true });
}
else if(this.NCATemplateOnBrowser.includes("<p class=\"ql-align-center\"><strong>CONFIDENTIALITY AND NON-COMPETE AGREEMENT</strong></p>"))
{
  this.NCATemplateOnBrowser= this.NCATemplateOnBrowser.replace("<strong>CONFIDENTIALITY AND NON-COMPETE AGREEMENT</strong>","")
  console.log(this.NCATemplateOnBrowser);
  html = htmlToPdfmake(this.NCATemplateOnBrowser, { removeExtraBlanks: true });
}
else{
   html = htmlToPdfmake(this.NCATemplateOnBrowser, { removeExtraBlanks: true });
}
var ct: any = [];
ct.push(' ');
ct.push(' ');
ct.push({
  columns: [
    {
      width: '50%',
      text: 'DevCare Solutions, Ltd.',
      bold: true,
      fontSize: 9,
      margin: 0
    },
    {
      width: '50%',
      text: form.applicantName,
      bold: true,
      fontSize: 9,
      margin: 0
    },
  ],
  columnGap: 180
})
ct.push(' ');
ct.push({
  columns: [

    {
      width: '50%',
      text: 'Janakiram Ramakrishnan',
      bold: true,
      fontSize: 11
    },
    {
      width: '50%',
      text: form.name,
      bold: true,
      fontSize: 11,
    },

  ],
  columnGap: 180
})

ct.push(
  // { canvas: [{ type: 'line', x1: 348, y1: 0, x2: 515, y2: 0, lineWidth: 0.1 }] },
  { canvas: [{ type: 'line', x1: 332, y1: 0, x2: 490, y2: 0, lineWidth: 0.1 }] },
  { canvas: [{ type: 'line', x1: 0, y1: 0, x2: 150, y2: 0, lineWidth: 0.1 }] }
)

ct.push({
  columns: [

    {
      width: '50%',
      text: 'Name (Print)',
      fontSize: 8,
      margin: [0, 2, 0, 0]
    },
    {
      width: '50%',
      text: "Candidate's Full Name",
      fontSize: 8,
      margin: [0, 2, 0, 0]
    },

  ],
  columnGap: 180
})
ct.push(' ');
// ct.push(' ');
// ct.push({
//   columns: [

//     {
//       width: '50%',
//       text: 'HR Manager',
//       bold: true,
//       fontSize: 11
//     },
//     {
//       width: '50%',
//       text: form.title,
//       // text: this.datepipe.transform(new Date(), "MM/dd/yyyy"),
//       bold: true,
//       fontSize: 11
//     },

//   ],
//   columnGap: 180
// })

// ct.push(
//   { canvas: [{ type: 'line', x1: 348, y1: 0, x2: 515, y2: 0, lineWidth: 0.1 }] },
//   { canvas: [{ type: 'line', x1: 0, y1: 0, x2: 150, y2: 0, lineWidth: 0.1 }] }
// )

// ct.push({
//   columns: [

//     {
//       width: '50%',
//       text: 'Title',
//       fontSize: 8,
//       margin: [0, 2, 0, 0]
//     },
//     {
//       width: '50%',
//       text: 'Title',
//       fontSize: 8,
//       margin: [0, 2, 0, 0]
//     },

//   ],
//   columnGap: 180
// })

// ct.push(' ');
// ct.push(' ');
ct.push({
  table: {
    widths: [150, 180, 150],
    body: [
      [
        {
          image: 'hrsignImage',
          width: '120'
        },
        {

        },
        // {
        //   text: this.signFormMSA.controls['name'].value,
        //   font: 'cedarvillecursiveFont',
        //   fontSize: 15,
        // },
        {
          image: 'userSignImage',
          width: '120'
        },
      ],
      [
        {
          text: this.datepipe.transform(new Date(), "MM/dd/yyyy"),
        },
        {

        },
        {
          text: this.datepipe.transform(new Date(), "MM/dd/yyyy"),
        },
      ],
    ]
  },
  layout: 'noBorders'
})


ct.push(
  // { canvas: [{ type: 'line', x1: 348, y1: 0, x2: 515, y2: 0, lineWidth: 0.1 }] },
  { canvas: [{ type: 'line', x1: 332, y1: 0, x2: 490, y2: 0, lineWidth: 0.1 }] },
  { canvas: [{ type: 'line', x1: 0, y1: 0, x2: 150, y2: 0, lineWidth: 0.1 }] }
)

ct.push({
  columns: [

    {
      width: '50%',
      text: 'Signature & Date',
      fontSize: 8,
      margin: [0, 2, 0, 0]
    },
    {
      width: '50%',
      text: 'Signature & Date',
      fontSize: 8,
      margin: [0, 2, 0, 0]
    },

  ],
  columnGap: 180
})
ct.push({

});
//let value = html.concat(html, ct)
let value = html;
for (let i = 0; i < ct.length; i++) {
  value.push(ct[i])
}
var docDefinition: any = {
  header:  function(currentPage, pageCount, pageSize) {
    //if (currentPage <= 1) {
    //    return [];
    //}
  
    // return {
    //     table: {
    //         widths: [170, 240,'*'],
    //         body: [
    //             [
    //                 { image: 'logoImage',width: '100',},
    //                 { text: 'CONFIDENTIALITY AND NON-COMPETE AGREEMENT', bold:true,fontSize: 9, margin: [-28, 43, 0, 0] },
    //                 { text:''}
    //             ],
    //         ]
    //     },
    //     layout: 'noBorders',
    //     margin: [40, 18, 10, 10]
    // };
    return {
      table: {
          widths: [120, 220, 180],
          body: [
              [
                { image: 'logoDevCare',width: '100', alignment:'left', margin: [12, 0, 5, 0]},
                { text: 'CONFIDENTIALITY AND NON-COMPETE AGREEMENT', bold:true,fontSize: 9, margin: [18, 31, -100, 0] },
                { image: 'logoCMMIISO',width: '155', alignment:'right', margin: [-6, 0, 5, 0]},
              ],
          ],
      },
      layout: 'noBorders',
      margin: [40, 18, 10, 10]
  };
  },
  // pageMargins: [40, 82, 40, 60],
  pageMargins: [54, 64, 54, 58],
  footer: function (currentPage: any, pageCount: any) {
    return {
      table: {
        widths: '*',
        body: [
          [
            { text: 'DevCare Solutions, Ltd.', alignment: 'left', style: 'normalText', margin: [52, 20, 50, 0], aligment: 'right', italics: true },
            { text: 'Page ' + currentPage.toString() + ' of ' + pageCount, alignment: 'right', style: 'normalText', margin: [0, 20, 53, 0], aligment: 'left', italics: true }
          ]
        ]
      },
      layout: 'noBorders'
    };
  },
  permissions: {
    printing: 'highResolution',
    modifying: false,
    copying: false
  },
  content: value,
  defaultStyle: {
    fontSize: 9,
    alignment: 'justify'
  },
  images: {
    hrsignImage: this.hrSign,
    userSignImage: this.imgBase64Path,
    logoDevCare: this.logoOnLeft,
    logoCMMIISO: this.logoOnRight,
  }
};

 const pdfDocGenerator = pdfMake.createPdf(docDefinition);
 pdfDocGenerator.getBlob((blob) => {
   this.blobFile = blob;
    //  const url = URL.createObjectURL(blob);
    //  window.open(url, '_blank');
   const file = new File([this.blobFile], "DEVCARENCA.pdf", { type: 'application/pdf' });
   console.log('blob file', this.blobFile);
   this.uploadedNCAFile = file;
   this.documentTypeOnFileUpload = "NCA";
   this.vendoronboardingService.InsertTempVendorDocuments(this.documentTypeOnFileUpload, this.uploadedNCAFile, this.emailLinkRefId).subscribe((data: any) => {
    //  console.log('nca generated',data);
     this.messageService.add({ severity: 'success', summary: 'Confirmed', detail: 'NCA successfully uploaded' });
     this.ncaFormUploadedPath = data.result;
     this.hasNCACompleted = true;
     this.loadingSaveButton = false;
     this.ncaSectionNext();
   },error => {
    console.log(error);
   }
   );
   //this.NCADocumentUploaded = true;
 });
      }, reject: () => {
        this.signFormNCA.patchValue({ ncaConfirmationCheckbox: false });
        this.onNCAConfirmation= false;
        this.loadingSaveButton = false;
        this.hasNCACompleted = false;
      }
    })
  }
}


}

handleChangeNCA(e){
  // if(e.index == 0){
  //   this.isSignatureTabNCA = true;
  //   this.isTextTabNCA = false;
  //   this.isImageUploadTabNCA = false;
  // }
  if(e.index == 0){
    this.isTextTabNCA = true;
    this.isSignatureTabNCA = false;
    this.isImageUploadTabNCA = false;
  }
  if(e.index == 1){
    this.isTextTabNCA = false;
    this.isSignatureTabNCA = false;
    this.isImageUploadTabNCA = true;
  }
}
onImageSelectNCASign(event, file: FileList) {
  this.imageFileNCASign = event.target.value;
  this.imageFileNCASign = this.imageFileNCASign.split('\\').pop().split('/').pop();
  if (this.imageFileNCASign.split('.').pop() == 'png' || this.imageFileNCASign.split('.').pop() == 'jpg' || this.imageFileNCASign.split('.').pop() == 'jpeg') {
    this.fileToUploadNCASign = file.item(0);
    //For Image Preview
    let reader = new FileReader();
    reader.onload = (event: any) => {
      this.imageUrlNCASign = event.target.result;
    }
    //console.log(this.fileToUpload);
    reader.readAsDataURL(this.fileToUploadNCASign);
    this.uploadImageFileNCASign();
    this.defaultImageNCASign = "";
  }
  else {
    this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Please select valid file format (png,jpg,jpeg)' });
  }
}

@ViewChild('imageUploadNCASign') imagefileInputNCASign;
uploadImageFileNCASign(): void {
  let fi = this.imagefileInputNCASign.nativeElement;
  if (fi.files && fi.files[0]) {
    this.uploadedFileNCASign = fi.files[0];
    if(this.uploadedFileNCASign .size> 1e+6)
    {
        //alert('1');
    }
    else{
      //alert('2');
    }
    var reader = new FileReader();
    reader.onload = (event:any) => 
    {
        this.imgBase64Path = event.target.result;
        // console.log(this.imgBase64Path);
    }
    reader.readAsDataURL(fi.files[0]);
  }
}

  isBoldOpenNCA = (arrayLength: any, valueBefore = false) => {
    const isEven = arrayLength % 2 === 0;
    const result = valueBefore !== isEven;

    return result;
  }


  onChangeNCAIAgreeAboveTerms(value) {
    this.NCAIAgreeAboveTerms = value.checked;
    // console.log('this.NCAIAgreeAboveTerms - ' + this.NCAIAgreeAboveTerms);
  }
  ncaSectionNext() {
    // if(this.msaTypeIdOnEdit == 2 || this.msaTypeIdOnEdit == 4){
    //   this.tabIndex = 4;
    // }
    // else if(this.msaTypeIdOnEdit == 1 || this.msaTypeIdOnEdit == 3){
    //   this.tabIndex = 3;
    // }
    if(!this.isVendorAvailable)
    {
      this.tabIndex = 4;
      this.messageService.add({severity: 'success', summary: 'Confirmed', detail: 'Details have been added successfully'})
    }
      if(this.isVendorAvailable )
      {
        this.tabIndex =this.tabIndex + 1;
      }
      this.scrollToTop(200);
     
  }
  ncaSectionPrevious() {
    // if(this.msaTypeIdOnEdit == 2 || this.msaTypeIdOnEdit == 4){
    //   this.tabIndex = 2;
    // }
    // else if(this.msaTypeIdOnEdit == 1 || this.msaTypeIdOnEdit == 3){
    //   this.tabIndex = 1;
    // }
    //this.tabIndex = 2;
    if(!this.isVendorAvailable)
      {
        this.tabIndex = 2;
      }
      
      if(this.isVendorAvailable)
      {
        this.tabIndex = this.tabIndex-1;
      }
      this.scrollToTop(200);
  }
  clearNCASign() {
    this.sigNCA.clear();
  }
  
  undoNCASign() {
    var data = this.sigNCA.toData();
    if (data) {
      data.pop(); // remove the last dot or line
      this.sigNCA.fromData(data);
    }
  }
  ////////////NCA accordion methods - End/////////////////
  ///////start////////////////DD Section methods//////

  onDDFormSelect(event) {
    if (event.target.value != '') {
      this.ddFormFileExtension = event.target.value;
      this.ddFormFileExtension = this.ddFormFileExtension.split('\\').pop().split('/').pop();
      if (this.ddFormFileExtension.split('.').pop() == 'pdf' || this.ddFormFileExtension.split('.').pop() == 'docx' || this.ddFormFileExtension.split('.').pop() == 'doc' || this.ddFormFileExtension.split('.').pop() == 'xls' || this.ddFormFileExtension.split('.').pop() == 'xlsx' || this.ddFormFileExtension.split('.').pop() == 'Pdf' || this.ddFormFileExtension.split('.').pop() == 'PDF') {
        this.uploadDDFormFile();
        this.isDDFileShowSuccessMsg = true;
        this.ddFormValid = false;
        this.ddFileUploadMessage = this.ddFormFileExtension;
      }
      else {
        this.hasDDCompleted = false;
        this.ddFormValid = true;
        this.isDDFileShowSuccessMsg = false;
        this.ddFileUploadMessage = "Please select a valid file format (.xls, .xlsx, .pdf, .doc, .docx)";
      }
    }
  }


  // onDDFormSelect(event) {
  //   if (event.target.value != '') {
  //     this.ddFormFileExtension = event.target.value;
  //     this.ddFormFileExtension = this.ddFormFileExtension.split('\\').pop().split('/').pop();
  //     if (this.ddFormFileExtension.split('.').pop() == 'pdf' || this.ddFormFileExtension.split('.').pop() == 'docx' || this.ddFormFileExtension.split('.').pop() == 'doc' || this.ddFormFileExtension.split('.').pop() == 'xls' || this.w9FormFileExtension.split('.').pop() == 'xlsx' || this.ddFormFileExtension.split('.').pop() == 'Pdf' || this.ddFormFileExtension.split('.').pop() == 'PDF') {
  //       this.uploadDDFormFile();
  //       this.isDDFileShowSuccessMsg = true;
  //       this.ddFormValid = false;
  //       this.ddFileUploadMessage = this.ddFormFileExtension;
  //     }
  //     else {
  //       this.hasDDCompleted = false;
  //       this.ddFormValid = true;
  //       this.isDDFileShowSuccessMsg = false;
  //       this.ddFileUploadMessage = "Please select a valid file format (.xls, .xlsx, .pdf, .doc, .docx)";
  //     }
  //   }
  // }

  @ViewChild('DDFormUpload') ddFormfileInput;
  uploadDDFormFile(): void {
    this.loadingUploadButton = true;
   // this.hasDDCompleted=true;
    let fi = this.ddFormfileInput.nativeElement;
    if (fi.files && fi.files[0]) {
      this.uploadedDDFile = fi.files[0];
      this.documentTypeOnFileUpload = 'DD';
      this.vendoronboardingService.InsertTempVendorDocuments(this.documentTypeOnFileUpload, this.uploadedDDFile, this.emailLinkRefId).subscribe((res) => {
        if(res != undefined){
          this.ddFormUploadedPath = res.result;
        }
        this.messageService.add({ severity: 'success', summary: 'Confirmed', detail: 'DD successfully uploaded' });
        // this.ddFormUploadedPath = res;
        console.log(this.ddFormUploadedPath);
        //this.splittedDDformUploadedPath = this.ddFormUploadedPath.split("/");
        //res = res.substring(1);
        //this.ddFileDocUrl = VMSConstants.registrationDocumentBaseUrl + res;
        this.showDDFormFilePreview = false;
        this.hasDDCompleted = true;
        this.loadingUploadButton = false;
        // this.ddSectionNext()
        this.ddFormfileInput.nativeElement.value = '';
      });
    }
  }


  ShowDDUploadedFile() {
    const ref = this.dialogService.open(DocViewerDialogComponent, {
      data: {
        fileUrl: this.ddFileDocUrl,
        title: 'W9 Form',
        fileName: this.ddFileDocUrl,
      },
      width: '100%',
      height: '100%',
      baseZIndex: 10000,
      showHeader: false,
    });
  }
  ddSectionPrevious() {
    // if(this.msaTypeIdOnEdit == 2 || this.msaTypeIdOnEdit == 4){
    //   this.tabIndex = 3;
    // }
    // else if(this.msaTypeIdOnEdit == 1 || this.msaTypeIdOnEdit == 3){
    //   this.tabIndex = 2;
    // }
    if(!this.isVendorAvailable)
    {
      if(this.showNCAAccordion == true){
        this.tabIndex = 3;
      }
      else if(this.showNCAAccordion == false){
        this.tabIndex = 2;
      }
    }
      if(this.isVendorAvailable && !this.isNCASelected)
        {
          this.tabIndex = this.tabIndex-1;
        }
        if(this.isVendorAvailable && this.isNCASelected)
          {
            if(this.showNCAAccordion == true){
              this.tabIndex =this.tabIndex - 1;
              this.scrollToTop(200);
            this.messageService.add({severity: 'success', summary: 'Confirmed', detail: 'Details have been added successfully'});
            this.clearNCASign();
            }
            else if(this.showNCAAccordion == false){
            this.tabIndex =this.tabIndex - 2;
            this.messageService.add({severity: 'success', summary: 'Confirmed', detail: 'Details have been added successfully'});
            //this.clearNCASign();
            }
          }
    
      
     this.scrollToTop(200);
    // this.tabIndex = 3;
  }
  ddSectionNext() {
    // if(this.msaTypeIdOnEdit == 2 || this.msaTypeIdOnEdit == 4){
    //   this.tabIndex = 5;
    // }
    // else if(this.msaTypeIdOnEdit == 1 || this.msaTypeIdOnEdit == 3){
    //   this.tabIndex = 4;
    // }
    if (this.isMSAType1099) {
      let value = this.companyProfileDDForm.getRawValue();
      if (this.ddOldCompanyName != value.companyName || this.ddOldAddress != value.address || this.ddOldBankName != value.bankName
        || this.ddOldAccountType != value.accountType || this.ddOldRoutingNumber != value.routingNumber || this.ddOldAccountNumber != value.accountNumber
        || this.ddOldSignature != value.signature || this.ddOldConfirmationCheckbox == value.ddConfirmationCheckbox) 
      {
        this.messageService.add({ severity: 'warn', summary: 'Warning', detail: 'One or more fields have been modified. Please preview the template again before proceeding to the next step.' })
        this.hasDDCompleted = false;
        this.hasDDPrivewCompleted = false;
        return;
      }
      this.confirmationService.confirm({
      header: 'DD Confirmation - Please confirm your Account details.',
      message: 'Please verify the information before submitting the DD, as changes cannot be made once submitted. Would you like to proceed with the submission?',
      icon: 'pi pi-exclamation-triangle required-field',
      accept: () => {
    if(!this.isVendorAvailable)
    {
      this.tabIndex = 5;
      this.hasDDCompleted = true;
      this.messageService.add({severity: 'success', summary: 'Confirmed', detail: 'Details have been added successfully'})
    }
    if(this.isVendorAvailable )
      {
        this.tabIndex =this.tabIndex + 1;
        this.hasDDCompleted = true;
      }
      this.scrollToTop(200);
   }, reject: () => {
        this.signFormNCA.patchValue({ ncaConfirmationCheckbox: false });
        this.hasDDCompleted= false;
        this.onDDConfirmation = false;
        this.hasDDPrivewCompleted = false;
        this.companyProfileDDForm.controls['ddConfirmationCheckbox'].setValue(false);
      }
    })
    }
    else{
    if(!this.isVendorAvailable)
    {
      this.tabIndex = 5;
      this.messageService.add({severity: 'success', summary: 'Confirmed', detail: 'Details have been added successfully'})
    }
    if(this.isVendorAvailable )
      {
        this.tabIndex =this.tabIndex + 1;
      }
      this.scrollToTop(200);
    }
  }
  ddSectionSkip() {
    // if(this.msaTypeIdOnEdit == 2 || this.msaTypeIdOnEdit == 4){
    //   this.tabIndex = 5;
    // }
    // else if(this.msaTypeIdOnEdit == 1 || this.msaTypeIdOnEdit == 3){
    //   this.tabIndex = 4;
    // }
    this.tabIndex = 5;
    this.scrollToTop(200);
  }
  
  ////////end///////////////DD Section methods/////////
  ///////start////////////////VoidCheque Section methods//////
  onVoidChequeFormSelect(event) {
    if (event.target.value != '') {
      this.voidChequeFormFileExtension = event.target.value;
      this.voidChequeFormFileExtension = this.voidChequeFormFileExtension.split('\\').pop().split('/').pop();
      if (this.voidChequeFormFileExtension.split('.').pop() == 'pdf' || this.voidChequeFormFileExtension.split('.').pop() == 'docx' || this.voidChequeFormFileExtension.split('.').pop() == 'doc' || this.voidChequeFormFileExtension.split('.').pop() == 'xls' || this.voidChequeFormFileExtension.split('.').pop() == 'xlsx' || this.voidChequeFormFileExtension.split('.').pop() == 'Pdf' || this.voidChequeFormFileExtension.split('.').pop() == 'PDF'
      || this.voidChequeFormFileExtension.split('.').pop() == 'png' || this.voidChequeFormFileExtension.split('.').pop() == 'jpeg' || this.voidChequeFormFileExtension.split('.').pop() == 'jpg' ||
    this.voidChequeFormFileExtension.split('.').pop() == 'gif' || this.voidChequeFormFileExtension.split('.').pop() == 'bmp') {
        this.uploadVoidChequeFormFile();
        this.isVoidChequeFileShowSuccessMsg = true;
        this.voidChequeFormValid = false;
        this.voidChequeFileUploadMessage = this.voidChequeFormFileExtension;
      }
      else {
        this.hasVoidChequeCompleted = false;
        this.voidChequeFormValid = true;
        this.isVoidChequeFileShowSuccessMsg = false;
        this.voidChequeFileUploadMessage = "Please select a valid file format (.xls, .xlsx, .pdf, .doc, .docx, .jpg, .png, .gif, .bmp)";
      }
    }
  }

  @ViewChild('VoidChequeFormUpload') voidChequeFormfileInput;
  uploadVoidChequeFormFile(): void {
    this.loadingUploadButton = true;
    let fi = this.voidChequeFormfileInput.nativeElement;
    if (fi.files && fi.files[0]) {
      this.uploadedVoidChequeFile = fi.files[0];
      this.documentTypeOnFileUpload = 'VOID';
      this.vendoronboardingService.InsertTempVendorDocuments(this.documentTypeOnFileUpload, this.uploadedVoidChequeFile, this.emailLinkRefId).subscribe((res) => {
        if(res != undefined){
          this.voidChequeFormUploadedPath = res.result;
        }
        this.messageService.add({ severity: 'success', summary: 'Confirmed', detail: 'VoidCheque successfully uploaded' });
        // this.voidChequeFormUploadedPath = res;
        // this.splittedVoidChequeformUploadedPath = this.voidChequeFormUploadedPath.split("/");
        /// res = res.substring(1);
        // this.voidChequeFileDocUrl = VMSConstants.registrationDocumentBaseUrl + res;
        this.showVoidChequeFormFilePreview = false;
        this.hasVoidChequeCompleted = true;
        this.loadingUploadButton = false;
        // this.voidChequeSectionNext();
        this.voidChequeFormfileInput.nativeElement.value = '';
      });
    }
  }
  ShowVoidChequeUploadedFile() {
    const ref = this.dialogService.open(DocViewerDialogComponent, {
      data: {
        fileUrl: this.voidChequeFileDocUrl,
        title: 'W9 Form',
        fileName: this.voidChequeFileDocUrl,
      },
      width: '100%',
      height: '100%',
      baseZIndex: 10000,
      showHeader: false,
    });
  }
  voidChequeSectionNext() {
    // if(this.msaTypeIdOnEdit == 2 || this.msaTypeIdOnEdit == 4){
    //   this.tabIndex = 6;
    // }
    // else if(this.msaTypeIdOnEdit == 1 || this.msaTypeIdOnEdit == 3){
    //   this.tabIndex = 5;
    // }
    if(!this.isVendorAvailable)
    {
      this.tabIndex = 6;
      this.messageService.add({severity: 'success', summary: 'Confirmed', detail: 'Details have been added successfully'})
    }
      if(this.isVendorAvailable )
      {
        this.tabIndex =this.tabIndex + 1;
      }
      this.scrollToTop(200);
  }
  voidChequeSectionSkip() {
    // if(this.msaTypeIdOnEdit == 2 || this.msaTypeIdOnEdit == 4){
    //   this.tabIndex = 6;
    // }
    // else if(this.msaTypeIdOnEdit == 1 || this.msaTypeIdOnEdit == 3){
    //   this.tabIndex = 5;
    // }
    this.tabIndex = 6;
    this.scrollToTop(200);
  }
  voidChequeSectionPrevious() {
    // if(this.msaTypeIdOnEdit == 2 || this.msaTypeIdOnEdit == 4){
    //   this.tabIndex = 4;
    // }
    // else if(this.msaTypeIdOnEdit == 1 || this.msaTypeIdOnEdit == 3){
    //   this.tabIndex = 3;
    // }
    //this.tabIndex = 4;
    if(!this.isVendorAvailable)
      {
        this.tabIndex = 4;
      }
      if(this.isVendorAvailable)
        {
        if(this.isVendorAvailable && this.isDDSelected)
        {
          this.tabIndex= this.tabIndex-1;
        }
          
        //if(this.isVendorAvailable && !this.isNCASelected)
        //{
          //  this.tabIndex= this.tabIndex-1;
        //}
        else if(this.isVendorAvailable && this.isNCASelected)
        {
              if(this.showNCAAccordion == true){
                this.tabIndex =this.tabIndex - 1;
                this.scrollToTop(200);
              this.messageService.add({severity: 'success', summary: 'Confirmed', detail: 'Details have been added successfully'});
              this.clearNCASign();
              }
              else if(this.showNCAAccordion == false){
              this.tabIndex =this.tabIndex - 2;
              this.messageService.add({severity: 'success', summary: 'Confirmed', detail: 'Details have been added successfully'});
              //this.clearNCASign();
              }
        }
        else if(this.isVendorAvailable &&(this.isMSASelected || this.isPOSelected))
        {
          this.tabIndex =this.tabIndex - 1;
        }
        else{
          this.tabIndex =this.tabIndex - 1;
        }
        }
      this.scrollToTop(200);
  }
  ////////end///////////////Voidcheque Section methods/////////
  ////////start////////////coi section methods////////

  insuranceExhibitDownloadFile(){
  //   if(this.insuranceExhibitA == 1){
  //   let link = document.createElement("a");
  //   link.download = "InsuranceExhibitA.pdf";
  //   link.href = "assets/pdf/Standard-ExA.pdf";
  //   link.click();
  // }
  // if(this.insuranceExhibitA == 2){
  //   let link = document.createElement("a");
  //   link.download = "InsuranceExhibitA.pdf";
  //   link.href = "assets/pdf/Knowledge Services - Ohio.pdf";
  //   link.click();
  // }
  // else if(this.insuranceExhibitA == 3){
  //   let link = document.createElement("a");
  //   link.download = "InsuranceExhibitA.pdf";
  //   link.href = "assets/pdf/Knowledge Services - Michigan.pdf";
  //   link.click();
  // }
  // else if(this.insuranceExhibitA == 4){
  //   let link = document.createElement("a");
  //   link.download = "InsuranceExhibitA.pdf";
  //   link.href = "assets/pdf/OST - Pennsylvania.pdf";
  //   link.click();
  // }
  // else if(this.insuranceExhibitA == 5){
  //   let link = document.createElement("a");
  //   link.download = "InsuranceExhibitA.pdf";
  //   link.href = "assets/pdf/Computer Aid - North Carolina.pdf";
  //   link.click();
  // }
  // else if(this.insuranceExhibitA == 6){
  //   let link = document.createElement("a");
  //   link.download = "InsuranceExhibitA.pdf";
  //   link.href = "assets/pdf/Covendis - CO, OR, GA.pdf";
  //   link.click();
  // }
  if (this.insuranceExhibitA >= 1 && this.insuranceExhibitA <= 6) {
    let link = document.createElement("a");
    link.download = "InsuranceExhibitA.pdf";
    switch (this.insuranceExhibitA) {
      case 1:
        link.href = "assets/pdf/Standard-ExA.pdf";
        break;
      case 2:
        link.href = "assets/pdf/Knowledge-Service-Ohio-ExA.pdf";
        break;
      case 3:
        link.href = "assets/pdf/Knowledge-Service-Michigan-ExA.pdf";
        break;
      case 4:
        link.href = "assets/pdf/OST-Pennsylvania-ExA.pdf";
        break;
      case 5:
        link.href = "assets/pdf/Computer-Aid-North-Carolina-ExA.pdf";
        break;
      case 6:
        link.href = "assets/pdf/Covendis-CO-OR-GA-ExA.pdf";
        break;
    }
    link.click();
  }
    
  }

  coiDownloadFile(){
     let link = document.createElement("a");
    link.download = "COI.pdf";
    link.href = "assets/pdf/COI.pdf";
    link.click();
  }

  companyCOIDetailsForm() {
    this.companyCOIDetailsRequestForm = this.formBuilder.group({    
      glEffDate: [],
      glExpDate: [],
      alEffDate: [],
      alExpDate: [],
      ulEffDate: [],
      ulExpDate: [],
      wcEffDate: [],
      wcExpDate: [],
      plEffDate: [],
      plExpDate: [],
    });
  }

  onInsuranceSelectRequest(event) {
    if (event.target.value != '') {
      this.InsuranceFileExtension = event.target.value;
      this.InsuranceFileExtension = this.InsuranceFileExtension.split('\\').pop().split('/').pop();
      if (this.InsuranceFileExtension.split('.').pop() == 'pdf' || this.InsuranceFileExtension.split('.').pop() == 'docx' || this.InsuranceFileExtension.split('.').pop() == 'doc' || this.InsuranceFileExtension.split('.').pop() == 'xls' || this.InsuranceFileExtension.split('.').pop() == 'xlsx' || this.InsuranceFileExtension.split('.').pop() == 'PDF' || this.InsuranceFileExtension.split('.').pop() == 'Pdf') {

        this.uploadInsuranceFileOnRequest();
        this.isInsurancefileShowsuccessmsgOnRequest = true;
        //this.coiValid = false;
        this.InsurancefileuploadmessageOnRequest = this.InsuranceFileExtension;
        event.target.value = "";
      }
      else {
        this.hasCOICompleted = false;
        //this.coiValid = true;
        this.isInsurancefileShowsuccessmsgOnRequest = false;
        this.InsurancefileuploadmessageOnRequest = "Please select a valid file format (.xls, .xlsx, .pdf, .doc, .docx)";
      }
    }
  }
  @ViewChild('InsuranceUploadRequest') InsurancefileInputRequest;
  uploadInsuranceFileOnRequest(): void {
    this.loadingUploadButton = true;
    let fi = this.InsurancefileInputRequest.nativeElement;
    if (fi.files && fi.files[0]) {
      this.uploadedInsuranceFile = fi.files[0];
      this.documentTypeOnFileUpload = 'COI';
      this.vendoronboardingService.InsertTempVendorDocuments(this.documentTypeOnFileUpload, this.uploadedInsuranceFile, this.emailLinkRefId).subscribe((res) => {
        //console.log('response', res);
        if(res != undefined){
          this.InsuranceUploadedPathRequest = res.result;
        }
        this.messageService.add({ severity: 'success', summary: 'Confirmed', detail: 'COI successfully uploaded' });
        // this.InsuranceUploadedPathRequest = res;
        // this.splittedInsuranceUploadedPathOnRequest = this.InsuranceUploadedPathRequest.split("/");
        // this.coiFileDocUrlOnRequest = VMSConstants.registrationDocumentBaseUrl + res;
        this.hasCOICompleted = true;
        this.loadingUploadButton = false;
        // this.coiSectionNext();
      });
    }

  }
  ShowInsuranceUploadedFileOnRequest() {
    const ref = this.dialogService.open(DocViewerDialogComponent, {
      data: {
        fileUrl: this.coiFileDocUrlOnRequest,
        title: 'COI',
        fileName: this.coiFileDocUrlOnRequest,
      },
      width: '100%',
      height: '100%',
      baseZIndex: 10000,
      showHeader: false,
    });
  }
  onSelectGlEffDate(event) {
    const localDateString = event.toLocaleDateString('En-en');
    this.glEffSelectedDate = new Date(localDateString);
    var selectedGLEffDate = new Date(this.glEffSelectedDate);
    //selectedGLEffDate.setDate( selectedGLEffDate.getDate() - 1);
    this.glEffSelectedDate = selectedGLEffDate;
    this.companyCOIDetailsRequestForm.controls['glExpDate'].setValue(undefined);
  }
  onSelectAlEffDate(event) {
    const localDateString = event.toLocaleDateString('En-en');
    this.alEffSelectedDate = new Date(localDateString);
    var selectedALEffDate = new Date(this.alEffSelectedDate);
    //selectedALEffDate.setDate( selectedALEffDate.getDate() - 1);
    this.alEffSelectedDate = selectedALEffDate;
    this.companyCOIDetailsRequestForm.controls['alExpDate'].setValue(undefined);
  }
  onSelectUlEffDate(event) {
    const localDateString = event.toLocaleDateString('En-en');
    this.ulEffSelectedDate = new Date(localDateString);
    var selectedULEffDate = new Date(this.ulEffSelectedDate);
    // selectedULEffDate.setDate( selectedULEffDate.getDate() - 1);
    this.ulEffSelectedDate = selectedULEffDate;
    this.companyCOIDetailsRequestForm.controls['ulExpDate'].setValue(undefined);
  }
  onSelectWcEffDate(event) {
    const localDateString = event.toLocaleDateString('En-en');
    this.wcEffSelectedDate = new Date(localDateString);
    var selectedWCEffDate = new Date(this.wcEffSelectedDate);
    // selectedWCEffDate.setDate( selectedWCEffDate.getDate() - 1);
    this.wcEffSelectedDate = selectedWCEffDate;
    this.companyCOIDetailsRequestForm.controls['wcExpDate'].setValue(undefined);
  }
  onSelectPlEffDate(event) {
    const localDateString = event.toLocaleDateString('En-en');
    this.plEffSelectedDate = new Date(localDateString);
    var selectedPLEffDate = new Date(this.plEffSelectedDate);
    //selectedPLEffDate.setDate( selectedPLEffDate.getDate() - 1);
    this.plEffSelectedDate = selectedPLEffDate;
    this.companyCOIDetailsRequestForm.controls['plExpDate'].setValue(undefined);
  }

  coiDetailsSave({ value }: { value: any }) {
    // value.insuranceFileUrl = this.InsuranceUploadedPathRequest;
    var currentDate = new Date();

    if (value.glEffDate != null) {
      var glEffDate = value.glEffDate.toDateString();
      let formatedglEffDate = new Date(glEffDate);
      var strformat = formatedglEffDate.toString();
      if (strformat.includes("India")) {
        formatedglEffDate.setDate(formatedglEffDate.getDate() + 1);
      }
      else {
        formatedglEffDate.setDate(formatedglEffDate.getDate());
      }
      value.glEffDate = (value.glEffDate === null) ? null : formatedglEffDate;
    }

    if (value.glExpDate != null) {
      var glExpDate = value.glExpDate.toDateString();
      let formatedglExpDate = new Date(glExpDate);
      var strformat = formatedglExpDate.toString();
      if (strformat.includes("India")) {
        formatedglExpDate.setDate(formatedglExpDate.getDate() + 1);
      }
      else {
        formatedglExpDate.setDate(formatedglExpDate.getDate());
      }
      value.glExpDate = (value.glExpDate === null) ? null : formatedglExpDate;
    }

    if (value.alEffDate != null) {
      var alEffDate = value.alEffDate.toDateString();
      let formatedalEffDate = new Date(alEffDate);
      var strformat = formatedalEffDate.toString();
      if (strformat.includes("India")) {
        formatedalEffDate.setDate(formatedalEffDate.getDate() + 1);
      }
      else {
        formatedalEffDate.setDate(formatedalEffDate.getDate());
      }
      value.alEffDate = (value.alEffDate === null) ? null : formatedalEffDate;
    }

    if (value.alExpDate != null) {
      var alExpDate = value.alExpDate.toDateString();
      let formatedalExpDate = new Date(alExpDate);
      var strformat = formatedalExpDate.toString();
      if (strformat.includes("India")) {
        formatedalExpDate.setDate(formatedalExpDate.getDate() + 1);
      }
      else {
        formatedalExpDate.setDate(formatedalExpDate.getDate());
      }
      value.alExpDate = (value.alExpDate === null) ? null : formatedalExpDate;
    }

    if (value.ulEffDate != null) {
      var ulEffDate = value.ulEffDate.toDateString();
      let formatedulEffDate = new Date(ulEffDate);
      var strformat = formatedulEffDate.toString();
      if (strformat.includes("India")) {
        formatedulEffDate.setDate(formatedulEffDate.getDate() + 1);
      }
      else {
        formatedulEffDate.setDate(formatedulEffDate.getDate());
      }
      value.ulEffDate = (value.ulEffDate === null) ? null : formatedulEffDate;
    }

    if (value.ulExpDate != null) {
      var ulExpDate = value.ulExpDate.toDateString();
      let formatedulExpDate = new Date(ulExpDate);
      var strformat = formatedulExpDate.toString();
      if (strformat.includes("India")) {
        formatedulExpDate.setDate(formatedulExpDate.getDate() + 1);
      }
      else {
        formatedulExpDate.setDate(formatedulExpDate.getDate());
      }
      value.ulExpDate = (value.ulExpDate === null) ? null : formatedulExpDate;
    }

    if (value.wcEffDate != null) {
      var wcEffDate = value.wcEffDate.toDateString();
      let formatedwcEffDate = new Date(wcEffDate);
      var strformat = formatedwcEffDate.toString();
      if (strformat.includes("India")) {
        formatedwcEffDate.setDate(formatedwcEffDate.getDate() + 1);
      }
      else {
        formatedwcEffDate.setDate(formatedwcEffDate.getDate());
      }
      value.wcEffDate = (value.wcEffDate === null) ? null : formatedwcEffDate;
    }

    if (value.wcExpDate != null) {
      var wcExpDate = value.wcExpDate.toDateString();
      let formatedwcExpDate = new Date(wcExpDate);
      var strformat = formatedwcExpDate.toString();
      if (strformat.includes("India")) {
        formatedwcExpDate.setDate(formatedwcExpDate.getDate() + 1);
      }
      else {
        formatedwcExpDate.setDate(formatedwcExpDate.getDate());
      }
      value.wcExpDate = (value.wcExpDate === null) ? null : formatedwcExpDate;
    }


    if (value.plEffDate != null) {
      var plEffDate = value.plEffDate.toDateString();
      let formatedplEffDate = new Date(plEffDate);
      var strformat = formatedplEffDate.toString();
      if (strformat.includes("India")) {
        formatedplEffDate.setDate(formatedplEffDate.getDate() + 1);
      }
      else {
        formatedplEffDate.setDate(formatedplEffDate.getDate());
      }
      value.plEffDate = (value.plEffDate === null) ? null : formatedplEffDate;
    }

    if (value.plExpDate != null) {
      var plExpDate = value.plExpDate.toDateString();
      let formatedplExpDate = new Date(plExpDate);
      var strformat = formatedplExpDate.toString();
      if (strformat.includes("India")) {
        formatedplExpDate.setDate(formatedplExpDate.getDate() + 1);
      }
      else {
        formatedplExpDate.setDate(formatedplExpDate.getDate());
      }
      value.plExpDate = (value.plExpDate === null) ? null : formatedplExpDate;
    }
    this.glEffDateToSubmit = value.glEffDate;
    this.glExpDateToSubmit = value.glExpDate;
    this.alEffDateToSubmit = value.alEffDate;
    this.alExpDateToSubmit = value.alExpDate;
    this.ulEffDateToSubmit = value.ulEffDate;
    this.ulExpDateToSubmit = value.ulExpDate;
    this.wcEffDateToSubmit = value.wcEffDate;
    this.wcExpDateToSubmit = value.wcExpDate;
    this.plEffDateToSubmit = value.plEffDate;
    this.plExpDateToSubmit = value.plExpDate;
    // this.insuranceFileUrl = value.insuranceFileUrl;
    this.coiSectionNext();
  }
  coiSectionNext() {
    // if(this.msaTypeIdOnEdit == 2 || this.msaTypeIdOnEdit == 4){
    //   this.tabIndex = 7;
    // }
    // else if(this.msaTypeIdOnEdit == 1 || this.msaTypeIdOnEdit == 3){
    //   this.tabIndex = 6;
    // }
    if(!this.isVendorAvailable)
    {
      this.tabIndex = 7;
      this.messageService.add({severity: 'success', summary: 'Confirmed', detail: 'Details have been added successfully'})
    }
    if(this.isVendorAvailable )
      {
        this.tabIndex =this.tabIndex + 1;
      }
      this.scrollToTop(200);
  }
  coiSectionSkip() {
    // if(this.msaTypeIdOnEdit == 2 || this.msaTypeIdOnEdit == 4){
    //   this.tabIndex = 7;
    // }
    // else if(this.msaTypeIdOnEdit == 1 || this.msaTypeIdOnEdit == 3){
    //   this.tabIndex = 6;
    // }
    this.tabIndex = 7;
    this.scrollToTop(200);
  }
  coiSectionPrevious() {
    // if(this.msaTypeIdOnEdit == 2 || this.msaTypeIdOnEdit == 4){
    //   this.tabIndex = 5;
    // }
    // else if(this.msaTypeIdOnEdit == 1 || this.msaTypeIdOnEdit == 3){
    //   this.tabIndex = 4;
    // }
    //this.tabIndex = 5;
    if(!this.isVendorAvailable)
      {
        this.tabIndex = 5;
      }
      if(this.isVendorAvailable)
        {
        if(this.isVendorAvailable && (this.isVoidChequeSelected || this.isDDSelected))
        {
          this.tabIndex= this.tabIndex-1;
        }
          
        //if(this.isVendorAvailable && !this.isNCASelected)
        //{
          //  this.tabIndex= this.tabIndex-1;
        //}
        else if(this.isVendorAvailable && this.isNCASelected)
        {
              if(this.showNCAAccordion == true){
                this.tabIndex =this.tabIndex - 1;
                this.scrollToTop(200);
              this.messageService.add({severity: 'success', summary: 'Confirmed', detail: 'Details have been added successfully'});
              this.clearNCASign();
              }
              else if(this.showNCAAccordion == false){
              this.tabIndex =this.tabIndex - 2;
              this.messageService.add({severity: 'success', summary: 'Confirmed', detail: 'Details have been added successfully'});
              //this.clearNCASign();
              }
        }
        else if(this.isVendorAvailable &&(this.isMSASelected || this.isPOSelected))
        {
          this.tabIndex =this.tabIndex - 1;
        }
        else{
          this.tabIndex =this.tabIndex - 1;
        }
        }
      this.scrollToTop(200);
      
      
      
  }
  ////////end////////////coi section methods////////
  ///////start////////////////W9 Section methods//////
  // onW9FormSelect(event) {
  //   if (event.target.value != '') {
  //     this.w9FormFileExtension = event.target.value;
  //     this.w9FormFileExtension = this.w9FormFileExtension.split('\\').pop().split('/').pop();
  //     if (this.w9FormFileExtension.split('.').pop() == 'pdf' || this.w9FormFileExtension.split('.').pop() == 'docx' || this.w9FormFileExtension.split('.').pop() == 'doc' || this.i9FormFileExtension.split('.').pop() == 'xls' || this.w9FormFileExtension.split('.').pop() == 'xlsx' || this.w9FormFileExtension.split('.').pop() == 'Pdf' || this.w9FormFileExtension.split('.').pop() == 'PDF') {
  //       this.uploadW9FormFile();
  //       this.isW9FileShowSuccessMsg = true;
  //       this.w9FormValid = false;
  //       this.w9FileUploadMessage = this.w9FormFileExtension;
  //     }
  //     else {
  //       this.hasW9Completed = false;
  //       this.w9FormValid = true;
  //       this.isW9FileShowSuccessMsg = false;
  //       this.w9FileUploadMessage = "Please select a valid file format (.xls, .xlsx, .pdf, .doc, .docx)";
  //     }
  //   }
  // }

  onW9FormSelect(event) {
    if (event.target.value != '') {
      this.w9FormFileExtension = event.target.value;
      this.w9FormFileExtension = this.w9FormFileExtension.split('\\').pop().split('/').pop();
      if (this.w9FormFileExtension.split('.').pop() == 'pdf' || this.w9FormFileExtension.split('.').pop() == 'docx' || this.w9FormFileExtension.split('.').pop() == 'doc' || this.w9FormFileExtension.split('.').pop() == 'xls' || this.w9FormFileExtension.split('.').pop() == 'xlsx' || this.w9FormFileExtension.split('.').pop() == 'Pdf' || this.w9FormFileExtension.split('.').pop() == 'PDF') {
        this.uploadW9FormFile();
        this.isW9FileShowSuccessMsg = true;
        this.w9FormValid = false;
        this.w9FileUploadMessage = this.w9FormFileExtension;
      }
      else {
        this.hasW9Completed = false;
        this.w9FormValid = true;
        this.isW9FileShowSuccessMsg = false;
        this.w9FileUploadMessage = "Please select a valid file format (.xls, .xlsx, .pdf, .doc, .docx)";
      }
    }
  }

  @ViewChild('W9FormUpload') w9FormfileInput;
  uploadW9FormFile(): void {
    this.loadingUploadButton = true;
    let fi = this.w9FormfileInput.nativeElement;
    if (fi.files && fi.files[0]) {
      this.uploadedW9File = fi.files[0];
      this.documentTypeOnFileUpload = 'W9';
      this.vendoronboardingService.InsertTempVendorDocuments(this.documentTypeOnFileUpload, this.uploadedW9File, this.emailLinkRefId).subscribe((res) => {
        if(res != undefined){
          this.w9FormUploadedPath = res.result;
        }
        this.messageService.add({ severity: 'success', summary: 'Confirmed', detail: 'W9 successfully uploaded' });
        // this.w9FormUploadedPath = res;
        //this.splittedW9formUploadedPath = this.w9FormUploadedPath.split("/");
        //res = res.substring(1);
        // this.w9FileDocUrl = VMSConstants.registrationDocumentBaseUrl + res;
        this.showW9FormFilePreview = false;
        this.hasW9Completed = true;
        this.loadingUploadButton = false;
        // this.w9SectionNext();
        this.w9FormfileInput.nativeElement.value = '';
      });
    }
  }
  ShowW9UploadedFile() {
    const ref = this.dialogService.open(DocViewerDialogComponent, {
      data: {
        fileUrl: this.w9FileDocUrl,
        title: 'W9 Form',
        fileName: this.w9FileDocUrl,
      },
      width: '100%',
      height: '100%',
      baseZIndex: 10000,
      showHeader: false,
    });
  }
  w9SectionNext() {
    // if(this.msaTypeIdOnEdit == 2 || this.msaTypeIdOnEdit == 4){
    //   this.tabIndex = 8;
    // }
    // else if(this.msaTypeIdOnEdit == 1 || this.msaTypeIdOnEdit == 3){
    //   this.tabIndex = 7;
    // }
    let value = this.companyProfileW9Form.getRawValue();
    if (this.isMSAType1099) {
      if (this.w9OldName !== value.name || this.w9OldBusinessName !== value.businessName || this.w9OldFederalTaxClassi !== value.federalTaxClassi ||
        this.w9OldLlcTax !== value.llcTax || this.w9OldOthers !== value.others || this.w9OldAddress !== value.address ||
        this.w9OldCityZipState !== value.cityZipState || this.w9OldListAccNumber !== value.listAccNumber || this.w9OldReqNameAddress !== value.reqNameAddress ||
        this.w9OldExemptPayeeCode !== value.exemptPayeeCode || this.w9OldExemptFATCA !== value.exemptFATCA || this.w9OldTypeofTNS !== value.typeofTNS ||
        this.w9OldSsn !== value.ssn || this.w9OldEin !== value.ein || this.w9OldSignature !== value.signature || this.w9OldW9ConfirmationCheckbox !== value.w9ConfirmationCheckbox) {
        this.messageService.add({ severity: 'warn', summary: 'Warning', detail: 'One or more fields have been modified. Please preview the template again before proceeding to the next step.' })
        this.hasW9Completed = false;
        this.hasW9PrivewCompleted = false;
        return;
      }
this.confirmationService.confirm({
      header: 'W-9 Confirmation - Please confirm your Information.',
      message: 'Please Verify the information before submitting the W-9, as changes cannot be made once submitted. Would you like to proceed with the submission?',
      icon: 'pi pi-exclamation-triangle required-field',
      accept: () => {
    if(!this.isVendorAvailable)
    {
      this.tabIndex = 8;
      this.hasW9Completed = true;
      this.messageService.add({severity: 'success', summary: 'Confirmed', detail: 'Details have been added successfully'});
    }
    if(this.isVendorAvailable )
      {
        this.hasW9Completed = true;
        this.tabIndex =this.tabIndex + 1;
      }
      this.scrollToTop(200);
   }, reject: () => {
        this.signFormNCA.patchValue({ ncaConfirmationCheckbox: false });
        this.hasW9Completed= false;
        this.onW9Confirmation = false;
        this.hasW9PrivewCompleted = false;
        this.companyProfileW9Form.controls['w9ConfirmationCheckbox'].setValue(false);
      }
    })
    }
    else{
    if(!this.isVendorAvailable)
    {
      this.tabIndex = 8;
      this.messageService.add({severity: 'success', summary: 'Confirmed', detail: 'Details have been added successfully'});
    }
    if(this.isVendorAvailable )
      {
        this.tabIndex =this.tabIndex + 1;
      }
      this.scrollToTop(200);
    }
  }
  w9SectionSkip() {
    // if(this.msaTypeIdOnEdit == 2 || this.msaTypeIdOnEdit == 4){
    //   this.tabIndex = 8;
    // }
    // else if(this.msaTypeIdOnEdit == 1 || this.msaTypeIdOnEdit == 3){
    //   this.tabIndex = 7;
    // }
    this.tabIndex = 8;
    this.scrollToTop(200);
  }
  w9SectionPrevious() {
    // if(this.msaTypeIdOnEdit == 2 || this.msaTypeIdOnEdit == 4){
    //   this.tabIndex = 6;
    // }
    // else if(this.msaTypeIdOnEdit == 1 || this.msaTypeIdOnEdit == 3){
    //   this.tabIndex = 5;
    // }
    //this.tabIndex = 6;
    if(!this.isVendorAvailable)
      {
        this.tabIndex = 6;
      }
      if(this.isVendorAvailable)
        {
        if(this.isVendorAvailable && (this.isVoidChequeSelected || this.isCOISelected|| this.isDDSelected))
        {
          this.tabIndex= this.tabIndex-1;
        }
          
        //if(this.isVendorAvailable && !this.isNCASelected)
        //{
          //  this.tabIndex= this.tabIndex-1;
        //}
        else if(this.isVendorAvailable && this.isNCASelected)
        {
              if(this.showNCAAccordion == true){
                this.tabIndex =this.tabIndex - 1;
                this.scrollToTop(200);
              this.messageService.add({severity: 'success', summary: 'Confirmed', detail: 'Details have been added successfully'});
              this.clearNCASign();
              }
              else if(this.showNCAAccordion == false){
              this.tabIndex =this.tabIndex - 2;
              this.messageService.add({severity: 'success', summary: 'Confirmed', detail: 'Details have been added successfully'});
              //this.clearNCASign();
              }
        }
        else if(this.isVendorAvailable &&(this.isMSASelected || this.isPOSelected))
        {
          this.tabIndex =this.tabIndex - 1;
        }
        else{
          this.tabIndex =this.tabIndex - 1;
        }
        }
      
      this.scrollToTop(200);
  }
  ////////end///////////////W9 Section methods/////////
  ///////start////////////////I9 Section methods//////
  onI9FormSelect(event) {
    if (event.target.value != '') {
      this.i9FormFileExtension = event.target.value;
      this.i9FormFileExtension = this.i9FormFileExtension.split('\\').pop().split('/').pop();
      if (this.i9FormFileExtension.split('.').pop() == 'pdf' || this.i9FormFileExtension.split('.').pop() == 'docx' || this.i9FormFileExtension.split('.').pop() == 'doc' || this.i9FormFileExtension.split('.').pop() == 'xls' || this.i9FormFileExtension.split('.').pop() == 'xlsx' || this.i9FormFileExtension.split('.').pop() == 'Pdf' || this.i9FormFileExtension.split('.').pop() == 'PDF') {
        this.uploadI9FormFile();
        this.isI9FileShowSuccessMsg = true;
        this.i9FormValid = false;
        this.i9FileUploadMessage = this.i9FormFileExtension;
      }
      else {
        this.hasI9Completed = false;
        this.i9FormValid = true;
        this.isI9FileShowSuccessMsg = false;
        this.i9FileUploadMessage = "Please select a valid file format (.xls, .xlsx, .pdf, .doc, .docx)";
      }
    }
  }

  @ViewChild('I9FormUpload') i9FormfileInput;
  uploadI9FormFile(): void {
    this.loadingUploadButton = true;
    let fi = this.i9FormfileInput.nativeElement;
    if (fi.files && fi.files[0]) {
      this.uploadedI9File = fi.files[0];
      this.documentTypeOnFileUpload = 'I9';
      this.vendoronboardingService.InsertTempVendorDocuments(this.documentTypeOnFileUpload, this.uploadedI9File, this.emailLinkRefId).subscribe((res) => {
        if(res != undefined){
          this.i9FormUploadedPath = res.result;
        }
        this.messageService.add({ severity: 'success', summary: 'Confirmed', detail: 'I9 successfully uploaded' });
        // this.i9FormUploadedPath = res;
        //this.splittedI9formUploadedPath = this.i9FormUploadedPath.split("/");
        //res = res.substring(1);
        //this.i9FileDocUrl = VMSConstants.registrationDocumentBaseUrl + res;
        this.showI9FormFilePreview = false;
        this.hasI9Completed = true;
        this.loadingUploadButton = false;
        // this.i9SectionNext();
        this.i9FormfileInput.nativeElement.value = '';
      });
    }
  }
  ShowI9UploadedFile() {
    const ref = this.dialogService.open(DocViewerDialogComponent, {
      data: {
        fileUrl: this.i9FileDocUrl,
        title: 'W9 Form',
        fileName: this.i9FileDocUrl,
      },
      width: '100%',
      height: '100%',
      baseZIndex: 10000,
      showHeader: false,
    });
  }
  i9SectionNext() {
    // if(this.msaTypeIdOnEdit == 2 || this.msaTypeIdOnEdit == 4){
    //   this.tabIndex = 9;
    // }
    // else if(this.msaTypeIdOnEdit == 1 || this.msaTypeIdOnEdit == 3){
    //   this.tabIndex = 8;
    // }
    if(!this.isVendorAvailable)
    {
      this.tabIndex = 9;
      this.messageService.add({severity: 'success', summary: 'Confirmed', detail: 'Details have been added successfully'});
    }
    if(this.isVendorAvailable )
      {
        this.tabIndex =this.tabIndex + 1;
      }
      this.scrollToTop(250);
  }
  i9SectionSkip() {
    // if(this.msaTypeIdOnEdit == 2 || this.msaTypeIdOnEdit == 4){
    //   this.tabIndex = 9;
    // }
    // else if(this.msaTypeIdOnEdit == 1 || this.msaTypeIdOnEdit == 3){
    //   this.tabIndex = 8;
    // }
    this.tabIndex = 9;
    this.scrollToTop(250);
    // this.messageService.add({severity: 'success', summary: 'Confirmed', detail: 'Details have been added successfully'})
  }
  i9SectionPrevious() {
    // if(this.msaTypeIdOnEdit == 2 || this.msaTypeIdOnEdit == 4){
    //   this.tabIndex = 7;
    // }
    // else if(this.msaTypeIdOnEdit == 1 || this.msaTypeIdOnEdit == 3){
    //   this.tabIndex = 6;
    // }
    //this.tabIndex = 7;
    if(!this.isVendorAvailable)
      {
        this.tabIndex = 7;
      }
      if(this.isVendorAvailable)
      {
      if(this.isVendorAvailable && (this.isVoidChequeSelected ||this.isW9Selected || this.isCOISelected|| this.isDDSelected))
      {
        this.tabIndex= this.tabIndex-1;
      }
        
      //if(this.isVendorAvailable && !this.isNCASelected)
      //{
        //  this.tabIndex= this.tabIndex-1;
      //}
      else if(this.isVendorAvailable && this.isNCASelected)
      {
            if(this.showNCAAccordion == true){
              this.tabIndex =this.tabIndex - 1;
              this.scrollToTop(200);
            this.messageService.add({severity: 'success', summary: 'Confirmed', detail: 'Details have been added successfully'});
            this.clearNCASign();
            }
            else if(this.showNCAAccordion == false){
            this.tabIndex =this.tabIndex - 2;
            this.messageService.add({severity: 'success', summary: 'Confirmed', detail: 'Details have been added successfully'});
            //this.clearNCASign();
            }
      }
      else if(this.isVendorAvailable &&(this.isMSASelected || this.isPOSelected))
      {
        this.tabIndex =this.tabIndex - 1;
      }
      else{
        this.tabIndex =this.tabIndex - 1;
      }
      }
      this.scrollToTop(200);
  }
  ////////end///////////////I9 Section methods/////////
  ///////start////////////////Everification Section methods//////
  onEverificationFormSelect(event) {
    if (event.target.value != '') {
      this.everificationFormFileExtension = event.target.value;
      this.everificationFormFileExtension = this.everificationFormFileExtension.split('\\').pop().split('/').pop();
      if (this.everificationFormFileExtension.split('.').pop() == 'pdf' || this.everificationFormFileExtension.split('.').pop() == 'docx' || this.everificationFormFileExtension.split('.').pop() == 'doc' || this.everificationFormFileExtension.split('.').pop() == 'xls' || this.everificationFormFileExtension.split('.').pop() == 'xlsx' || this.everificationFormFileExtension.split('.').pop() == 'Pdf' || this.everificationFormFileExtension.split('.').pop() == 'PDF') {
        this.uploadeverificationFormFile();
        this.isEverificationFileShowSuccessMsg = true;
        this.everificationFormValid = false;
        this.everificationFileUploadMessage = this.everificationFormFileExtension;
      }
      else {
        this.hasEverificationCompleted = false;
        this.everificationFormValid = true;
        this.isEverificationFileShowSuccessMsg = false;
        this.everificationFileUploadMessage = "Please select a valid file format (.xls, .xlsx, .pdf, .doc, .docx)";
      }
    }
  }

  @ViewChild('EverificationFormUpload') everificationFormfileInput;
  uploadeverificationFormFile(): void {
    this.loadingUploadButton = true;
    let fi = this.everificationFormfileInput.nativeElement;
    if (fi.files && fi.files[0]) {
      this.uploadedEverificationFile = fi.files[0];
      this.documentTypeOnFileUpload = 'Everification';
      this.vendoronboardingService.InsertTempVendorDocuments(this.documentTypeOnFileUpload, this.uploadedEverificationFile, this.emailLinkRefId).subscribe((res) => {
        if(res != undefined){
          this.everificationFormUploadedPath = res.result;
        }
        this.messageService.add({ severity: 'success', summary: 'Confirmed', detail: 'everification successfully uploaded' });
        //this.splittedEverificationformUploadedPath = this.everificationFormUploadedPath.split("/");
        //  res = res.substring(1);
        // this.everificationFileDocUrl = VMSConstants.registrationDocumentBaseUrl + res;
        this.showEverificationFormFilePreview = false;
        this.hasEverificationCompleted = true;
        this.loadingUploadButton = false;
        this.everificationFormfileInput.nativeElement.value = '';
      });
    }
  }
  ShowEverificationUploadedFile() {
    const ref = this.dialogService.open(DocViewerDialogComponent, {
      data: {
        fileUrl: this.everificationFileDocUrl,
        title: 'W9 Form',
        fileName: this.everificationFileDocUrl,
      },
      width: '100%',
      height: '100%',
      baseZIndex: 10000,
      showHeader: false,
    });
  }
  everificationSectionPrevious() {
    // if(this.msaTypeIdOnEdit == 2 || this.msaTypeIdOnEdit == 4){
    //   this.tabIndex = 9;
    // }
    // else if(this.msaTypeIdOnEdit == 1 || this.msaTypeIdOnEdit == 3){
    //   this.tabIndex = 7;
    // }
    if(!this.isVendorAvailable)
    {
      this.tabIndex = 8;
      this.scrollToTop(200);
    }
    if(this.isVendorAvailable)
    {
      if(this.isVendorAvailable && (this.isVoidChequeSelected || this.isI9Selected ||this.isW9Selected || this.isCOISelected|| this.isDDSelected))
      {
        this.tabIndex= this.tabIndex-1;
      }
        
      //if(this.isVendorAvailable && !this.isNCASelected)
      //{
        //  this.tabIndex= this.tabIndex-1;
      //}
      else if(this.isVendorAvailable && this.isNCASelected)
      {
            if(this.showNCAAccordion == true){
              this.tabIndex =this.tabIndex - 1;
              this.scrollToTop(200);
            this.messageService.add({severity: 'success', summary: 'Confirmed', detail: 'Details have been added successfully'});
            this.clearNCASign();
            }
            else if(this.showNCAAccordion == false){
            this.tabIndex =this.tabIndex - 2;
            this.scrollToTop(200);
            this.messageService.add({severity: 'success', summary: 'Confirmed', detail: 'Details have been added successfully'});
            //this.clearNCASign();
            }
      }
      else if(this.isVendorAvailable &&(this.isMSASelected || this.isPOSelected))
      {
        this.tabIndex =this.tabIndex - 1;
      }
      else{
        this.tabIndex =this.tabIndex - 1;
      }
      this.scrollToTop(200);
    }

      
   
    
   
  }
  ////////end///////////////everification Section methods/////////

  editorMaxLength(maxlength): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } => {
      var regex = /(<([^>]+)>)/ig;
      var value = control.value;
      if (value == null) {
        return null;
      }
      var result = value.replace(regex, "");
      if (result.length > maxlength) {
        return { 'maxlengthError': true };
      }else{
        return null;
      }
    }
  }

  submitCompanyProfileAndVendorOnboardDetails() {
    this.loadingSaveButton=true;
    // console.log(this.msaFormUploadedPath, this.poFormUploadedPath, this.ncaFormUploadedPath, this.ddFormUploadedPath, this.voidChequeFormUploadedPath
    //   , this.InsuranceUploadedPathRequest, this.w9FormUploadedPath, this.i9FormUploadedPath, this.everificationFormUploadedPath);
    const vendorOnboardDetails: IVendorOnboardingDetails = {
      entityTypeId: this.entityTypeId,
      vendorName: this.vendorNameToSubmit,
      taxIdNumber: this.taxIdNumberToSubmit,
      primaryEmail: this.vendorEmailIdToSubmit,
      primaryPhone: this.vendorPhoneToSubmit,
      primaryPhoneExt: this.vendorExtToSubmit,
      faxNumber: this.faxNumberToSubmit,
      website: this.webAddressToSubmit,
      addressLine1: this.addressLine1ToSubmit,
      addressLine2: this.addressLine2ToSubmit,
      city: this.cityToSubmit,
      stateId: this.stateId,
      zipCode: this.zipCodeToSubmit,
      zipCodeExt: this.zipCodeExtToSubmit,
      countryId: this.middleNameToSubmit,
      paymentTermsId: this.paymentTermsId,
      vendorAdminFirstName: this.firstNameToSubmit,
      vendorAdminMiddleName: this.middleNameToSubmit,
      vendorAdminLastName: this.lastNameToSubmit,
      vendorAdminEmail: this.adminEmailToSubmit,
      vendorAdminPhone: this.adminPhoneToSubmit,
      vendorAdminPhoneExt: this.adminExtToSubmit,
      glEffDate: this.glEffDateToSubmit,
      glExpDate: this.glExpDateToSubmit,
      alEffDate: this.alEffDateToSubmit,
      alExpDate: this.alExpDateToSubmit,
      ulEffDate: this.ulEffDateToSubmit,
      ulExpDate: this.ulExpDateToSubmit,
      wcEffDate: this.wcEffDateToSubmit,
      wcExpDate: this.wcExpDateToSubmit,
      plEffDate: this.plEffDateToSubmit,
      plExpDate: this.plExpDateToSubmit,
      insuranceFileUrl: this.InsuranceUploadedPath,
      msaDocumentDetails: { customFileName: this.msaFormUploadedPath },
      poDocumentDetails: { customFileName: this.poFormUploadedPath  },
      ncaDocumentDetails: { customFileName: this.ncaFormUploadedPath  },
      ddDocumentDetails: { customFileName: this.ddFormUploadedPath  },
      coiDocumentDetails: { customFileName: this.InsuranceUploadedPathRequest  },
      voidChequeDocumentDetails: { customFileName: this.voidChequeFormUploadedPath  },
      w9DocumentDetails: { customFileName: this.w9FormUploadedPath  },
      i9DocumentDetails: { customFileName: this.i9FormUploadedPath  },
      everificationDocumentDetails: { customFileName: this.everificationFormUploadedPath  },
      hasProfileStepCompleted: this.hasCompanyProfileCompleted,
      hasMSAStepCompleted: this.hasMSACompleted,
      hasPOStepCompleted: this.hasPOCompleted,
      hasNCAStepCompleted: this.hasNCACompleted,
      hasDDStepCompleted: this.hasDDCompleted,
      hasVoidChequeStepCompleted: this.hasVoidChequeCompleted,
      hasCOIStepCompleted: this.hasCOICompleted,
      hasW9StepCompleted: this.hasW9Completed,
      hasI9StepCompleted: this.hasI9Completed,
      hasEVerificationStepCompleted: this.hasEverificationCompleted,
      tempVendorId: this.tempVendorId,
      emailLinkRefId: this.emailLinkRefId,
      modifiedBy: 1,
      submittedByEmail: this.linkSharedEmailId,
      createdBy: this.createdBy,
      vendorSubmittedOn: new Date(),
      modifiedOn: new Date(),
      ssnNumber:this.ssnNumberToSubmit,
      comments: (this.commentsControl.value == null ? null : this.commentsControl.value),
      isMSASelected:this.isMSASelected,
      isPOSelected:this.isPOSelected,
      isNCASelected:this.isNCASelected,
      isDDSelected:this.isDDSelected,
      isCOISelected:this.isCOISelected,
      isW9Selected:this.isW9Selected,
      isI9Selected:this.isI9Selected,
      isVoidChequeSelected:this.isVoidChequeSelected,
      isEVerificationSelected:this.isEVerificationSelected,
      isVendorAvailable:this.isVendorAvailable,
      vendorId:this.vendorId,

    };
    // console.log(vendorOnboardDetails);
    this.vendoronboardingService.SubmitVendorOnboardDetails(vendorOnboardDetails).subscribe((data:any)=>{
      // this.router.navigateByUrl('/login');
      this.commentsControl.setValue('');
      this.saveModal=true;
    });
    // this.confirmationService.confirm({
    //   key:'submitSucessDialog',
    //   header:'Confirmation - Onboarding Details Submitted',
    //   message:'The details have been submitted successfully. Our accounts team will verify your details and respond once approved or provide with further details',
    //   accept: () => {
    //     console.log('this');
    //     this.router.navigateByUrl('/login');
    //   }, reject:() =>{
    //     this.router.navigateByUrl('/login');
    //   }
    // })
  }
  saveRedirect() {
    setTimeout(() => {
      this.spinner.show();
      setTimeout(() => {
        this.loadingSaveButton=false;
        this.spinner.hide();
      }, 2000);
      this.router.navigate(['/login']);
    }, 1000);
  }
/////////////////vendor details accordion////////start////
vendorForm() {
  console.log('for');
  this.vendorDetailsForm = this.formBuilder.group({
    vendorName: ['', [Validators.required]],
    taxIdNumber: [''],
    ssnNumber: [''],
    nameOnDocument:['',[Validators.required]],
    addressLine1:[''],
  });
}
get vendorDetailsFormEditControl() {
  return this.vendorDetailsForm.controls;
}

OnMSAConfirmationCheckBoxChange(value) {
  this.onMSAConfirmation = value.checked;
}
OnPOConfirmationCheckBoxChange(value) {
  this.onPOConfirmation = value.checked;
}
OnNCAConfirmationCheckBoxChange(value) {
  this.onNCAConfirmation = value.checked;
}

  OnDDConfirmationCheckBoxChange(value) {
    this.onDDConfirmation = value.checked;
  }

  async ddSubmitForPrev() {
    this.loadingUploadButton = true;
    const value = this.companyProfileDDForm.value;
    this.setDDNewValue(value);
    const existingPdfBytes = await fetch('../../../../assets/pdf/DD_Auth.pdf').then(res => res.arrayBuffer());
    const pdfDoc = await PDFDocument.load(existingPdfBytes);

    const pages = pdfDoc.getPages();
    const firstPage = pages[0];
    pdfDoc.registerFontkit(fontkit);
    // Load a font
    const font = await pdfDoc.embedFont(StandardFonts.Helvetica);

    // Load custom Cedarville Cursive font
    const cedarvilleBytes = await fetch('../../../../assets/fonts/Cedarville-Cursive.ttf')
      .then(res => res.arrayBuffer());
    const cedarvilleFont = await pdfDoc.embedFont(cedarvilleBytes);

    // Draw text at desired coordinates (x, y from bottom-left)
    firstPage.drawText(value.companyName, {
      x: 190,
      y: 580,
      size: 12,
      font,
      color: rgb(0, 0, 0),
    });

    firstPage.drawText(value.address, {
      x: 190,
      y: 552,
      size: 12,
      font,
      color: rgb(0, 0, 0),
    });

    firstPage.drawText(value.bankName, {
      x: 190,
      y: 525,
      size: 12,
      font,
      color: rgb(0, 0, 0),
    });

    if (value.accountType == 'Checking Account') {
      firstPage.drawText('X', {
        x: 193,
        y: 500,
        size: 14,
        font,
        color: rgb(0, 0, 0),
      });
    }
    else {
      firstPage.drawText('X', {
        x: 324,
        y: 500,
        size: 14,
        font,
        color: rgb(0, 0, 0),
      });
    }

    firstPage.drawText(value.routingNumber, {
      x: 190,
      y: 475,
      size: 12,
      font,
      color: rgb(0, 0, 0),
    });

    firstPage.drawText(value.accountNumber, {
      x: 190,
      y: 450,
      size: 12,
      font,
      color: rgb(0, 0, 0),
    });

    firstPage.drawText(value.signature, {
      x: 206,
      y: 165,
      size: 18,
      font: cedarvilleFont,
      color: rgb(0, 0, 0),
    });

    firstPage.drawText(value.date, {
      x: 490,
      y: 165,
      size: 12,
      font,
      color: rgb(0, 0, 0),
    });

    // const imageBytes = await fetch('../../../../assets/check.png').then(res => res.arrayBuffer());
    // const checkImage = await pdfDoc.embedPng(imageBytes);
    //   firstPage.drawImage(checkImage, {
    //     x: 195,
    //     y: 496,
    //     width: 12,
    //     height: 12,
    //   });

    const pdfBytes = await pdfDoc.save();

    const blob = new Blob([pdfBytes], { type: 'application/pdf' });
    //saveAs(blob, 'Filled-DD.pdf');

    const file = new File([blob], "Filled-DD.pdf", { type: "application/pdf" });
    if (file) {
      this.uploadedDDFile = file;
      this.documentTypeOnFileUpload = 'DD';
      this.vendoronboardingService.InsertTempVendorDocuments(this.documentTypeOnFileUpload, this.uploadedDDFile, this.emailLinkRefId).subscribe((res) => {
        if (res != undefined) {
          this.ddFormUploadedPath = res.result;
        }
        this.messageService.add({ severity: 'success', summary: 'Confirmed', detail: 'DD successfully uploaded' });
        // this.ddFormUploadedPath = res;
        console.log(this.ddFormUploadedPath);
        //this.splittedDDformUploadedPath = this.ddFormUploadedPath.split("/");
        //res = res.substring(1);
        this.ddFileDocUrl = VMSConstants.vendorOnboardingDocumentBaseUrl + this.emailLinkRefId +'/' + res.result;
        this.showDDFormFilePreview = false;
        //this.hasDDCompleted = true;
        this.hasDDPrivewCompleted = true;
        this.loadingUploadButton = false;
        // this.ddSectionNext()
        this.documentPreview(this.ddFileDocUrl, res.result, 'DD Form');
        this.ddFormfileInput.nativeElement.value = '';
      });
    }

    // const url = '../../../../assets/pdf/DD_Auth.pdf'
    // const ref = this.dialogService.open(DocViewerDialogComponent, {
    //   data: {
    //     fileUrl: url,
    //     title: 'DD Form',
    //     fileName: url,
    //   },
    //   width: '100%',
    //   height: '100%',
    //   baseZIndex: 10000,
    //   showHeader: false,
    // });
  }

  onCategoryClick(event: any) {
    const llcTax = this.companyProfileW9Form.get('llcTax');
    const others = this.companyProfileW9Form.get('others');
    if (event.value == 'LLC Tax Classification') {
      this.isOthers = false;
      this.isLLC = true;
      others.setValue(null);
      llcTax.setValidators([Validators.required]);
      others.clearValidators();
    }
    else if (event.value == 'others') {
      this.isOthers = true;
      this.isLLC = false;
      llcTax.setValue(null);
      others.setValidators([Validators.required]);
      llcTax.clearValidators();
    }
    else {
      this.isOthers = false;
      this.isLLC = false;
      llcTax.setValue(null);
      llcTax.clearValidators();
      others.setValue(null);
      others.clearValidators();
    }
    llcTax.updateValueAndValidity();
    others.updateValueAndValidity();
  }

  onTINCategoryClick(event: any) {
    const ssn = this.companyProfileW9Form.get('ssn');
    const ein = this.companyProfileW9Form.get('ein');
    if (event.value == 'SSN') {
      this.isSSN = true;
      this.isEIN = false;
      ein.setValue(null);
      ssn.setValidators([Validators.required]);
      //ssn.setValue(this.ssnNumberToSubmit)
      ein.clearValidators();
    }
    else if (event.value == 'EIN') {
      this.isSSN = false;
      this.isEIN = true;
      ssn.setValue(null);
      ein.setValidators([Validators.required]);
      ssn.clearValidators();
    }
    else {
      this.isSSN = false;
      this.isEIN = false;
      ssn.setValue(null);
      ssn.clearValidators();
      ein.setValue(null);
      ein.clearValidators();
    }
    ssn.updateValueAndValidity();
    ein.updateValueAndValidity();
  }

  validateInput(event: any) {
    const inputChar = event.data;
    if (inputChar && inputChar !== 'x' && isNaN(Number(inputChar))) {
      event.target.value = event.target.value.replace(inputChar, '');
    }
  }

  OnW9ConfirmationCheckBoxChange(value) {
    this.onW9Confirmation = value.checked;
    console.log("value - ", this.companyProfileI9Form.value)
  }


  async w9SubmitForPrev({ value }: { value: any }) {
    value = this.companyProfileW9Form.value;
    this.setW9NewValue(value);
    this.loadingUploadButton = true;
    const existingPdfBytes = await fetch('../../../../assets/pdf/W9.pdf').then(res => res.arrayBuffer());
    const pdfDoc = await PDFDocument.load(existingPdfBytes);

    const pages = pdfDoc.getPages();
    const firstPage = pages[0];
    pdfDoc.registerFontkit(fontkit);
    // Load a font
    const font = await pdfDoc.embedFont(StandardFonts.Helvetica);
    // Load custom Cedarville Cursive font
    const cedarvilleBytes = await fetch('../../../../assets/fonts/Cedarville-Cursive.ttf')
      .then(res => res.arrayBuffer());
    const cedarvilleFont = await pdfDoc.embedFont(cedarvilleBytes);

    // Draw text at desired coordinates (x, y from bottom-left)
    firstPage.drawText(value.name, {
      x: 75,
      y: 688,
      size: 10,
      font,
      color: rgb(0, 0, 0),
    });

    firstPage.drawText(value.businessName ? value.businessName : "", {
      x: 75,
      y: 665,
      size: 10,
      font,
      color: rgb(0, 0, 0),
    });

    if (value.federalTaxClassi == 'single-member LLC') {
      firstPage.drawText('X', {
        x: 67,
        y: 626,
        size: 8,
        font,
        color: rgb(0, 0, 0),
      });
    }
    else if (value.federalTaxClassi == 'C Corporation') {
      firstPage.drawText('X', {
        x: 181,
        y: 627,
        size: 8,
        font,
        color: rgb(0, 0, 0),
      });
    }
    else if (value.federalTaxClassi == 'S Corporation') {
      firstPage.drawText('X', {
        x: 253,
        y: 627,
        size: 8,
        font,
        color: rgb(0, 0, 0),
      });
    }
    else if (value.federalTaxClassi == 'Partnership') {
      firstPage.drawText('X', {
        x: 325,
        y: 627,
        size: 8,
        font,
        color: rgb(0, 0, 0),
      });
    }
    else if (value.federalTaxClassi == 'Trust/estate') {
      firstPage.drawText('X', {
        x: 397,
        y: 627,
        size: 8,
        font,
        color: rgb(0, 0, 0),
      });
    }
    else if (value.federalTaxClassi == 'LLC Tax Classification') {
      firstPage.drawText('X', {
        x: 67,
        y: 601,
        size: 8,
        font,
        color: rgb(0, 0, 0),
      });

      firstPage.drawText(value.llcTax ? value.llcTax : "", {
        x: 415,
        y: 601,
        size: 10,
        font,
        color: rgb(0, 0, 0),
      });
    }
    else if (value.federalTaxClassi == 'others') {
      firstPage.drawText('X', {
        x: 67,
        y: 555,
        size: 8,
        font,
        color: rgb(0, 0, 0),
      });

      firstPage.drawText(value.others ? value.others : "", {
        x: 165,
        y: 555,
        size: 10,
        font,
        color: rgb(0, 0, 0),
      });
    }
    firstPage.drawText(value.exemptPayeeCode ? value.exemptPayeeCode : "", {
      x: 541,
      y: 615,
      size: 10,
      font,
      color: rgb(0, 0, 0),
    });

    firstPage.drawText(value.exemptFATCA ? value.exemptFATCA : "", {
      x: 508,
      y: 578,
      size: 10,
      font,
      color: rgb(0, 0, 0),
    });

    firstPage.drawText(value.address, {
      x: 75,
      y: 532,
      size: 10,
      font,
      color: rgb(0, 0, 0),
    });


    firstPage.drawText(value.cityZipState, {
      x: 75,
      y: 508,
      size: 10,
      font,
      color: rgb(0, 0, 0),
    });

    firstPage.drawText(value.listAccNumber ? value.listAccNumber : "", {
      x: 75,
      y: 484,
      size: 10,
      font,
      color: rgb(0, 0, 0),
    });

    // firstPage.drawText(value.reqNameAddress ? value.reqNameAddress : "", {
    //   x: 389,
    //   y: 535,
    //   size: 10,
    //   font,
    //   color: rgb(0, 0, 0),
    // });

    const text = value.reqNameAddress ? value.reqNameAddress : "";
    // Break into chunks of 40 characters
    const chunks: string[] = text.match(/.{1,40}/g) || [];

    let startY = 535;
    const lineHeight = 13; // distance between lines

    chunks.forEach((line, index) => {
      firstPage.drawText(line, {
        x: 392,
        y: startY - (index * lineHeight),
        size: 10,
        font,
        color: rgb(0, 0, 0),
      });
    });

    // SSN Start
    if (value.ssn) {
      const ssnDigits = value.ssn?.split('');
      // Starting x/y positions for the first box
      let x = 423; // change based on box position
      let y = 440;
      const digitSpacing = 14; // adjust spacing to align with each box

      // Draw each digit separately
      for (let i = 0; i < ssnDigits.length; i++) {
        const digit = ssnDigits[i];

        firstPage.drawText(digit, {
          x,
          y,
          size: 12,
          font,
          color: rgb(0, 0, 0),
        });

        x += digitSpacing;

        // Extra space after 3rd and 5th digit (after first and second block)
        if (i === 2 || i === 4) {
          x += 15; // adjust spacing between the SSN blocks
        }
      }
    }
    // SSN End

    // ein Start
    if (value.ein) {
      const einDigits = value.ein?.split('');
      // Starting x/y positions for the first box
      let x = 423; // change based on box position
      let y = 390;
      const digitSpacingEIN = 14; // adjust spacing to align with each box

      // Draw each digit separately
      for (let i = 0; i < einDigits.length; i++) {
        const digitEIN = einDigits[i];

        firstPage.drawText(digitEIN, {
          x,
          y,
          size: 12,
          font,
          color: rgb(0, 0, 0),
        });

        x += digitSpacingEIN;

        // Extra space after 3rd and 5th digit (after first and second block)
        if (i === 1) {
          x += 15; // adjust spacing between the SSN blocks
        }
      }
    }
    // ein End

    firstPage.drawText(value.signature ? value.signature : "", {
      x: 131,
      y: 235,
      size: 16,
      font: cedarvilleFont,
      color: rgb(0, 0, 0),
    });

    firstPage.drawText(value.date, {
      x: 422,
      y: 232,
      size: 10,
      font,
      color: rgb(0, 0, 0),
    });

    const pdfBytes = await pdfDoc.save();

    const blob = new Blob([pdfBytes], { type: 'application/pdf' });
    //saveAs(blob, 'Filled-W9.pdf');


    const file = new File([blob], "Filled-w9.pdf", { type: "application/pdf" });
    if (file) {
      this.uploadedW9File = file;
      this.documentTypeOnFileUpload = 'W9';
      this.vendoronboardingService.InsertTempVendorDocuments(this.documentTypeOnFileUpload, this.uploadedW9File, this.emailLinkRefId).subscribe((res) => {
        if (res != undefined) {
          this.w9FormUploadedPath = res.result;
        }
        this.messageService.add({ severity: 'success', summary: 'Confirmed', detail: 'W9 successfully uploaded' });
        // this.w9FormUploadedPath = res;
        //this.splittedW9formUploadedPath = this.w9FormUploadedPath.split("/");
        //res = res.substring(1);
        this.w9FileDocUrl = VMSConstants.vendorOnboardingDocumentBaseUrl + this.emailLinkRefId +'/' + res.result;
        this.showW9FormFilePreview = false;
        //this.hasW9Completed = true;
        this.hasW9PrivewCompleted = true;
        this.loadingUploadButton = false;
        // this.w9SectionNext();
        this.documentPreview(this.w9FileDocUrl, res.result, 'W9 Form');
        this.w9FormfileInput.nativeElement.value = '';
      });
    }
  }

  oncitizenshipCategoryClick(event: any) {
    const uscisOrANumber = this.companyProfileI9Form.get('uscisOrANumber');
    const noncitizenNumber = this.companyProfileI9Form.get('noncitizenNumber');

    const uscisANumber = this.companyProfileI9Form.get('uscisANumber');
    const i94AdminNumber = this.companyProfileI9Form.get('i94AdminNumber');
    const fpn = this.companyProfileI9Form.get('fpn');

    if (event.value == 'lawful permanent resident') {
      this.isidentifiers = false;
      this.isUSCIS = true;
      noncitizenNumber.setValue(null);
      uscisOrANumber.setValidators([Validators.required]);
      noncitizenNumber.clearValidators();

      // disable identifiers fields
      this.isUSCISANumber = false;
      this.isI94AdminNumber = false;
      this.isfpn = false;
      uscisANumber.clearValidators();
      i94AdminNumber.clearValidators();
      fpn.clearValidators();
    }
    else if (event.value == 'noncitizen authorized to work') {
      this.isidentifiers = true;
      this.isUSCIS = false;
      uscisOrANumber.setValue(null);
      noncitizenNumber.setValidators([Validators.required]);
      uscisOrANumber.clearValidators();
    }
    else {
      this.isidentifiers = false;
      this.isUSCIS = false;
      uscisOrANumber.setValue(null);
      uscisOrANumber.clearValidators();
      noncitizenNumber.setValue(null);
      noncitizenNumber.clearValidators();

      // disable identifiers fields
      this.isUSCISANumber = false;
      this.isI94AdminNumber = false;
      this.isfpn = false;
      uscisANumber.clearValidators();
      i94AdminNumber.clearValidators();
      fpn.clearValidators();
    }
    uscisOrANumber.updateValueAndValidity();
    noncitizenNumber.updateValueAndValidity();

    uscisANumber.updateValueAndValidity();
    i94AdminNumber.updateValueAndValidity();
    fpn.updateValueAndValidity();
  }

  onIdentifiersCategoryClick(event: any) {
    const uscisANumber = this.companyProfileI9Form.get('uscisANumber');
    const i94AdminNumber = this.companyProfileI9Form.get('i94AdminNumber');
    const fpn = this.companyProfileI9Form.get('fpn');
    //const noncitizenNumber = this.companyProfileI9Form.get('noncitizenNumber');
    if (event.value == 'USCIS') {
      this.isUSCISANumber = true;
      this.isI94AdminNumber = false;
      this.isfpn = false;
      uscisANumber.setValidators([Validators.required]);
      i94AdminNumber.setValue(null);
      i94AdminNumber.clearValidators();
      fpn.setValue(null);
      fpn.clearValidators();
    }
    else if (event.value == 'I94') {
      this.isUSCISANumber = false;
      this.isI94AdminNumber = true;
      this.isfpn = false;
      i94AdminNumber.setValidators([Validators.required]);
      uscisANumber.setValue(null);
      uscisANumber.clearValidators();
      fpn.setValue(null);
      fpn.clearValidators();
    }
    else if (event.value == 'Passport and Issuance') {
      this.isUSCISANumber = false;
      this.isI94AdminNumber = false;
      this.isfpn = true;
      fpn.setValidators([Validators.required]);
      uscisANumber.setValue(null);
      uscisANumber.clearValidators();
      i94AdminNumber.setValue(null);
      i94AdminNumber.clearValidators();
    }
    uscisANumber.updateValueAndValidity();
    i94AdminNumber.updateValueAndValidity();
    fpn.updateValueAndValidity();
  }

  OnI9ConfirmationCheckBoxChange(value) {
    this.onI9Confirmation = value.checked;
  }

  async i9SubmitForPrev({ value }: { value: any }) {
    value = this.companyProfileI9Form.value;
    this.setI9NewValue(value);
    this.loadingUploadButton = true;
    //const value = this.companyProfileDDForm.value;
    const existingPdfBytes = await fetch('../../../../assets/pdf/I9_Form.pdf').then(res => res.arrayBuffer());
    const pdfDoc = await PDFDocument.load(existingPdfBytes);

    const pages = pdfDoc.getPages();
    const firstPage = pages[0];
    pdfDoc.registerFontkit(fontkit);
    // Load a font
    const font = await pdfDoc.embedFont(StandardFonts.Helvetica);
    // Load custom Cedarville Cursive font
    const cedarvilleBytes = await fetch('../../../../assets/fonts/Cedarville-Cursive.ttf')
      .then(res => res.arrayBuffer());
    const cedarvilleFont = await pdfDoc.embedFont(cedarvilleBytes);

    // Draw text at desired coordinates (x, y from bottom-left)
    firstPage.drawText(value.lastName, {
      x: 45,
      y: 608,
      size: 10,
      font,
      color: rgb(0, 0, 0),
    });

    firstPage.drawText(value.firstName, {
      x: 207,
      y: 608,
      size: 10,
      font,
      color: rgb(0, 0, 0),
    });

    firstPage.drawText(value.middleName ? value.middleName : "", {
      x: 350,
      y: 608,
      size: 10,
      font,
      color: rgb(0, 0, 0),
    });

    firstPage.drawText(value.otherLastName ? value.otherLastName : "", {
      x: 422,
      y: 608,
      size: 10,
      font,
      color: rgb(0, 0, 0),
    });

    firstPage.drawText(value.address ? value.address : "", {
      x: 45,
      y: 585,
      size: 10,
      font,
      color: rgb(0, 0, 0),
    });

    firstPage.drawText(value.aptNumber ? value.aptNumber : "", {
      x: 235,
      y: 585,
      size: 10,
      font,
      color: rgb(0, 0, 0),
    });

    firstPage.drawText(value.cityOrTown, {
      x: 310,
      y: 585,
      size: 10,
      font,
      color: rgb(0, 0, 0),
    });

    firstPage.drawText(value.state, {
      x: 462,
      y: 585,
      size: 10,
      font,
      color: rgb(0, 0, 0),
    });

    firstPage.drawText(value.zip, {
      x: 510,
      y: 585,
      size: 10,
      font,
      color: rgb(0, 0, 0),
    });

    firstPage.drawText(value.dob ? `${value.dob.slice(0, 2)}/${value.dob.slice(2, 4)}/${value.dob.slice(4, 8)}` : "", {
      x: 45,
      y: 557,
      size: 10,
      font,
      color: rgb(0, 0, 0),
    });

    // SSN Start
    const ssnDigits = value.ssn.split('');
    // Starting x/y positions for the first box
    let x = 151; // change based on box position
    let y = 556;
    const digitSpacing = 12; // adjust spacing to align with each box

    // Draw each digit separately
    for (let i = 0; i < ssnDigits.length; i++) {
      const digit = ssnDigits[i];

      firstPage.drawText(digit, {
        x,
        y,
        size: 12,
        font,
        color: rgb(0, 0, 0),
      });

      x += digitSpacing;

      // Extra space after 3rd and 5th digit (after first and second block)
      // if (i === 2 || i === 4) {
      //   x += 15; // adjust spacing between the SSN blocks
      // }
    }

    firstPage.drawText(value.emailId ? value.emailId : "", {
      x: 270,
      y: 557,
      size: 10,
      font,
      color: rgb(0, 0, 0),
    });

    firstPage.drawText(value.telePhoneNo.toString() ? value.telePhoneNo.toString() : "", {
      x: 460,
      y: 557,
      size: 10,
      font,
      color: rgb(0, 0, 0),
    });

    if (value.citizenshipOrImmigration == 'citizen of US') {
      firstPage.drawText('X', {
        x: 184.5,
        y: 524,
        size: 8,
        font,
        color: rgb(0, 0, 0),
      });
    }
    else if (value.citizenshipOrImmigration == 'noncitizen of US') {
      firstPage.drawText('X', {
        x: 184,
        y: 513,
        size: 8,
        font,
        color: rgb(0, 0, 0),
      });
    }
    else if (value.citizenshipOrImmigration == 'lawful permanent resident') {
      firstPage.drawText('X', {
        x: 184,
        y: 501,
        size: 8,
        font,
        color: rgb(0, 0, 0),
      });

      firstPage.drawText(value.uscisOrANumber ? value.uscisOrANumber : "", {
        x: 394,
        y: 501,
        size: 8,
        font,
        color: rgb(0, 0, 0),
      });
    }
    else if (value.citizenshipOrImmigration == 'noncitizen authorized to work') {
      firstPage.drawText('X', {
        x: 184,
        y: 489,
        size: 8,
        font,
        color: rgb(0, 0, 0),
      });

      firstPage.drawText(value.expDate ? `${value.expDate.slice(0, 2)}/${value.expDate.slice(2, 4)}/${value.expDate.slice(4, 8)}` : "", {
        x: 520,
        y: 488,
        size: 10,
        font,
        color: rgb(0, 0, 0),
      });

      firstPage.drawText(value.uscisANumber ? value.uscisANumber : "", {
        x: 184,
        y: 446,
        size: 10,
        font,
        color: rgb(0, 0, 0),
      });
      firstPage.drawText(value.i94AdminNumber ? value.i94AdminNumber : "", {
        x: 280,
        y: 446,
        size: 10,
        font,
        color: rgb(0, 0, 0),
      });
      firstPage.drawText(value.fpn ? value.fpn : "", {
        x: 398,
        y: 446,
        size: 10,
        font,
        color: rgb(0, 0, 0),
      });
    }

    firstPage.drawText(value.signature, {
      x: 115,
      y: 428,
      size: 18,
      font: cedarvilleFont,
      color: rgb(0, 0, 0),
    });

    firstPage.drawText(value.date, {
      x: 372,
      y: 425,
      size: 10,
      font,
      color: rgb(0, 0, 0),
    });

    const pdfBytes = await pdfDoc.save();

    const blob = new Blob([pdfBytes], { type: 'application/pdf' });
    //saveAs(blob, 'Filled-I9.pdf');
    const file = new File([blob], "Filled-I9.pdf", { type: "application/pdf" });
    if (file) {
      this.uploadedI9File = file;
      this.documentTypeOnFileUpload = 'I9';
      this.vendoronboardingService.InsertTempVendorDocuments(this.documentTypeOnFileUpload, this.uploadedI9File, this.emailLinkRefId).subscribe((res) => {
        if (res != undefined) {
          this.i9FormUploadedPath = res.result;
        }
        //this.messageService.add({ severity: 'success', summary: 'Confirmed', detail: 'I9 successfully uploaded' });
        // this.i9FormUploadedPath = res;
        //this.splittedI9formUploadedPath = this.i9FormUploadedPath.split("/");
        //res = res.substring(1);
        this.i9FileDocUrl = VMSConstants.vendorOnboardingDocumentBaseUrl + this.emailLinkRefId +'/' + res.result;
        this.showI9FormFilePreview = false;
        //this.hasI9Completed = true;
        this.hasI9PrivewCompleted = true;
        this.loadingUploadButton = false;
        // this.i9SectionNext();
        this.documentPreview(this.i9FileDocUrl, res.result, 'I9 Form');
        this.i9FormfileInput.nativeElement.value = '';
      });
    }
  }

  documentPreview(url: string, fileName: string, title: string) {
    const ref = this.dialogService.open(DocViewerDialogComponent, {
      data: {
        fileUrl: url,
        title: title,
        fileName: fileName,
      },
      width: '90%',
      height: '100%',
      baseZIndex: 10000,
      showHeader: false,
    });
  }

  i9SectionSave() {
    let value = this.companyProfileI9Form.getRawValue();
    if (this.i9OldLastName !== value.lastName || this.i9OldFirstName !== value.firstName || this.i9OldMiddleName !== value.middleName ||
      this.i9OldOtherLastName !== value.otherLastName || this.i9OldAddress !== value.address || this.i9OldAptNumber !== value.aptNumber ||
      this.i9OldCityOrTown !== value.cityOrTown || this.i9OldState !== value.state || this.i9OldZip !== value.zip || this.i9OldDob !== value.dob ||
      this.i9OldSsn !== value.ssn || this.i9OldEmailId !== value.emailId || this.i9OldTelePhoneNo !== value.telePhoneNo ||
      this.i9OldCitizenshipOrImmigration !== value.citizenshipOrImmigration || this.i9OldUscisOrANumber !== value.uscisOrANumber ||
      this.i9OldNoncitizenNumber !== value.noncitizenNumber || this.i9OldExpDate !== value.expDate || this.i9OldUscisANumber !== value.uscisANumber ||
      this.i9OldI94AdminNumber !== value.i94AdminNumber || this.i9OldFpn !== value.fpn || this.i9OldSignature !== value.signature ||
      this.i9OldI9ConfirmationCheckbox !== value.i9ConfirmationCheckbox
    ) {
      this.messageService.add({ severity: 'warn', summary: 'Warning', detail: 'One or more fields have been modified. Please preview the template again before saving.' })
      this.hasI9Completed = false;
      this.hasI9PrivewCompleted = false;
      return;
    }

    this.confirmationService.confirm({
      header: 'I-9 Confirmation - Please confirm your Information.',
      message: 'Please verify the information before submitting the I-9, as changes cannot be made once submitted. Would you like to proceed with the submission?',
      icon: 'pi pi-exclamation-triangle required-field',
      accept: () => {
        this.hasI9Completed = true;
        this.messageService.add({severity: 'success', summary: 'Confirmed', detail: 'Details have been added successfully'});
        this.tabIndex =this.tabIndex + 1;
      }, reject: () => {
        this.signFormNCA.patchValue({ ncaConfirmationCheckbox: false });
        this.hasI9Completed = false;
        this.hasI9PrivewCompleted = false;
        this.onI9Confirmation = false;
        this.companyProfileI9Form.controls['i9ConfirmationCheckbox'].setValue(false);
      }
    });
  }

  setDDNewValue(value:any){
    this.ddOldCompanyName = value.companyName;
    this.ddOldAddress = value.address;
    this.ddOldBankName = value.bankName;
    this.ddOldAccountType = value.accountType;
    this.ddOldRoutingNumber = value.routingNumber;
    this.ddOldAccountNumber = value.accountNumber;
    this.ddOldSignature = value.signature;
    this.ddOldConfirmationCheckbox == value.ddConfirmationCheckbox;
  }


  setW9NewValue(value: any) {
    this.w9OldName = value.name;
    this.w9OldBusinessName = value.businessName;
    this.w9OldFederalTaxClassi = value.federalTaxClassi;
    this.w9OldLlcTax = value.llcTax;
    this.w9OldOthers = value.others;
    this.w9OldAddress = value.address;
    this.w9OldCityZipState = value.cityZipState;
    this.w9OldListAccNumber = value.listAccNumber;
    this.w9OldReqNameAddress = value.reqNameAddress;
    this.w9OldExemptPayeeCode = value.exemptPayeeCode;
    this.w9OldExemptFATCA = value.exemptFATCA;
    this.w9OldTypeofTNS = value.typeofTNS;
    this.w9OldSsn = value.ssn;
    this.w9OldEin = value.ein;
    this.w9OldSignature = value.signature;
    this.w9OldW9ConfirmationCheckbox = value.w9ConfirmationCheckbox;

  }


  setI9NewValue(value: any) {
    this.i9OldLastName = value.lastName;
    this.i9OldFirstName = value.firstName;
    this.i9OldMiddleName = value.middleName;
    this.i9OldOtherLastName = value.otherLastName;
    this.i9OldAddress = value.address;
    this.i9OldAptNumber = value.aptNumber;
    this.i9OldCityOrTown = value.cityOrTown;
    this.i9OldState = value.state;
    this.i9OldZip = value.zip;
    this.i9OldDob = value.dob;
    this.i9OldSsn = value.ssn;
    this.i9OldEmailId = value.emailId;
    this.i9OldTelePhoneNo = value.telePhoneNo;
    this.i9OldCitizenshipOrImmigration = value.citizenshipOrImmigration;
    this.i9OldUscisOrANumber = value.uscisOrANumber;
    this.i9OldNoncitizenNumber = value.noncitizenNumber;
    this.i9OldExpDate = value.expDate;
    this.i9OldUscisANumber = value.uscisANumber;
    this.i9OldI94AdminNumber = value.i94AdminNumber;
    this.i9OldFpn = value.fpn;
    this.i9OldSignature = value.signature;
    this.i9OldI9ConfirmationCheckbox = value.i9ConfirmationCheckbox;
  }

  onPaste(event: ClipboardEvent) {
  event.preventDefault();
  let pasted = event.clipboardData?.getData('text') ?? '';
  pasted = pasted.replace(/[^0-9]/g, ''); // keep only digits
  //pasted = pasted.replace(/[^0-9x]/g, ''); // keep only digits and x
  const input = event.target as HTMLInputElement;
  input.value = pasted;
  input.dispatchEvent(new Event('input')); // update FormControl
}
scrollToTop(position:number) {
  this.viewportScroller.scrollToPosition([0, position]);
}

}
